/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 16:41:54
 * @LastEditTime: 2019-12-19 10:53:49
 * @LastEditTime: 2019-09-09 11:43:43
 * @LastEditors: Please set LastEditors
 */

export default {
  v5: {
    select_files_to_upload: 'Select files to upload',
    my_video_shorts: 'ΤΑ ΒΙΝΤΕΟ SHORTS ΜΟΥ',
    see_more: 'ΔΕΙΤΕ ΠΕΡΙΣΣΟΤΕΡΑ',
    no_shorts_found: 'Δεν βρέθηκαν shorts',
    shorts: 'Shorts',
    general_information: 'Γενικές πληροφορίες',
    gamification: 'Gamification',
    click_to_select_files: 'Κάντε κλικ για να επιλέξετε αρχεία',
    selected_files: 'Επιλεγμένα αρχεία',
    uploaded: 'Μεταφορτώθηκε',
    failed: 'Απέτυχε',
    system_will_automatically_analyze_and_select_the_most_relevant:
      'Το σύστημα θα αναλύσει αυτόματα και θα επιλέξει τα πιο σχετικά έγγραφα από τη βιβλιοθήκη της οργάνωσής σας βάσει των απαιτήσεων περιεχομένου.',
    select_from_library: ' Επιλέξτε από τη βιβλιοθήκη',
    search_document: 'Αναζήτηση εγγράφων...',
    selected: 'Επιλεγμένο',
    loading_documents: 'Φόρτωση εγγράφων...',
    review_generated_content: 'Ανασκόπηση δημιουργημένου περιεχομένου',
    confirm_and_replace_content: 'Επιβεβαίωση και αντικατάσταση περιεχομένου',
    the_generate_content_will_replace:
      'Το δημιουργημένο περιεχόμενο θα αντικαταστήσει το υπάρχον κείμενο στις επιλεγμένες σελίδες. Εάν δεν θέλετε να εφαρμόσετε αυτές τις αλλαγές, μπορείτε να επιστρέψετε στο προηγούμενο βήμα.',
    pages_to_be_updated: 'Σελίδες προς ενημέρωση',
    generated_revisions: 'Δημιουργημένες αναθεωρήσεις',
    lesson_preview: 'Προεπισκόπηση μαθήματος',
    create_new_folder: 'Δημιουργία νέου φακέλου',
    rename_item: 'Μετονομασία στοιχείου',
    enter_folder_name: 'Εισάγετε όνομα φακέλου:',
    enter_new_name: 'Εισάγετε νέο όνομα:',
    folder_name: 'Όνομα φακέλου:',
    new_name: 'Νέο όνομα',
    move_items: 'Μετακίνηση στοιχείων',
    copy_items: 'Αντιγραφή στοιχείων',
    move_here: 'Μετακίνηση εδώ',
    copy_here: 'Αντιγραφή εδώ',
    select_destination_library_and_folder:
      'Επιλέξτε βιβλιοθήκη και φάκελο προορισμού:',
    items_selected: 'Επιλεγμένα στοιχεία',
    version: 'Έκδοση',
    modified_by: 'Τροποποιήθηκε από',
    size: 'Μέγεθος',
    restore: 'Επαναφορά',
    are_you_sure_you_want_to_restore_this_version:
      'Είστε σίγουροι ότι θέλετε να επαναφέρετε αυτή την έκδοση;',
    this_will_replce_the_current_version_with_the_selected_one:
      'Αυτό θα αντικαταστήσει την τρέχουσα έκδοση με την επιλεγμένη.',
    restore_this_version: 'Επαναφορά αυτής της έκδοσης',
    restore_not_available: 'Η επαναφορά δεν είναι διαθέσιμη',
    version_history: 'Ιστορικό εκδόσεων:',
    by_making_items_public:
      'Κάνοντας τα στοιχεία δημόσια, θα είναι ορατά σε όλους. Παρακαλώ διαβάστε τους όρους και προϋποθέσεις πριν συνεχίσετε.',
    the_selected_items_will_be_copied:
      'Τα επιλεγμένα στοιχεία θα αντιγραφούν στη δημόσια βιβλιοθήκη σας και θα είναι ορατά σε όλους.',
    the_selected_items_will_be_copied_to_org:
      'Τα επιλεγμένα στοιχεία θα αντιγραφούν στη βιβλιοθήκη της οργάνωσής σας και θα είναι ορατά σε όλα τα μέλη της οργάνωσης.',
    the_selected_items_will_be_copied_to_your_private:
      'Τα επιλεγμένα στοιχεία θα αντιγραφούν στην προσωπική σας βιβλιοθήκη και θα είναι ορατά μόνο σε εσάς.',
    loading_organization: 'Φόρτωση χρηστών οργάνωσης...',
    click_download_to_view: 'Κάντε κλικ στο Λήψη για να δείτε',
    archive_file: 'Αρχείο αρχειοθέτησης',
    no_preview_available: 'Δεν υπάρχει διαθέσιμη προεπισκόπηση',
    audit_report: 'Αναφορά ελέγχου',
    audit_type: 'Τύπος ενέργειας',
    i_agree_to_the_terms_and_conditions:
      'Συμφωνώ με τους όρους και τις προϋποθέσεις.',
    this_file_is_indexed_for_ai: 'Αυτό το αρχείο έχει ευρετηριαστεί για AI.',
    file_is_not_indexed_for_ai: 'Το αρχείο δεν έχει ευρετηριαστεί για AI.',
    no_users_found: 'Δεν βρέθηκαν χρήστες',
    no_users_available: 'Δεν υπάρχουν διαθέσιμοι χρήστες',
    add_people: 'Προσθήκη ατόμων',
    people: 'Άτομα',
    access_type: 'Τύπος πρόσβασης',
    no_group_found: 'Δεν βρέθηκαν ομάδες',
    add_group: 'Προσθήκη ομάδας',
    groups: 'Ομάδες',
    users_top: 'Χρήστες',
    confirm_delete: 'Επιβεβαίωση διαγραφής',
    do_you_want_remove: 'Είστε βέβαιοι ότι θέλετε να αφαιρέσετε',
    form_this_documents_permissions: 'από τα δικαιώματα αυτού του εγγράφου;',
    no_users_found_in_this_group: 'Δεν βρέθηκαν χρήστες σε αυτήν την ομάδα',
    add_selected_users: 'Προσθήκη επιλεγμένων χρηστών',
    choose_users_from_the_list: 'Επιλέξτε χρήστες από τη λίστα',
    selected_users: 'Επιλεγμένοι χρήστες',
    archived: 'Αρχειοθετημένο',
    request_approval: 'Αίτηση έγκρισης',
    document_in_review: 'Έγγραφο υπό αναθεώρηση',
    approve: 'Έγκριση',
    reject: 'Απόρριψη',
    comment: 'Σχόλιο:',
    enter_your_commit: 'Εισάγετε το σχόλιό σας...',
    confirm_cancel: 'Επιβεβαίωση ακύρωσης',
    upload_3d_zip: 'Μεταφόρτωση 3D Zip',
    delete_items: 'Διαγραφή στοιχείων',
    video_upload_request: 'Αίτημα μεταφόρτωσης βίντεο',
    reject_video: 'Απόρριψη βίντεο',
    enter_rejection_reason: 'Εισάγετε λόγο απόρριψης...',
    please_provide_a_reason_for_reejection_this_video:
      'Παρακαλώ δώστε λόγο για την απόρριψη αυτού του βίντεο:',
    generate_trivia_with_ai: 'Δημιουργία quiz με AI',
    select_category: 'Επιλέξτε κατηγορία:',
    number_of_question: 'Αριθμός ερωτήσεων',
    generated_questions: 'Δημιουργημένες ερωτήσεις',
    this_will_clear_all_generate_question:
      'Αυτό θα διαγράψει όλες τις δημιουργημένες ερωτήσεις. Συνεχίζετε;',
    sure_delete: 'Είστε σίγουροι ότι θέλετε να διαγράψετε;',
    delete_this_question:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή την ερώτηση;',
    loading_quiz: 'Φόρτωση quiz...',
    creteing_file: 'Δημιουργία αρχείου',
    opening_desktop_app: 'Άνοιγμα εφαρμογής επιτραπέζιου υπολογιστή',
    this_folder_is_empty: 'Αυτός ο φάκελος είναι κενός',
    select_a_competition: 'Επιλέξτε έναν διαγωνισμό...',
    activity_badges: 'Σήματα δραστηριότητας',
    awarded_every_badges:
      'Απονέμεται κάθε 4, 8, 16, 32, 64, 128, 256, 512 συνδέσεις',
    learning_badges: 'Σήματα μάθησης',
    awarded_every_courses:
      'Απονέμεται κάθε 1, 4, 8, 16, 32, 64, 128 ολοκληρωμένα μαθήματα',
    test_badges: 'Σήματα δοκιμών',
    awarded_every_passes_tests:
      'Απονέμεται κάθε 2, 4, 8, 16, 32, 64, 128, 256 επιτυχημένα τεστ',
    assignment_badges: 'Σήματα εργασιών',
    awarded_every_passed_assignments:
      'Απονέμεται κάθε 1, 2, 4, 8, 16, 32, 64, 128 επιτυχημένες εργασίες',
    perfectionism_badges: 'Σήματα τελειομανίας',
    awarded_every_assignments_with_scrore:
      'Απονέμεται για κάθε τεστ ή εργασία με σκορ 90%+',
    communication_badges: 'Σήματα επικοινωνίας',
    awarded_every_topics_or_comments:
      'Απονέμεται κάθε 2, 4, 8, 16, 32, 64, 128, 256 θέματα ή σχόλια',
    certification_badges: 'Σήματα πιστοποίησης',
    awarded_every_certificates:
      'Απονέμεται κάθε 1, 2, 4, 8, 16, 32, 64, 128 πιστοποιητικά',
    level_name: 'Όνομα επιπέδου',
    delete_competition: 'Διαγραφή διαγωνισμού',
    this_week: 'Αυτή την εβδομάδα',
    this_year: 'Αυτό το έτος',
    make_organization: 'Κάντε οργανισμό',
    no_results_found: 'Δεν βρέθηκαν αποτελέσματα για',
    no_items_available: 'Δεν υπάρχουν διαθέσιμα στοιχεία',
    help_video: 'Βοηθητικά βίντεο',
    select_a_video_from_the_list:
      'Επιλέξτε ένα βίντεο από τη λίστα για να ξεκινήσετε τη μάθηση'
  },
  v4: {
    upload_another_file: 'Upload another file',
    all_files_uploaded: 'All files uploaded',
    upload_and_submit: 'Upload & Submit',
    drop_files: 'Αποθέστε το αρχείο και επιλέξτε πού να το ανεβάσετε.',
    duplicate_lessoon: 'Το μάθημα υπάρχει ήδη στο μάθημα',
    skill_rule_title: 'Παρακαλώ εισάγετε τίτλο δεξιότητας ταξιδιού',
    imageCreatorTitle: 'Δημιουργός Εικόνας',
    isTranslated: 'Μεταφρασμένο',
    translationCourseDesc:
      'Η μετάφραση αυτού του μαθήματος μπορεί να πάρει μερικά λεπτά. Ευχαριστούμε για την υπομονή σας!',
    translateCourseTip:
      'Δημιουργήστε ένα μεταφρασμένο μάθημα που μπορείτε να τροποποιήσετε ανεξάρτητα από το αρχικό, συμπεριλαμβανομένων όλων των μαθημάτων και σελίδων.',
    translateModalBtn: 'Μετάφραση',
    translationSuccess: 'Το μάθημα "<0/>" μεταφράστηκε με επιτυχία!',
    translatingCourse: 'Μετάφραση μαθήματος...',
    translateModalTitle: 'Μετάφραση μαθήματος',
    translateSelectLang: 'Επιλέξτε γλώσσα',
    fileDeleteconfirm:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο; Δεν μπορεί να αναιρεθεί.',
    fileDeleteMessage: 'Το αρχείο διαγράφηκε με επιτυχία.',
    fileDeleteFailedMessage: 'Η διαγραφή του αρχείου απέτυχε!',
    fileDelete: 'Διαγράψτε αυτό το αρχείο.',
    certificate_save_btn: 'Προσθήκη Πιστοποιητικού στο ',
    maze_path_info: 'Δεν υπάρχουν διαθέτες διαδρομές για το γράφημα!',
    file_size_mb: 'Το μέγεθος αρχείου πρέπει να είναι μικρότερο από 25 MB!',
    reports: {
      products: 'Προϊόντα',
      users: 'Χρήστες',
      ph_username: 'Αναζήτηση χρήστη με όνομα χρήστη',
      ph_id: 'Αναζήτηση χρήστη με αριθμό ID χρήστη',
      ph_email: 'Αναζήτηση χρήστη με email χρήστη'
    },
    select_upload_section_id: 'Απαιτείται ενότητα αρχείου',
    tags_all: 'Όλα',
    delete_file_confirm:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο;',
    delete_file_title: 'Διαγραφή Αρχείου',
    tooltip_publish: 'Δημοσίευση μαθήματος στην επιλεγμένη επιλογή',
    tooltip_save: 'Αποθήκευση μαθήματος με τις τρέχουσες ενημερώσεις',
    tooltip_next: 'Μετάβαση στην επόμενη ρύθμιση μαθήματος',
    tooltip_finish: 'Ολοκλήρωση και αποθήκευση των τρεχουσών ενημερώσεων',
    stories_modal: {
      title_upload: 'Ανέβασμα Ιστοριών',
      title_update: 'Ενημέρωση Ιστοριών',
      title_audio: 'Αρχείο Ηχητικής Ιστορίας',
      btn_upload: 'Ανέβασμα',
      btn_update: 'Ενημέρωση',
      btn_close: 'Κλείσιμο',
      btn_cancel: 'Ακύρωση',
      lbl_cover: 'Εξώφυλλο Ηχητικής Ιστορίας',
      rule_cover: 'Παρακαλώ ανεβάστε εξώφυλλο ηχητικής ιστορίας!',
      lbl_title: 'Τίτλος Ηχητικής Ιστορίας',
      rule_title: 'Παρακαλώ εισάγετε τον τίτλο της ηχητικής ιστορίας!',
      lbl_description: 'Περιγραφή Ηχητικής Ιστορίας',
      rule_description:
        'Παρακαλώ εισάγετε την περιγραφή της ηχητικής ιστορίας!',
      lbl_file: 'Ανέβασμα αρχείου ηχητικής ιστορίας',
      rule_file: 'Παρακαλώ ανεβάστε αρχείο ηχητικής ιστορίας!',
      rule_file_type: 'Παρακαλώ ανεβάστε έγκυρο αρχείο ηχητικής ιστορίας!',
      lbl_select_file: 'Επιλέξτε αρχείο ηχητικής ιστορίας',
      msg_valid_file: 'Παρακαλώ επιλέξτε έγκυρο αρχείο ηχητικής ιστορίας!',
      msg_success: 'Το αρχείο ηχητικής ιστορίας ανέβηκε με επιτυχία',
      msg_failed: 'Αποτυχία ανάθεσης δεδομένων πολυμέσων!',
      msg_error: 'Σφάλμα κατά το ανέβασμα αρχείου!'
    },
    audio_modal: {
      title_upload: 'Ανέβασμα',
      title_update: 'Ενημέρωση',
      title_audio: 'Αρχείο Ήχου',
      btn_upload: 'Ανέβασμα',
      btn_update: 'Ενημέρωση',
      btn_close: 'Κλείσιμο',
      btn_cancel: 'Ακύρωση',
      lbl_cover: 'Εξώφυλλο Ήχου',
      rule_cover: 'Παρακαλώ ανεβάστε εξώφυλλο ήχου!',
      lbl_title: 'Τίτλος Ήχου',
      rule_title: 'Παρακαλώ εισάγετε τον τίτλο του ήχου!',
      lbl_description: 'Περιγραφή Ήχου',
      rule_description: 'Παρακαλώ εισάγετε περιγραφή ήχου!',
      lbl_file: 'Ανέβασμα αρχείου ήχου',
      rule_file: 'Παρακαλώ ανεβάστε αρχείο ήχου!',
      rule_file_type: 'Παρακαλώ ανεβάστε έγκυρο αρχείο ήχου!',
      lbl_select_file: 'Επιλέξτε αρχείο ήχου',
      msg_valid_file: 'Παρακαλώ επιλέξτε έγκυρο αρχείο ήχου!',
      msg_success: 'Το αρχείο ήχου ανέβηκε με επιτυχία',
      msg_failed: 'Αποτυχία ανάθεσης δεδομένων πολυμέσων!',
      msg_error: 'Σφάλμα κατά το ανέβασμα αρχείου!'
    },
    info_episode: 'Μια εικόνα εξωφύλλου για το επεισόδιο.',
    btn_delete_episode: 'Διαγραφή αυτού του επεισοδίου podcast.',
    btn_edit_marketplace: 'Επεξεργασία λεπτομερειών αγοράς.',
    btn_save_marketplace: 'Αποθήκευση των τρεχουσών αλλαγών.',
    btn_ai_podcast: 'Δημιουργία επεισοδίου podcast με AI.',
    btn_upload_podcast: 'Ανέβασμα δικού σας ηχητικού επεισοδίου podcast.',
    attach_file:
      'Ανεβάστε αρχεία για να μοιραστείτε περισσότερο περιεχόμενο με το κοινό σας',
    fileDownload: 'Κατεβάστε αυτό το αρχείο.',
    singleEpishode: 'Επεισόδιο',
    podcast_music: 'podcast, μουσική & ιστορίες',
    publishHeader: 'Δημοσίευση Podcasts, Μουσικής & Ιστοριών',
    editHeader: 'Επεξεργασία Podcasts, Μουσικής & Ιστοριών',
    createHeader: 'Δημιουργία Podcasts, Μουσικής & Ιστοριών',
    marketplaceHeader: 'Λεπτομέρειες Αγοράς Podcasts, Μουσικής & Ιστοριών',
    message_marketplace: 'Παρακαλώ συμπληρώστε τη φόρμα αγοράς!',
    create_podcast_live: 'Ζωντανό Podcast και Μουσική',
    create_podcast_custom: 'Προσαρμοσμένο Podcast και Μουσική',
    create_podcast_stories: 'Ιστορία',
    ai_Assisted_podcast_reation: 'Podcast και Μουσική με Βοήθεια AI',
    publishTitle:
      'Δημοσιεύστε podcast, μουσική & ιστορίες για δημόσια προβολή.',
    customButton: 'Δημιουργία Προσαρμοσμένου',
    customTitle: 'Αποθηκεύει τις αλλαγές που έγιναν στο podcast.',
    updateButton: 'Ενημέρωση',
    createButton: 'Δημιουργία',
    createNewButton: 'Δημιουργία Νέου',
    updateTitle:
      'Ενημέρωση τρεχόντων λεπτομερειών podcast, μουσικής & ιστοριών.',
    createTitle: 'Δημιουργία νέου podcast, μουσικής & ιστοριών',
    createNewTitle:
      'Νέο podcast, μουσική & ιστορίες θα δημιουργηθούν στο τρέχον podcast, μουσική & ιστορίες με νέα στοιχεία εισόδου.',
    podcastTitle: 'Λίστα Επεισοδίων',
    podcastStoryTitle: 'Λίστα Επεισοδίων Ιστοριών',
    podcastToolTipTitle: 'Λίστα επεισοδίων podcast',
    uploadAudio: 'Ανέβασμα',
    aiAudio: 'AI Ήχος',
    emptyPodcast: 'Δεν υπάρχει ακόμα ηχογράφηση podcast, μουσικής & ιστοριών.',
    emptyStoriesPodcast: 'Δεν έχουν προστεθεί ιστορίες ακόμα.',
    emptyCreatePodcast: 'Παρακαλώ δημιουργήστε podcast για να προσθέσετε ήχο.',
    playPodcast: 'Αναπαραγωγή επιλεγμένου podcast, μουσικής & ιστοριών.',
    pausePodcast: 'Παύση επιλεγμένου podcast, μουσικής & ιστοριών.',
    selectPodcast: 'Επιλογή αυτού του podcast, μουσικής & ιστοριών.',
    downloadPodcast: 'Κατεβάστε αυτόν τον ήχο.',
    uploadAudioFile: 'Ανέβασμα νέου ήχου και αντικατάσταση του τρέχοντος ήχου.',
    deleteConfirm: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτόν τον ήχο;',
    roomName: 'Όνομα Podcast',
    addGuestTitle: 'ΠΡΟΣΘΗΚΗ ΟΜΙΛΗΤΗ',
    showTime: 'Ώρα Προβολής',
    startTime: 'Ώρα Έναρξης',
    endTime: 'Ώρα Λήξης',
    erorMsgImg: 'Παρακαλώ επιλέξτε έγκυρη εικόνα.',
    failedMsgImg: 'Αποτυχία φόρτωσης εικόνας. Παρακαλώ δοκιμάστε ξανά!',
    failedMsgUpload: 'Αποτυχία ανέβασματος εικόνας εξωφύλλου!',
    btnCoverUpload: 'Ανέβασμα Εξωφύλλου',
    is_private: 'Ιδιωτικό',
    to_attach: 'Επισύναψη Αρχείου',
    file_attached: 'Επισύναψη Αρχείου (αρχείων)',
    main_event: 'Κύριο Γεγονός',
    event: 'Γεγονότα',
    upload_pdf: 'Ανέβασμα PDF',
    portrait: 'Πορτραίτο',
    landscape: 'Οριζόντιο',
    import_from_library: 'Εισαγωγή Κειμένου από τη Βιβλιοθήκη Πολυμέσων',
    question_answer_ai: 'Ερώτηση/Απάντηση AI',
    take_maze: 'ΠΑΙΞΕ MetaMaze',
    training: 'Εκπαίδευση',
    select_transcribe_locale: 'Επιλέξτε Γλώσσα για Μεταγραφή',
    transcribe_limit: 'Παρακαλώ Εισάγετε Λεπτά Μεταγραφής',
    not_complete: 'Οι Πληροφορίες της Αγοράς Δεν Είναι Πλήρεις',
    complete: 'Οι Πληροφορίες της Αγοράς Είναι Πλήρεις',
    not_admin: 'Απαιτούνται Δικαιώματα Διαχειριστή για Δημοσίευση στην Αγορά',
    no_course:
      'Παρακαλώ Εισάγετε Τίτλο και Επιλέξτε Εικόνα για Ενεργοποίηση Αγοράς',
    scorm_not_complete:
      'Παρακαλώ Εισάγετε Τίτλο και Επιλέξτε Εικόνα για Ανέβασμα Αρχείου SCORM',
    not_found_maze: 'Δεν Βρέθηκε MetaMaze',
    email_require: 'Απαιτούνται Διευθύνσεις Email',
    poll_required: 'Απαιτούνται Δεδομένα Δημοσκόπησης',
    alert: 'Προειδοποίηση!',
    warning: 'Προειδοποίηση!',
    ok: 'Εντάξει',
    cancel: 'Ακύρωση',
    done: 'Ολοκληρώθηκε',
    insert: 'Εισαγωγή',
    private: 'Ιδιωτικό',
    public: 'Δημόσιο',
    no_connection: 'Χάθηκε η Σύνδεση στο Διαδίκτυο',
    switch: 'Εναλλαγή',
    share_screen: 'Κοινή Χρήση Οθόνης',
    stop_share_screen: 'Διακοπή Κοινής Χρήσης Οθόνης',
    share_screen_with_camera: 'Κοινή Χρήση Οθόνης με Κάμερα',
    stop_share_screen_with_camera: 'Διακοπή Κοινής Χρήσης Οθόνης με Κάμερα',
    camera_on: 'Κάμερα Ενεργή',
    camera_off: 'Κάμερα Απενεργοποιημένη',
    mic_on: 'Ενεργοποίηση Μικροφώνου',
    mic_off: 'Απενεργοποίηση Μικροφώνου',
    fullscreen: 'Πλήρης Οθόνη',
    live_now: 'Ζωντανά Τώρα',
    schedule_on: 'Προγραμματισμένο για',
    organisations: 'Οργανισμοί',
    org_groups: 'Ομάδες Οργανισμού',
    specific_user: 'Συγκεκριμένος Χρήστης',
    gif: 'GIF',
    unavailable: 'Μη Διαθέσιμο',
    yes: 'Ναι',
    no: 'Όχι',
    event_duration_message: 'Μέγιστο 300 λεπτά (5 ώρες)',
    send_email: 'Αποστολή Ειδοποίησης E-mail',
    admin_only: 'Μόνο για Διαχειριστές',
    join: 'Συμμετοχή',
    leave: 'Αποχώρηση',
    share: 'Κοινή Χρήση',
    share_text:
      'Παρακαλώ πληκτρολογήστε το email αυτού που θέλετε να μοιραστείτε αυτό το αρχείο.',
    share_text_title: 'Κοινοποίηση PDF',
    share_text_title_txt: 'Κοινοποίηση Κειμένου',
    select_users: 'Επιλογή Χρηστών',
    delete: 'Διαγραφή',
    attachment_event: 'Συνημμένα για το γεγονός:',
    transcribe_limit: 'Λεπτά Μεταγραφής',
    monthly_transcribe: 'Μηνιαίο Όριο Μεταγραφής:',
    enable_ai: 'Ενεργοποίηση AI:',
    enable_maze: 'Ενεργοποίηση MetaMaze:',
    media_service: 'Υπηρεσία Πολυμέσων',
    allow_others: 'Επιτρέψτε σε Άλλους να Επεξεργαστούν',
    join_breakout_room: 'Είσοδος σε Δωμάτιο Breakout',
    bio: 'Βιογραφικό',
    linkedin: 'LinkedIn',
    select_org_report:
      'Παρακαλώ βρείτε και επιλέξτε έναν οργανισμό για να δημιουργήσετε αναφορά.',
    org_image_not_found: 'Εικόνα Δεν Βρέθηκε',
    insert_text: 'Εισαγωγή Κειμένου',
    insert_question_answer: 'Ερώτηση/Απάντηση AI',
    modal_title2: 'Συλλογή Κειμένου',
    my_text_library: 'Η Βιβλιοθήκη Κειμένου Μου',
    ai: 'AI',
    public_text_library: 'Δημόσια Βιβλιοθήκη Κειμένου',
    organization_text_library: 'Βιβλιοθήκη Κειμένου Οργανισμού',
    no_transcribed_text: 'Δεν Βρέθηκε Κείμενο Μεταγραφής',
    public_text_not_found: 'Δεν Βρέθηκε Δημόσιο Μεταγραμμένο Κείμενο',
    org_text_not_found: 'Δεν Βρέφθηκε Μεταγραμμένο Κείμενο Οργανισμού',
    org_video_not_found: 'Βίντεο Δεν Βρέθηκε',
    canva: 'Κάντο από το Canva',
    canva_open: 'Κάντε κλικ εδώ για να ανοίξετε τον επεξεργαστή Canva.',
    pdf: 'PDF',
    txt: 'ΚΕΙΜΕΝΟ',
    human: 'Premium',
    shared_file: 'Το αρχείο σας έχει κοινοποιηθεί με επιτυχία.',
    error_shared_file:
      'Υπάρχει πρόβλημα με την κοινοποίηση του αρχείου. Παρακαλώ δοκιμάστε ξανά.',
    publish: 'Δημοσίευση',
    maze_scenes: 'Σκηνές MetaMaze',
    pexel_images: 'Εικόνες Pexel',
    group: 'Ομάδα',
    group_name: 'Όνομα Ομάδας',
    select_group: 'Επιλογή Ομάδας',
    search_maze: 'Αναζήτηση MetaMaze',
    hosts: 'Φιλοξενώντας',
    avg_score: 'Ποσοστό Βαθμολογίας',
    maze_report: 'Αναφορά MetaMaze',
    maze_view: 'Προβολή MetaMaze',
    title_maze: 'MetaMaze',
    author: 'Συγγραφέας',
    match: 'Ταίριασμα Διαδρομής',
    preview_mazeTitle: 'Τίτλος: ',
    other: 'Άλλο',
    total: 'ΣΥΝΟΛΙΚΟ',
    report_course: 'ΜΑΘΗΜΑ',
    report_courses: 'ΜΑΘΗΜΑΤΑ',
    report_event: 'ΕΚΔΗΛΩΣΗ',
    report_events: 'ΕΚΔΗΛΩΣΕΙΣ',
    report_maze: 'METAΜΑΖΕ',
    report_personalize_learning: 'ΕΞΑΤΟΜΙΚΕΥΜΕΝΗ ΜΑΘΗΣΗ',
    report_live_assessment: 'ΖΩΝΤΑΝΗ ΑΞΙΟΛΟΓΗΣΗ',
    report_live_assessments: 'ΖΩΝΤΑΝΕΣ ΑΞΙΟΛΟΓΗΣΕΙΣ',
    report_skill_journey: 'ΔΙΑΔΡΟΜΗ ΔΕΞΙΟΤΗΤΩΝ',
    skill_journey: 'Διαδρομή Δεξιοτήτων',
    skill_journeys: 'Διαδρομές Δεξιοτήτων',
    date: 'ΗΜΕΡΟΜΗΝΙΑ: ',
    search_people: 'Αναζήτηση Ατόμων',
    passed: 'ΠΕΡΑΣΕ',
    failed: 'ΑΠΟΤΥΧΙΑ',
    item: 'ΑΝΤΙΚΕΙΜΕΝΟ',
    type: 'ΤΥΠΟΣ',
    minimum_pass_score: 'ΕΛΑΧΙΣΤΗ ΒΑΘΜΟΛΟΓΙΑ ΠΕΡΑΣΜΑΤΟΣ',
    resources_count: 'ΑΡΙΘΜΟΣ ΠΟΡΩΝ',
    back: 'ΠΙΣΩ',
    resources: 'ΠΟΡΟΙ',
    time_spent: 'ΧΡΟΝΟΣ (ΛΕΠΤΑ)',
    detail: 'ΛΕΠΤΟΜΕΡΕΙΑ',
    watched_time_mins: 'ΧΡΟΝΟΣ ΠΡΟΒΟΛΗΣ (ΛΕΠΤΑ)',
    personalize_learning: 'Εξατομικευμένη Μάθηση',
    result: 'Αποτέλεσμα',
    assessment_title: 'Τίτλος',
    marketPlace_graph: 'Γράφημα Marketplace',
    attachments: 'Πρόσθετα Συνημμένα',
    new_scorm_course: 'Ανέβασμα Νέου Μαθήματος SCORM',
    upload_scorm_course: 'Ανέβασμα Μαθήματος SCORM',
    new_maze: 'Δημιουργία Νέου MetaMaze',
    new_skill_journey: 'Δημιουργία Διαδρομής Δεξιοτήτων',
    tags_scorm: 'SCORM',
    tags_skillJourney: 'Διαδρομή Δεξιοτήτων',
    new_discussion_room: 'Δημιουργία Νέου Podcast',
    title: 'Τι θέλετε να κάνετε σήμερα;',
    build_course: 'Δημιουργία Μαθήματος',
    live_broadcast: 'Ζωντανή Μετάδοση',
    invite_users: 'Πρόσκληση Χρηστών στον Οργανισμό μου',
    build_voice_over: 'Δημιουργία Φωνητικής Εγγραφής',
    view_reports: 'Προβολή Αναφορών',
    upload_media: 'Ανέβασμα Μέσων ή Εργασίας και Κοινοποίηση',
    main_menu: 'Κύριο Μενού',
    get_started: 'ΞΕΚΙΝΗΣΤΕ',
    search_group: 'Αναζήτηση Οργανωτικής Ομάδας',
    ai_course: 'Μάθημα Τεχνητής Νοημοσύνης',
    search_user: 'Αναζήτηση Ονόματος Εταιρείας',
    no_maze: 'Δεν υπάρχουν MetaMaze αυτή τη στιγμή.',
    conference_event_title: 'Συνέδρια',
    conference_event_subTitle: 'Ολοκληρωμένα Συνέδρια',
    conference_event: 'Δεν υπάρχουν συνέδρια αυτή τη στιγμή.',
    no_skill: 'Δεν υπάρχουν διαδρομές δεξιοτήτων.',
    no_podcast: 'Δεν υπάρχουν podcast.',
    maze_channel: 'MetaMaze',
    past_live_assessment: 'Προηγούμενες Ζωντανές Αξιολογήσεις',
    no_live_assessment: 'Δεν υπάρχουν ζωντανές αξιολογήσεις.',
    enrolled_courses: 'Μαθήματα',
    my_video_channel: 'Κανάλια Βίντεο μου',
    enrolled_liveEvents: 'Ζωντανές Εκδηλώσεις',
    sharebot: 'Sharebot',
    selected_language: 'Επιλεγμένη γλώσσα',
    shareSphere_game: 'Παιχνίδι ShareSphere',
    maze: 'MetaMaze',
    skill: 'Διαδρομή Δεξιοτήτων',
    channel: 'Κανάλι',
    order: 'Παραγγελία',
    is_record: 'Εγγραφή',
    no_maze_found: 'Δεν βρέθηκε MetaMaze.',
    maze_self_limit_reached: 'Έχετε φτάσει το όριο αυτοαξιολόγησης MetaMaze.',
    metamaze_two_times: 'Έχετε ήδη ολοκληρώσει αυτό το MetaMaze 2 φορές.',
    metamaze_two_times_no_result:
      'Έχετε ήδη ολοκληρώσει αυτό το MetaMaze 2 φορές. Το αποτέλεσμα σας δεν θα καταγραφεί μετά τη δεύτερη φορά.',
    scorm_zip: 'SCORM ZIP',
    pass_score: 'Ελάχιστη Βαθμολογία για Επιτυχία',
    organization: 'Παρακαλώ Επιλέξτε Οργανισμό',
    pass_score_mark: 'Εισάγετε βαθμολογία από 1 έως 100',
    maze_cloning_success: 'Το MetaMaze "<0/>" αντιγράφηκε επιτυχώς!',
    create_certificate: 'Δημιουργία Πιστοποιητικού',
    create_badge: 'Δημιουργία Σήματος',
    certificate_added: 'Πιστοποιητικό Προστέθηκε.',
    badge_added: 'Σήμα Προστέθηκε.',
    certificate_warning:
      'Δεν μπορείτε να επεξεργαστείτε το πιστοποιητικό/σήμα αφού δημοσιευτεί!',
    created_course_plan:
      'Επεξεργαστείτε και δημοσιεύστε το μάθημα και το πλάνο ζωντανών εκδηλώσεων που δημιουργήσατε',
    market_place_space: 'Αγορά',
    select_course_language: 'Επιλέξτε γλώσσα (Προαιρετικό)',
    select_language: 'Επιλέξτε γλώσσα',
    file_upload: 'Ανέβασμα αρχείου',
    text: 'Γράψτε κείμενο εδώ…',
    attempts_count: 'Αριθμός προσπαθειών που μπορεί να κάνει ο χρήστης',
    no_of_people_placeholder: 'Αριθμός ατόμων',
    back_to_maze: 'Επιστροφή στο Σενάριο MetaMaze',
    edit_maze: 'Επεξεργασία MetaMaze',
    wait: 'Παρακαλώ περιμένετε...',
    retry: 'Επανάληψη',
    publish_scorm_course: 'Δημοσίευση Μαθήματος SCORM',
    publish_maze: 'Δημοσίευση MetaMaze',
    import: 'Εισαγωγή Στοιχείων',
    answer_correct: 'Επιλέξτε τη σωστή απάντηση',
    author_name: `Παρακαλώ εισάγετε το όνομα του συγγραφέα`,
    select_category: 'Παρακαλώ επιλέξτε κατηγορία',
    course_outline: 'Παρακαλώ εισάγετε το περίγραμμα του μαθήματος',
    course_obj: 'Παρακαλώ εισάγετε τους στόχους του μαθήματος',
    course_description: 'Παρακαλώ εισάγετε την περιγραφή του μαθήματος',
    maze_outline: 'Παρακαλώ εισάγετε το περίγραμμα του λαβύρινθου',
    maze_obj: 'Παρακαλώ εισάγετε τους στόχους του λαβύρινθου',
    maze_description: 'Παρακαλώ εισάγετε την περιγραφή του λαβύρινθου',
    lessons: 'Παρακαλώ εισάγετε τον αριθμό των μαθημάτων',
    user_email_require: `Απαιτείται email χρήστη`,
    team_size: `Απαιτείται μέγεθος ομάδας`,
    enter_price: 'Παρακαλώ εισάγετε τιμή (5 ή περισσότερα)',
    input_title_maze: 'Παρακαλώ εισάγετε τίτλο λαβύρινθου',
    trainer_bio: 'Παρακαλώ εισάγετε το βιογραφικό του εκπαιδευτή',
    trainer_linkedin: 'Παρακαλώ εισάγετε το LinkedIn του εκπαιδευτή',
    error_video: 'Παρακαλώ εισάγετε τον αριθμό των βίντεο',
    input_video_link: 'Παρακαλώ εισάγετε σύνδεσμο βίντεο',
    number_of_video: 'αριθμός βίντεο',
    number_of_lessions: 'αριθμός μαθημάτων',
    no_of_people_in_conference: 'Πόσα άτομα στη διάσκεψη;',
    transcribe_settings: 'Ρυθμίσεις μεταγραφής',
    transcribe: 'Μεταγραφή',
    cloning_maze: 'Κλωνοποίηση MetaMaze...',
    id_number: 'Αριθμός ταυτότητας',
    timezone: 'Ζώνη ώρας',
    edit_maze: 'Επεξεργασία',
    delete_maze: 'Διαγραφή',
    view_maze: 'Προβολή',
    create_metamaze: 'Δημιουργία MetaMaze',
    metamaze_scenario: 'Σενάριο MetaMaze',
    publish_metamaze: 'Ρυθμίσεις δημοσίευσης',
    search_result: 'Αποτελέσματα αναζήτησης:',
    search_for: 'Αναζήτηση για',
    search_no_result: '- Δεν βρέθηκαν αποτελέσματα!',
    channel_no_available: 'Κανάλι μη διαθέσιμο!',
    this_card: 'Αυτή είναι μια κάρτα',
    course_no_available: 'Δεν υπάρχουν διαθέσιμα μαθήματα!',
    exit_fullscreen: 'Έξοδος πλήρους οθόνης',
    bg_image: 'Εικόνα φόντου',
    introduction: 'Εισαγωγή',
    summary: 'Περίληψη',
    generate_introduction: 'Δημιουργία εισαγωγής',
    generate_summary: 'Δημιουργία περίληψης',
    bullet_points: 'Σημεία με κουκκίδες',
    title_simulation: 'Παρακαλώ εισάγετε όνομα προσομοίωσης',
    view_generated_images: 'Προβολή δημιουργημένων εικόνων',
    image_transparency: 'Διαφάνεια εικόνας',
    template_bg_color: 'Χρώμα φόντου πρότυπου',
    select_template_layout: 'Επιλέξτε διάταξη προτύπου',
    reload_template: '(Πραγματοποίηση επαναφόρτωσης προτύπων)',
    are_you_sure_want_close: 'Είστε βέβαιοι ότι θέλετε να κλείσετε;',
    all_your_changes_will_be_lost: 'Όλες οι αλλαγές σας θα χαθούν.',
    please_checked_before_generated_video:
      'Παρακαλώ επιβεβαιώστε ότι έχουν ελεγχθεί όλες οι συνθήκες πριν τη δημιουργία βίντεο.',
    voice_must_be_selected: 'Πρέπει να επιλεγεί φωνή',
    avatar_must_be_selected: 'Πρέπει να επιλεγεί εικόνα avatar.',
    maximum_five_slides_try_again:
      'Σφάλμα κατά την εξαγωγή εικόνων από το αρχείο σας. Βεβαιωθείτε ότι υπάρχουν το πολύ 5 διαφάνειες και σημειώσεις σε κάθε διαφάνεια. Παρακαλώ δοκιμάστε ξανά!',
    back_to_upload: 'Επιστροφή στη μεταφόρτωση',
    uploading_file_to_server: 'Μεταφόρτωση του αρχείου σας στον διακομιστή',
    extracting_images_from_your_file: 'Εξαγωγή εικόνων από το αρχείο σας',
    upload_your_ppt_or_drag:
      'Μεταφορτώστε το αρχείο παρουσίασης (.PPTX) ή σύρετε το εδώ.',
    maximum_five_slides_error:
      'Βεβαιωθείτε ότι το αρχείο PowerPoint περιέχει το πολύ 5 διαφάνειες και υπάρχουν σημειώσεις σε κάθε διαφάνεια. Διαφορετικά θα παρουσιαστεί σφάλμα.',
    number_of_questions_generated: 'Αριθμός ερωτήσεων προς δημιουργία',
    quiz_page_this_cannot_be_done:
      'Είστε βέβαιοι ότι θέλετε να προσθέσετε το κουίζ σε αυτή τη σελίδα; Αυτό δεν μπορεί να ανακληθεί.',
    confirm_selection: 'Επιβεβαίωση επιλογής',
    select_quiz_page: 'Επιλέξτε σελίδα κουίζ',
    lesson_do_you_want_add_this_quiz:
      'Σε ποιο μέρος του μαθήματος θέλετε να προσθέσετε αυτό το κουίζ;',
    beginning_of_lesson: 'Στην αρχή του μαθήματος',
    end_of_lesson: 'Στο τέλος του μαθήματος',
    currently_active_page: 'Τρέχουσα ενεργή σελίδα',
    finish: 'Ολοκλήρωση',
    upload_selection_file: 'Μεταφορτώστε αρχείο τμήματος',
    general_quiz: 'Γενικό κουίζ',
    manage_sequence: 'Διαχείριση σειράς',
    save_sequence: 'Αποθήκευση σειράς',
    new: 'Νέο',
    in_progress: 'Σε εξέλιξη',
    recommended_course: 'Συνιστώμενο μάθημα',
    up_coming: 'Επερχόμενο',
    past_live: 'Προηγούμενο ζωντανό',
    input_your_channel_name: 'Παρακαλώ εισάγετε το όνομα του καναλιού σας!',
    organization_place: 'Marketplace Οργάνωσης',
    marketplace_report: 'Αναφορά Marketplace',
    story_writing: 'Δημιουργία ιστορίας',
    Ai_quiz: 'AI Κουίζ',
    generate_quiz: 'Δημιουργία κουίζ',
    create_story: 'Δημιουργία ιστορίας',
    change_layout_page: 'Πρόκειται να αλλάξετε τη διάταξη αυτής της σελίδας.',
    change_layout_message:
      'Σημειώστε ότι μόνο το κείμενο, οι εικόνες, το φόντο και το λογότυπο θα διατηρηθούν. Όλα τα άλλα στοιχεία θα καταργηθούν από τη σελίδα.',
    reviews: 'Κριτικές',
    tab_attachments: 'Συνημμένα',
    zoom_in: 'Σύγκλιση',
    zoom_out: 'Απομάκρυνση',
    zoom_reset: 'Επαναφορά ζουμ',
    no_attachment: 'Δεν υπάρχουν συνημμένα.',
    select_upload_simulation: 'Παρακαλώ επιλέξτε/μεταφορτώστε προσομοίωση.',
    quiz_updated_successfully: 'Το κουίζ ενημερώθηκε με επιτυχία!',
    quizes: 'Κουίζ',
    trivia: 'Παραλλαγή',
    closing: 'Κλείσιμο...',
    products: 'Προϊόντα',
    ask_questions: 'Κάντε μια ερώτηση εδώ...',
    course_information: 'Πληροφορίες μαθήματος',
    course_assistance: 'Βοήθεια δημιουργού μαθήματος',
    go_back: 'Επιστροφή',
    ai_generate_content_progress: 'Πρόοδος δημιουργίας περιεχομένου',
    view_generate_content: 'Προβολή δημιουργημένου περιεχομένου',
    generate_error: 'Σφάλμα δημιουργίας!',
    confirm_creating_course:
      'Θέλετε να επιβεβαιώσετε τη δημιουργία του μαθήματος χρησιμοποιώντας αυτό το περιεχόμενο;',
    generate_content_automatically:
      'Αυτό θα προσθέσει όλο το δημιουργημένο περιεχόμενο ως μαθήματα και σελίδες στο μάθημά σας αυτόματα.',
    quiz_created_successfully: 'Το κουίζ δημιουργήθηκε με επιτυχία!',
    create_quiz: 'Δημιουργία κουίζ',
    quiz_setting: 'Ρύθμιση κουίζ',
    please_fill_quiz_setting:
      '* Παρακαλώ συμπληρώστε όλα τα πεδία στις ρυθμίσεις κουίζ',
    question_list: 'Λίστα ερωτήσεων',
    add_quiz_to_page: 'Προσθήκη κουίζ στη σελίδα',
    form_create_question: 'Φόρμα δημιουργίας ερώτησης',
    user_information_updated: 'Πληροφορίες χρήστη ενημερώθηκαν!',
    your_stripe_activete_to_continue:
      'Ο λογαριασμός Stripe σας είναι ανενεργός. Παρακαλώ συνδέστε ή ενεργοποιήστε τον για να συνεχίσετε.',
    connect_tripe: 'Σύνδεση Stripe',
    certificate_sent_sucessfully:
      'Το πιστοποιητικό εστάλη στο email σας με επιτυχία.',
    error_try_again: 'Σφάλμα. Δοκιμάστε ξανά!',
    error_delete_channel: 'Σφάλμα κατά τη διαγραφή του καναλιού.',
    error_update_sub: 'Σφάλμα κατά την ενημέρωση της συνδρομής.',
    end_time_cannot_start:
      'Η ώρα λήξης δεν μπορεί να είναι πριν από την έναρξη.',
    start_date_time_interval: 'Απαιτούνται Έναρξη Ημερομηνίας και Ώρας!',
    podcast_updated_successful: 'Το podcast ενημερώθηκε με επιτυχία.',
    podcast_created_successful: 'Το podcast δημιουργήθηκε με επιτυχία.',
    podcast_published_successful: 'Το podcast δημοσιεύθηκε με επιτυχία.',
    podcast_cover_updated: 'Η εικόνα εξωφύλλου του podcast ενημερώθηκε',
    new_podcast_details:
      'Ένα νέο podcast θα δημιουργηθεί στο τρέχον podcast με νέα εισαγόμενα στοιχεία.',
    current_update_podcast:
      'Ενημέρωση τρέχοντος podcast, μουσικής & λεπτομερειών ιστοριών.',
    create_new_podcast: 'Δημιουργία νέου podcast',
    publish_podcast_public_view: 'Δημοσίευση podcast για δημόσια προβολή.',
    only_allowed_twenty_five_email: 'Επιτρέπονται μόνο 25 emails.',
    only_allowed_five_email: 'Επιτρέπονται μόνο 5 emails.',
    cover_is_required: 'Απαιτείται εξώφυλλο.',
    topic_is_required: 'Απαιτείται θέμα.',
    delete_schedule: 'Διαγραφή προγράμματος',
    make_as_coaching: 'Ορισμός ως Coaching Διαθεσιμότητα',
    manage_category: 'Διαχείριση κατηγορίας',
    threshold: 'Κατώφλι',
    threshold_popup:
      'Τιμή κατωφλίου σε ποσοστό (%), η τιμή μετά την οποία ενεργοποιείται η σύσταση για την κατηγορία.',
    list_of_catagory: 'Λίστα κατηγοριών',
    category_name: 'Όνομα κατηγορίας',
    category_threshold: 'Κατώφλι κατηγορίας',
    play_game: 'Παίξε παιχνίδι',
    switching_organization: 'Μεταβαίνω σε οργανισμό...',
    coaching_session: 'Συνεδρία Coaching',
    required_channel_id: 'Απαιτείται αναγνωριστικό καναλιού!',
    error_occured_try_again: 'Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά!',
    please_complete_marketplace_form:
      'Παρακαλώ συμπληρώστε τη φόρμα marketplace!',
    upload_file_corrupt: 'Το αρχείο που μεταφορτώθηκε είναι κατεστραμμένο.',
    course_not_published: 'Το μάθημα δεν έχει ακόμη δημοσιευτεί!',
    error_request: 'Σφάλμα στο αίτημα. Παρακαλώ δοκιμάστε ξανά!',
    skill_request: 'Παρακαλώ συμπληρώστε τα πεδία δεξιότητας!',
    error_occured: 'Παρουσιάστηκε σφάλμα. Δοκιμάστε ξανά!',
    show_time: 'Εμφάνιση ώρας',
    start_time: 'Ώρα έναρξης',
    end_time: 'Ώρα λήξης',
    room_name: 'Όνομα podcast',
    add_guest_speaker: 'Προσθήκη καλεσμένου ομιλητή',
    cover_picture: 'Εικόνα εξωφύλλου',
    guest_speaker: 'Καλεσμένος ομιλητής',
    see_more: 'Δείτε περισσότερα',
    see_less: 'Δείτε λιγότερα',
    background: 'Φόντο',
    icon: 'Εικονίδιο',
    icon_size: 'Μέγεθος εικονιδίου',
    icon_color: 'Χρώμα εικονιδίου',
    only_text: 'Μόνο κείμενο',
    change_bg: 'Αλλαγή χρώματος φόντου',
    bg_color: 'Χρώμα φόντου',
    font_size: 'Μέγεθος γραμματοσειράς',
    normal: 'Κανονικό',
    change_color: 'Αλλαγή χρώματος κειμένου',
    slant_text: 'Κεκλιμένο κείμενο',
    text_radius: 'Ακτίνα κειμένου',
    vertical_align: 'Κάθετη στοίχιση',
    horizontal_align: 'Οριζόντια στοίχιση',
    change_icon_color: 'Αλλαγή χρώματος εικονιδίου',
    upload_icon: 'Μεταφόρτωση εικονιδίου',
    upload_signature: 'Μεταφόρτωση υπογραφής',
    add_another_sign: 'Προσθήκη δεύτερης υπογραφής',
    name_badges: 'Όνομα ετικετών',
    should_less_150: 'πρέπει να είναι έως 150 χαρακτήρες',
    your_badge: 'Η ετικέτα σας',
    do_you_want_delete_badge:
      'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτήν την ετικέτα;',
    do_you_want_delete_cert:
      'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτό το πιστοποιητικό;',
    upload_logo: 'Ανεβάστε λογότυπο',
    name_of_cert: 'Όνομα πιστοποιητικού',
    upload_cert: 'Ενημέρωση πιστοποιητικού',
    your_cert: 'Το πιστοποιητικό σας',
    translate_to: 'Μετάφραση σε',
    select_file_attach: 'Επιλέξτε αρχείο για συνημμένο',
    certificate: 'Πιστοποιητικό',
    badge: 'Ετικέτα',
    publish_options: 'Επιλογές δημοσίευσης',
    publish_skills_journey: 'Δημοσίευση διαδρομής δεξιοτήτων',
    videos: 'Βίντεο',
    generate_ai_video:
      'Η διαδικασία δημιουργίας βίντεο με AI μπορεί να διαρκέσει. Θα ειδοποιηθείτε μέσω email μόλις ολοκληρωθεί.',
    trainer_information: 'Πληροφορίες εκπαιδευτή',
    promotional_video_link: 'Σύνδεσμος προωθητικού βίντεο',
    please_select: 'Παρακαλώ επιλέξτε',
    image_name: 'Όνομα εικόνας:',
    image_size: 'Μέγεθος εικόνας:',
    charecters_fifteen_less: 'Έως 15 χαρακτήρες',
    leadership: 'Ηγεσία',
    text_arc: 'Τόξο κειμένου',
    vertical: 'Κάθετο',
    horizontal: 'Οριζόντιο',
    badge_history: 'Ιστορικό ετικετών',
    templates: 'Πρότυπα',
    sign: 'Υπογραφή',
    logo: 'Λογότυπο',
    certificate_history: 'Ιστορικό πιστοποιητικών',
    please_wait: 'Παρακαλώ περιμένετε...',
    information: 'Πληροφορίες',
    support_five_thousand_live_event:
      'Υποστηρίζει έως 5000 συμμετέχοντες για live event',
    support_ten_live_event: 'Υποστηρίζει έως 10 ζωντανούς συμμετέχοντες',
    we_will_back_participant:
      'Θα επιστρέψουμε με event με πρόσβαση σε πλήθος συμμετεχόντων.',
    course_objectives: 'Στόχοι μαθήματος',
    course_outlines: 'Περιγράμματα μαθήματος',
    price_dollor: 'Τιμή (USD)',
    not_completed: 'Μη ολοκληρωμένο',
    enable_marketplace: 'Ενεργοποίηση αγοράς',
    enable_course_ai: 'Ενεργοποίηση δημιουργίας μαθήματος με AI',
    enable_report_to_admin: 'Ενεργοποίηση αναφοράς στον διαχειριστή',
    enable_white_label: 'Ενεργοποίηση white label',
    enable_eleven_labs_for_maze_play: 'Ενεργοποίηση Elevenlabs για Maze Play',
    enable_eleven_labs_for_maze_play_cloned:
      'Ενεργοποίηση Elevenlabs για κλωνοποιημένες φωνές',
    simulation_quiz: 'Κουίζ προσομοίωσης',
    bg_color_setting: 'Ρύθμιση χρώματος φόντου',
    color_preview: 'Προεπισκόπηση χρώματος',
    choose_new_color: 'Επιλέξτε νέο χρώμα',
    remove_color: 'Αφαίρεση χρώματος',
    apply_color: 'Εφαρμογή χρώματος',
    elemeent_in_a_sceenario_page:
      'Δεν μπορείτε να προσθέσετε περισσότερα στοιχεία στη σελίδα πρόκλησης. Δοκιμάστε σε άλλες σελίδες ή αφαιρέστε το στοιχείο πρόκλησης.',
    no_data_found: 'Δεν βρέθηκαν δεδομένα',
    references: 'Αναφορές',
    open_file: 'Άνοιγμα αρχείου',
    showing_result: 'Εμφάνιση αποτελεσμάτων:',
    fiften_day_free_trail: 'Δωρεάν δοκιμή 15 ημερών',
    your_browser_does_not_support:
      'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει ήχο.',
    podcast_desc: 'Περιγραφή podcast',
    input_podcast_desc: 'Εισαγάγετε περιγραφή podcast',
    podcast_obj: 'Στόχοι podcast',
    input_podcast_obj: 'Εισαγάγετε στόχους podcast',
    podcast_outline: 'Περίγραμμα podcast',
    input_podcast_outline: 'Εισαγάγετε περίγραμμα podcast',
    add_file: 'Προσθήκη αρχείου',
    generate_podcast_audio: 'Δημιουργία ήχου podcast',
    generate_uploaded_file_input_parameter:
      'Δημιουργία με βάση τα περιεχόμενα των μεταφορτωμένων αρχείων.',
    go_backe_generation_state:
      'Επιστροφή στην κατάσταση δημιουργίας περιεχομένου',
    create_ai_powered_podcast: 'Δημιουργία podcast με τεχνητή νοημοσύνη',
    generate_voice_for_all_podcast: 'Δημιουργία φωνής για όλα τα επεισόδια',
    create_podcast_episode: 'Δημιουργία επεισοδίου podcast',
    voice_name: 'Όνομα φωνής',
    input_custom_name: 'Εισαγάγετε προσαρμοσμένο όνομα!',
    enter_custom_name: 'Εισαγάγετε προσαρμοσμένο όνομα φωνής',
    upload_complete: 'Η μεταφόρτωση ολοκληρώθηκε',
    uploading_in_progress: 'Μεταφόρτωση σε εξέλιξη...',
    podcast_stream_content: 'Περιεχόμενο σειράς podcast',
    upload_podcast_cover: 'Ανεβάστε εξώφυλλο podcast!',
    enter_podcast_name: 'Εισαγάγετε όνομα podcast!',
    podcast_topic: 'Θέμα podcast',
    enter_podcast_topic: 'Εισαγάγετε θέμα podcast!',
    enter_podcast_desc: 'Εισαγάγετε περιγραφή podcast!',
    number_of_speaker: 'Αριθμός ομιλητών',
    select_the_number_of_speaker: 'Επιλέξτε αριθμό ομιλητών!',
    number_of_episode: 'Αριθμός επεισοδίων',
    input_number_of_episode: 'Εισαγάγετε αριθμό επεισοδίων!',
    podcast_length: 'Διάρκεια podcast',
    select_the_podcast_length: 'Επιλέξτε διάρκεια podcast!',
    short_podcast: 'Σύντομο (5-10 λεπτά)',
    medium_podcast: 'Μέσο (15-18 λεπτά)',
    long_podcast: 'Μακρύ (18+ λεπτά)',
    name_of_host: 'Όνομα παρουσιαστή',
    enter_host_name: 'Εισαγάγετε όνομα παρουσιαστή!',
    guest_name: 'Ονόματα προσκεκλημένων',
    enter_guest_name: 'Εισαγάγετε ονόματα προσκεκλημένων!',
    choose_speaker_tone: 'Επιλέξτε τόνο φωνής',
    enter_speaker_tone: 'Επιλέξτε τόνο φωνής για το podcast!',
    informal: 'Ανεπίσημο',
    formal: 'Επίσημο',
    serious: 'Σοβαρό',
    light_humor: 'Ελαφρύ χιούμορ',
    casual: 'Καθημερινό',
    select_content_source: 'Επιλέξτε πηγή περιεχομένου',
    from_internet: 'Από το διαδίκτυο',
    upload_pdf_internet: 'Ανεβάστε PDF ή σελίδα περιεχομένου',
    note: 'Σημείωση:',
    podcast_content_will_be_automatically_generated:
      'Το περιεχόμενο του podcast θα δημιουργηθεί αυτόματα από αξιόπιστες διαδικτυακές πηγές.',
    upload_or_select_file: 'Ανεβάστε ή επιλέξτε αρχείο!',
    podcast_eposode_title: 'Τίτλος επεισοδίου podcast',
    enter_podcast_title: 'Εισαγάγετε τίτλο επεισοδίου!',
    podcast_episode_des: 'Περιγραφή επεισοδίου podcast',
    enter_podcast_episode_des: 'Εισαγάγετε περιγραφή επεισοδίου!',
    voice: 'Φωνή',
    music: 'Μουσική',
    select_music: 'Επιλέξτε μουσική',
    play_the_music: 'Αναπαραγωγή μουσικής',
    stop_the_music: 'Διακοπή μουσικής',
    context: 'Περιεχόμενο',
    generate_audio_content_selected_voice:
      'Δημιουργία ήχου με επιλεγμένη φωνή.',
    required_field_before_submitting:
      'Παρακαλούμε συμπληρώστε όλα τα υποχρεωτικά πεδία πριν την υποβολή.',
    regenerate_voice: 'Επαναδημιουργία φωνής',
    generate_voice: 'Δημιουργία φωνής',
    your_browser_does_not_suppot:
      'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει ήχο.',
    are_sure_leave_podcast:
      'Είστε βέβαιοι ότι θέλετε να φύγετε από το podcast;',
    broadcast_ongoing:
      'Η μετάδοση είναι σε εξέλιξη. Θέλετε σίγουρα να φύγετε από τη σελίδα;',
    brodcaster_unavailable: 'Ο παρουσιαστής δεν είναι διαθέσιμος.',
    setting_calender_for_booking: 'Ορισμός ημερολογίου για κράτηση',
    add_calender: 'Προσθήκη ημερολογίου',
    waiting_join_host: 'Αναμονή για ένταξη του παρουσιαστή...',
    no_reviews_found: 'Δεν βρέθηκαν κριτικές',
    rated_already: 'Έχετε ήδη βαθμολογήσει αυτό το live',
    downlink_png: 'Λήψη σε PNG',
    downlink_jpg: 'Λήψη σε JPG',
    donwload_file_format: 'Επιλέξτε μορφή αρχείου για λήψη.',
    crashed_event:
      'Το γεγονός διακόπηκε. Πρέπει να δημιουργηθεί νέο γεγονός. Συγγνώμη για την ταλαιπωρία.',
    prompt: 'Ερώτημα:',
    generated_image: '🚀 Δημιουργία εικόνας σε εξέλιξη... Παρακαλώ περιμένετε.',
    download_add: 'Λήψη όλων',
    setting_generator: 'Ρυθμίσεις δημιουργού',
    enter_image_prompt: 'Εισάγετε θέμα εικόνας',
    image_prompt: 'Θέμα εικόνας',
    negative_prompt: 'Μη επιθυμητό περιεχόμενο',
    negative_image_prompt: 'Μη επιθυμητό θέμα εικόνας',
    number_output: 'Αριθμός εικόνων προς δημιουργία',
    enter_number_output: 'Εισαγάγετε αριθμό εικόνων',
    image_style: 'Στυλ εικόνας',
    output_format: 'Μορφή εξόδου',
    seeds: 'Σπόροι',
    enter_seeds: 'Εισαγάγετε σπόρους',
    performance_mode: 'Λειτουργία απόδοσης',
    quality: 'Ποιότητα',
    speed: 'Ταχύτητα',
    balanced: 'Ισορροπημένο',
    guidance_scale: 'Κλίμακα καθοδήγησης',
    enter_guidance: 'Εισάγετε κλίμακα καθοδήγησης',
    select_image: 'Επιλέξτε εικόνα.',
    image_prmt: 'Θέμα εικόνας',
    generate_image_list_empty: 'Δεν υπάρχουν διαθέσιμες εικόνες.',
    knowledge_center_tooltrip_des:
      'Λάβετε ακριβείς και σχετικές απαντήσεις βασισμένες σε πληροφορίες από το διαδίκτυο. Το AI βασίζεται σε περιεχόμενο από το διαδίκτυο.',
    contexts: 'Πλαίσια',
    ai_processing_video_sharebot:
      'Η επεξεργασία AI για βίντεο Sharebot ισχύει για 24 ώρες.',
    remove_sharebot_video:
      'Για να καταργήσετε το βίντεο Sharebot, αφαιρέστε το απόσπασμα ήχου και το βίντεο.',
    remove_sharebot_video_audio:
      'Η διαγραφή του αποσπάσματος ήχου καταργεί τον σύνδεσμο Sharebot από βίντεο/ήχο, αλλά το περιεχόμενο παραμένει στη βιβλιοθήκη.',
    monthly_live_stream:
      'Επικοινωνήστε μαζί μας για να τροποποιήσετε τα όρια των ζωντανών μεταδόσεων ανά μήνα.',
    monthly_transcribe_limit:
      'Επικοινωνήστε μαζί μας για να τροποποιήσετε τα όρια μεταγραφής ανά μήνα.',
    must_be_one_to_three_hundred:
      'Η τιμή πρέπει να είναι μεταξύ 1 και 300 λεπτών.',
    all_field_required: 'Όλα τα πεδία είναι υποχρεωτικά.',
    duration_minute: 'Διάρκεια (μέγιστο 300 λεπτά)',
    gender: 'Φύλο',
    select_gender: 'Επιλέξτε φύλο',
    accent: 'Προφορά',
    select_accent: 'Επιλέξτε προφορά',
    create_voice: 'Δημιουργία φωνής',
    enter_voice_name: 'Εισαγάγετε το όνομα της φωνής',
    select_voice_gender: 'Επιλέξτε φύλο φωνής',
    upload_voice: 'Ανεβάστε τη φωνή σας',
    upload_voice_mp_three: 'Ανεβάστε τη φωνή σας (.mp3)',
    cloned_voice: 'Κλωνοποιημένη φωνή',
    voice_type: 'Τύπος φωνής',
    select_voice_type: 'Επιλέξτε τύπο φωνής',
    sharelook_stand: 'Κανονική',
    sharelook_premium: 'Premium',
    sharelook_custum_voice: 'Προσαρμοσμένη (κλωνοποιημένη φωνή)',
    create_auto_flow: 'Δημιουργία αυτόματης ροής',
    how_many_layers: 'Πόσα επίπεδα',
    verify_selection: 'Επαλήθευση επιλογής',
    uploaded_successful: 'Το αρχείο ανέβηκε με επιτυχία',
    upload_failed: 'Η αποστολή απέτυχε',
    upload_only_five_mb: 'Ανεβάστε αρχεία (PDF, έως 5 αρχεία)',
    docs_from_org_library: 'Έγγραφα από τη βιβλιοθήκη του οργανισμού',
    failed_maze_generate: 'Αποτυχία δημιουργίας λαβυρίνθου. Δοκιμάστε ξανά.',
    generate_metamaze: 'Δημιουργία MetaMaze...',
    metamaze_being_generated:
      'Το MetaMaze δημιουργείται. Θα λάβετε ένα email όταν ολοκληρωθεί.',
    metamaze_generate_successfully: 'Το MetaMaze δημιουργήθηκε με επιτυχία!',
    metamaze_with_proceed: 'Τώρα μπορείτε να συνεχίσετε με το MetaMaze.',
    ai_metamaze_generate: 'MetaMaze που δημιουργήθηκε από AI',
    what_kind_maze_create: 'Τι είδους λαβύρινθο θέλετε να δημιουργήσετε;',
    manual_metamaze_creation: 'Χειροκίνητη δημιουργία MetaMaze',
    manually_maze_customizing_scnario:
      'Προσαρμόστε σενάρια και επιλογές με το χέρι',
    maze_ai_generated: 'Λαβύρινθος που δημιουργήθηκε αυτόματα από AI',
    unmark_deadend: 'Αποεπιλογή αδιέξοδου',
    mark_deadend: 'Επισήμανση ως αδιέξοδο',
    select_multiple_image_for_scenario:
      'Επιλέξτε πολλές εικόνες για αυτό το σενάριο.',
    select_your_image: 'Επιλεγμένη εικόνα',
    click_to_preview: 'Κάντε κλικ για προεπισκόπηση',
    are_you_sure_delete_image:
      'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή την εικόνα;',
    select_image_from_library: 'Επιλέξτε εικόνα από τη βιβλιοθήκη πολυμέσων',
    uploading_video: 'Γίνεται αποστολή βίντεο...',
    tree_node_type: 'Τύπος κόμβου δέντρου',
    correct_option_scenario: 'Σωστή επιλογή/σενάριο',
    incorrect_option: 'Λανθασμένη επιλογή',
    option_scenario_without_text: 'Επιλογή/σενάριο χωρίς κείμενο',
    dead_end: 'Αδιέξοδο (κόκκινο σημάδι)',
    correct_path: 'Σωστή διαδρομή',
    incorrect_path_not_selected_correct_option_path:
      'Λάθος διαδρομή / δεν επιλέχθηκε η σωστή επιλογή',
    double_click_on_tree_node:
      'Κάντε διπλό κλικ στον κόμβο για να δείτε το συσχετισμένο σενάριο.',
    add_scenario: 'Προσθήκη σεναρίου',
    add_option: 'Προσθήκη επιλογής',
    an_error_occured: 'Παρουσιάστηκε σφάλμα:',
    download_summary: 'Λήψη σύνοψης',
    step_wise_analysis: 'Ανάλυση βήμα προς βήμα',
    step: 'Βήμα',
    upload_csv_file: 'Ανέβασμα αρχείου CSV',
    download_template_to_import: 'Κατεβάστε το πρότυπο για εισαγωγή',
    please_input_email: 'Εισαγάγετε email',
    email_at_least_three_characters:
      'Το email πρέπει να έχει τουλάχιστον 3 χαρακτήρες',
    email_cannot_be_empty: 'Το email δεν μπορεί να είναι κενό',
    input_email_in_new_line: 'Εισαγάγετε κάθε email σε νέα γραμμή',
    role: 'Ρόλος',
    select_role: 'Επιλέξτε ρόλο',
    select_group: 'Επιλέξτε ομάδα',
    identification_number: 'Αριθμός ταυτοποίησης (προαιρετικό)',
    add_identification_number: 'Προσθήκη αριθμού ταυτοποίησης',
    pie_chart_of_all_categories:
      'Γράφημα πίτας όλων των κατηγοριών στο Sharelook',
    total_sharesphere_question_answered_by_users:
      'Ερωτήσεις ShareSphere που απαντήθηκαν από χρήστες επιτυχώς/ανεπιτυχώς',
    voice_style_over_the_text:
      'Εφαρμόστε διαφορετικά στυλ φωνής στο κείμενο. Το Lorem Ipsum είναι ένα πρότυπο κείμενο της εκτυπωτικής βιομηχανίας από τον 16ο αιώνα.',
    input_your_question: 'Πληκτρολογήστε την ερώτησή σας!',
    make_me_sales_manager: 'Π.χ. - Κάνε με διευθυντή πωλήσεων',
    enter_the_number_relevant_document:
      'Εισαγάγετε τον αριθμό σχετικών εγγράφων',
    please_wait_loading_result: 'Παρακαλώ περιμένετε, φόρτωση αποτελεσμάτων...',
    no_result_found:
      'Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε να διατυπώσετε την ερώτηση διαφορετικά.',
    browser_doesnot_support_iframes: 'Ο περιηγητής σας δεν υποστηρίζει iframes',
    total_duration: 'Συνολική διάρκεια',
    number_of_messages: 'Αριθμός μηνυμάτων',
    search_result: 'Αποτέλεσμα αναζήτησης',
    count_result: '(1244 αποτελέσματα)',
    your_other_interests: 'Άλλα ενδιαφέροντά σας',
    your_total_score: 'Συνολική βαθμολογία σας',
    add_a_question: '+ Προσθήκη ερώτησης',
    travia_question_empty: 'Δεν υπάρχουν ερωτήσεις Trivia',
    video_generation_is_on_queue: 'Το βίντεό σας είναι στην ουρά!',
    checking_video_status: 'Έλεγχος κατάστασης βίντεο...',
    total_quizzes: 'Σύνολο κουίζ',
    number_of_votes: 'Αριθμός ψήφων',
    total_events: 'Σύνολο εκδηλώσεων',
    number_of_rates: 'Αριθμός αξιολογήσεων',
    number_of_likes: 'Αριθμός "μου αρέσει"',
    all_courses: 'Όλα τα μαθήματα',
    total_questions: 'Συνολικές ερωτήσεις',
    no_skill_journey: 'Δεν υπάρχει διαθέσιμο ταξίδι δεξιοτήτων!',
    search_no_results: '- Χωρίς αποτελέσματα!',
    no_image_generated: 'Δεν έχει δημιουργηθεί εικόνα ακόμα!',
    all_topic_in_this_lesson:
      'Αυτό θα διαγράψει όλα τα θέματα από το μάθημα. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    content_has_been_generated:
      'Το περιεχόμενο έχει ήδη δημιουργηθεί για αυτό το θέμα.',
    update_course_template: 'Ενημέρωση προτύπου μαθήματος',
    add_course_template: 'Προσθήκη προτύπου μαθήματος',
    create_course_now: 'Δημιουργία μαθήματος τώρα',
    preview_course: 'Προεπισκόπηση μαθήματος',
    layout: 'Διάταξη',
    import_from_youtube: 'Εισαγωγή από το YouTube',
    my_media_library: 'Η βιβλιοθήκη πολυμέσων μου',
    bg_added: 'Το φόντο προστέθηκε',
    add_bg: 'Προσθήκη φόντου',
    booked_schedule: 'Κρατημένο πρόγραμμα',
    add_schedule: 'Προσθήκη προγράμματος',
    are_you_delete_schedule:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το πρόγραμμα;',
    add_task: 'Προσθήκη εργασίας',
    update_calender: 'Ενημέρωση ημερολογίου',
    manage_cookies: 'Διαχείριση Cookies',
    cookie_banner_text:
      'Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία περιήγησής σας, να αναλύσουμε την επισκεψιμότητα του ιστότοπου και να εξατομικεύσουμε το περιεχόμενο. Η ιδιωτικότητά σας είναι σημαντική για εμάς.',
    accept_all_cookies: 'Αποδοχή όλων των cookies',
    reject_all: 'Απόρριψη όλων',
    customize: 'Προσαρμογή',
    cookie_preferences_title: 'Προτιμήσεις Cookies & Ρυθμίσεις Ιδιωτικότητας',
    privacy_subtitle:
      'Η ιδιωτικότητά σας έχει σημασία για εμάς. Επιλέξτε ποια cookies επιθυμείτε. Μπορείτε να αλλάξετε αυτές τις ρυθμίσεις οποιαδήποτε στιγμή.',
    save_choices: 'Αποθήκευση επιλογών μου',
    strictly_necessary: 'Απολύτως απαραίτητα',
    strictly_necessary_desc:
      'Αυτά τα cookies είναι απαραίτητα για τη σωστή λειτουργία του ιστότοπου. Ενεργοποιούν βασικές λειτουργίες όπως πλοήγηση σελίδων, υποβολή φορμών και πρόσβαση σε ασφαλείς περιοχές. Ο ιστότοπος δεν μπορεί να λειτουργήσει σωστά χωρίς αυτά.',
    analytics_performance: 'Ανάλυση & Απόδοση',
    analytics_performance_desc:
      'Αυτά τα cookies μας βοηθούν να κατανοήσουμε πώς οι επισκέπτες αλληλεπιδρούν με τον ιστότοπό μας συλλέγοντας και αναφέροντας πληροφορίες ανώνυμα. Αυτό μας βοηθά να βελτιώσουμε την απόδοση και την εμπειρία χρήστη.',
    advertising_marketing: 'Διαφήμιση & Μάρκετινγκ',
    advertising_marketing_desc:
      'Αυτά τα cookies χρησιμοποιούνται για να κάνουν τα διαφημιστικά μηνύματα πιο σχετικά με εσάς. Αποτρέπουν την επανεμφάνιση των ίδιων διαφημίσεων και διασφαλίζουν ότι προβάλλονται σωστά για τους διαφημιζόμενους.',
    tracking_social: 'Παρακολούθηση & Κοινωνικά Δίκτυα',
    tracking_social_desc:
      'Αυτά τα cookies ενεργοποιούν προηγμένες λειτουργίες και εξατομίκευση, όπως δυνατότητες κοινωνικών δικτύων και προσωποποιημένο περιεχόμενο. Μπορεί να έχουν ρυθμιστεί από εμάς ή από τρίτους παρόχους.',
    functional: 'Λειτουργικά',
    functional_desc:
      'Αυτά τα cookies επιτρέπουν προηγμένες λειτουργίες όπως υποστήριξη μέσω συνομιλίας, ζωντανή βοήθεια και άλλες διαδραστικές δυνατότητες που βελτιώνουν την εμπειρία σας στον ιστότοπό μας.',
    your_rights: 'Τα δικαιώματά σας:',
    rights_description:
      'Μπορείτε να αποσύρετε τη συγκατάθεσή σας, να αποκτήσετε πρόσβαση στα δεδομένα σας ή να ζητήσετε τη διαγραφή τους οποιαδήποτε στιγμή.',
    withdraw_consent: 'Ανάκληση όλων των συγκαταθέσεων',

    how_many_options: 'Πόσες επιλογές',
    add_content: 'Προσθήκη περιεχομένου',
    downloads_center: 'Κέντρο λήψεων',
    sharelook_help_center: 'Κέντρο βοήθειας Sharelook',
    channel_outline: 'Περίγραμμα καναλιού',
    channel_objectives: 'Στόχοι καναλιού',
    no_sop_available: 'Δεν υπάρχει διαθέσιμη λίστα SOP.',
    generate_world_summary: 'Δημιουργία σεναρίου',
    world_scenario: 'Πραγματικό σενάριο',
    drag_icon_hint:
      'Συμβουλή: Σύρετε το εικονίδιο στον καμβά για να το τοποθετήσετε',
    drag_text_hint:
      'Συμβουλή: Σύρετε το κείμενο στον καμβά για να το τοποθετήσετε',
    edit_badge: 'Επεξεργασία σήματος',
    create_new_badge: 'Νέο σήμα',
    select_video_preview: 'Επιλέξτε ένα βίντεο για προεπισκόπηση',
    certificate_title_required: 'Απαιτείται τίτλος πιστοποιητικού',
    discard_changes: 'Απόρριψη αλλαγών',
    edit_certificate: 'Επεξεργασία πιστοποιητικού',
    add_another_logo: 'Προσθήκη άλλου λογότυπου',
    optional: 'Προαιρετικό',
    doc: 'DOC',
    ppt: 'PPT',
    quest_title: 'Δημιουργία νέας αποστολής',
    quest_filter_title: 'Αποστολή',
    sharelook_assistance: 'Καθοδήγηση Sharelook',
    upload_scorm_zip: 'Μεταφόρτωση αρχείου SCORM zip',
    only_letters_numbers_space_dot_allowed:
      'Επιτρέπονται μόνο γράμματα, αριθμοί, κενά και τελείες!',
    video_playing: 'Αναπαραγωγή',
    course_price_message: `*Το μάθημα θα δημοσιευθεί μόνο σε χρήστες εντός του οργανισμού και δεν μπορεί να μεταπωληθεί στην αγορά.`,
    lesson_must_be_positive:
      'Ο αριθμός μαθημάτων πρέπει να είναι μεγαλύτερος από 1',
    btn_proceed: 'Συνέχεια',
    rule_select_music: 'Παρακαλώ επιλέξτε μουσική',
    course_info: 'Πληροφορίες μαθήματος',
    content_selection: 'Επιλογή περιεχομένου',
    course_content_source: 'Πηγή περιεχομένου μαθήματος',
    choose_how_to_source:
      'Επιλέξτε πώς θα αποκτηθεί το περιεχόμενο για αυτό το μάθημα:',
    automatic_selection: 'Αυτόματη επιλογή',
    system_will_automatically_select_relavant_documents:
      'Το σύστημα θα επιλέξει αυτόματα σχετικά έγγραφα από τη βιβλιοθήκη σας',
    manual_selection: 'Χειροκίνητη επιλογή',
    choose_specific_documents_from_your_library:
      'Επιλέξτε συγκεκριμένα έγγραφα από τη βιβλιοθήκη σας',
    upload_files: 'Μεταφόρτωση αρχείων',
    upload_new_documents:
      'Μεταφορτώστε νέα έγγραφα (PDF, DOC, DOCX, PPT, PPTX, TXT) - Μέγιστο 5 αρχεία',
    file: 'αρχείο',
    ready_to_upload: 'έτοιμο για μεταφόρτωση',
    clear_all: 'Εκκαθάριση όλων',
    confirm_course_wide_premiew: 'Επιβεβαίωση προεπισκόπησης μαθήματος',
    generate_course_preview: 'Δημιουργία προεπισκόπησης μαθήματος',
    instructions_across_the_course_to_generate:
      'Θα εφαρμόσουμε τις οδηγίες σας σε ολόκληρο το μάθημα για να δημιουργηθεί προεπισκόπηση. Ελέγξτε τα πάντα πριν αποφασίσετε να διατηρήσετε ή να απορρίψετε αλλαγές.',
    instruction_to_preview_course_wide:
      'Οδηγίες για προεπισκόπηση ολόκληρου του μαθήματος:',
    edit_content: 'Επεξεργασία περιεχομένου',
    manage_course_template: 'Διαχείριση προτύπου μαθήματος',
    undo: 'Αναίρεση',
    apply_changes: 'Εφαρμογή αλλαγών',
    characters: 'χαρακτήρες',
    apply_all: 'Εφαρμογή όλων',
    apply_to_all: 'Εφαρμογή σε όλα',
    use_this_content: 'Χρήση αυτού του περιεχομένου',
    original: 'Αρχικό',
    edited: 'Επεξεργασμένο',
    edited_content_preview: 'Προεπισκόπηση επεξεργασμένου περιεχομένου',
    apply_edits_to_all_topices: 'Εφαρμογή επεξεργασιών σε όλα τα θέματα;',
    current_editing_instructions_across_the_whole_course:
      'Αυτό θα εφαρμόσει τις τρέχουσες οδηγίες επεξεργασίας σε ολόκληρο το μάθημα. Μπορείτε να δείτε τη συνδυασμένη προεπισκόπηση πριν από την αποθήκευση.',
    edit_content_instructions: 'Οδηγίες επεξεργασίας περιεχομένου',
    generate_content_for_this_topic_instruction:
      'Δημιουργία περιεχομένου για αυτό το θέμα βάσει των οδηγιών σας',
    descrip_edit_content:
      'Περιγράψτε πώς να επεξεργαστεί αυτό το περιεχόμενο (π.χ. συντομεύστε, απλοποιήστε, αναδιατυπώστε)',
    try_short_clear_direcctives: `Δοκιμάστε σύντομες, σαφείς οδηγίες. Παραδείγματα: "μειώστε σε 100 λέξεις, κρατήστε τα βασικά σημεία", "απλοποιήστε τη γλώσσα", "κάντε το πιο συνοπτικό και αφαιρέστε περιττά μέρη".`,
    we_preserve_the_core_meaning:
      'Διατηρούμε το βασικό νόημα ενώ εφαρμόζουμε τις οδηγίες σας.',
    feedback_optional: 'Σχόλια (προαιρετικά)',
    write_your_feedback_here: 'Γράψτε τα σχόλιά σας εδώ',
    from_web: 'Από τον Ιστό',
    from_desktop: 'Από τον υπολογιστή',
    pleae_wait_processing: 'Παρακαλώ περιμένετε, επεξεργασία...',
    create_simulation_from_screen_capture:
      'Δημιουργία προσομοίωσης από καταγραφή οθόνης',
    sharelook_not_found: 'Το ShareLook δεν βρέθηκε',
    sharelook_screen_capture_application_not_be_opened:
      'Η εφαρμογή καταγραφής οθόνης ShareLook δεν μπόρεσε να ανοίξει. Ίσως δεν είναι εγκατεστημένη στον υπολογιστή σας.',
    download_sharelook: 'Λήψη ShareLook',
    launch_sharelook_application: 'Εκκίνηση εφαρμογής ShareLook',
    this_will_open_the_sharelook_application_for_screen_capture:
      'Αυτό θα ανοίξει την εφαρμογή ShareLook για καταγραφή οθόνης.',
    sharelook_dosenot_open:
      'Αν το ShareLook δεν ανοίγει, ίσως δεν είναι εγκατεστημένο στον υπολογιστή σας.',
    open_sharelook: 'Άνοιγμα ShareLook',
    download_app: 'Λήψη εφαρμογής',
    background_image_setting: 'Ρυθμίσεις εικόνας φόντου',
    current_image: 'Τρέχουσα εικόνα',
    change_image: 'Αλλαγή εικόνας',
    remove_image: 'Αφαίρεση εικόνας',
    no_background_image_selected: 'Δεν έχει επιλεγεί εικόνα φόντου',
    add_image: 'Προσθήκη εικόνας',
    this_will_open_for_screen_recording:
      'Αυτό θα ανοίξει την εφαρμογή ShareLook για εγγραφή οθόνης.',
    ai_image_generation: 'Δημιουργία εικόνας με τεχνητή νοημοσύνη',
    image_edit: 'Επεξεργασία εικόνας',
    text_to_image: 'Κείμενο σε εικόνα',
    output_gallary: 'Συλλογή εξόδου',
    instant_generation: 'Έτοιμο για άμεση δημιουργία',
    prompt_and_unleash_the_power:
      'Εισαγάγετε το prompt σας και απελευθερώστε τη δύναμη',
    use_this_image: 'Χρήση αυτής της εικόνας',
    error_generating: 'Σφάλμα κατά τη δημιουργία.',
    generation_tips: 'Συμβουλές δημιουργίας',
    detailed_descriptions_for_more_accurate_results:
      'Χρησιμοποιήστε λεπτομερείς περιγραφές για πιο ακριβή αποτελέσματα',
    reference_image: 'Εικόνα αναφοράς',
    select_pixel_image: 'Επιλέξτε pixel εικόνας',
    max_mb: 'Μέγιστο 50MB',
    please_enter_text_to_appear_image:
      'Παρακαλώ εισαγάγετε το κείμενο που θα εμφανίζεται στην εικόνα',
    enter_text_to_apear_in_the_image:
      'Εισαγάγετε το κείμενο που θα εμφανίζεται στην εικόνα',
    generate_image: 'Δημιουργία εικόνας',
    prompt_assistant: 'Βοηθός prompt',
    generate_image_using_suggested_prompt:
      'Δημιουργία εικόνας χρησιμοποιώντας το προτεινόμενο prompt',
    talk_to_ai_about_the_image_generate:
      'Μιλήστε στην ΤΝ για την εικόνα που θέλετε να δημιουργήσετε',
    ask_for_prompt_suggestions: 'Ζητήστε προτάσεις prompt...',
    enter_a_search_term_to_find_stock_images:
      'Εισαγάγετε έναν όρο αναζήτησης για να βρείτε εικόνες stock',
    choose_your_content_source: 'Επιλέξτε την πηγή περιεχομένου σας:',
    upload_new_document_from_your_device:
      'Μεταφορτώστε νέα έγγραφα από τη συσκευή σας',
    automatic_library_selection: 'Αυτόματη επιλογή βιβλιοθήκης',
    system_automatically_selects_relevant_document:
      'Το σύστημα επιλέγει αυτόματα σχετικά έγγραφα',
    manual_library_selection: 'Χειροκίνητη επιλογή βιβλιοθήκης',
    generate_content: 'Δημιουργία περιεχομένου',
    add_to_current_page: 'Προσθήκη στην τρέχουσα σελίδα',
    generate_bullet_points: 'Δημιουργία κουκκίδων',
    generating: 'Δημιουργία σε εξέλιξη',
    this_may_take_a_few_moments: 'Αυτό μπορεί να διαρκέσει λίγα δευτερόλεπτα',
    apply_to_page: 'Εφαρμογή στη σελίδα',
    scenario_escription: 'Περιγραφή σεναρίου:',
    feedback: 'Ανατροφοδότηση',
    form_mode: 'Λειτουργία Φόρμας',
    chat_mode: 'Λειτουργία Συνομιλίας',
    this_will_generate_a_continuation_of_the_seleccted_story:
      'Αυτό θα δημιουργήσει μια συνέχεια της επιλεγμένης ιστορίας χρησιμοποιώντας AI.',
    continue_this_story_question: 'Συνεχίζουμε αυτή την ιστορία;',
    continue_this_story: 'Συνέχισε αυτή την ιστορία',
    what_will_happen: 'Τι θα συμβεί:',
    the_ai_will_analyze_the_existing_story_content:
      'Το AI θα αναλύσει το υπάρχον περιεχόμενο της ιστορίας',
    generate_a_natural_continuation_that_follows_the_same_tone:
      'Δημιουργία φυσικής συνέχειας που ακολουθεί τον ίδιο τόνο και στυλ',
    create_new_content_that_build_upon_the_current_narrative:
      'Δημιουργία νέου περιεχομένου που βασίζεται στην τρέχουσα αφήγηση',
    this_process_may_take_a_few_moments_to_complete:
      'Αυτή η διαδικασία μπορεί να χρειαστεί λίγα λεπτά για να ολοκληρωθεί.',
    no_existing_stories_found_for_this_course:
      'Δεν βρέθηκαν υπάρχουσες ιστορίες για αυτό το μάθημα.',
    create_your_first_story: 'Δημιουργήστε την πρώτη σας ιστορία',
    existing_stories: 'Υπάρχουσες Ιστορίες',
    create_new_story: 'Δημιουργία Νέας Ιστορίας',
    tone: 'Τόνος',
    style: 'Στυλ',
    genre: 'Είδος',
    loading_your_stories: 'Φόρτωση των ιστοριών σας...',
    edit_story: 'Επεξεργασία Ιστορίας',
    story_preferences: 'Προτιμήσεις Ιστορίας',
    please_input_your: 'Παρακαλώ εισάγετε το/την',
    add_character_names_and_press_enter:
      'Προσθέστε ονόματα χαρακτήρων και πατήστε Enter',
    select_or_type_your: 'Επιλέξτε ή πληκτρολογήστε το/την',
    enter_your: 'Εισάγετε το/την',
    position_of_the_story_in_the_lesson:
      'Η θέση της ιστορίας στο μάθημα. Η ιστορία θα προστεθεί ως μπλοκ στη συγκεκριμένη θέση.',
    save_previous_content_on_the_pages:
      'Αποθήκευση προηγούμενου περιεχομένου στις σελίδες',
    the_existing_content_in_the_selected_pages:
      'Το υπάρχον περιεχόμενο στις επιλεγμένες σελίδες θα αντικατασταθεί από την παραγόμενη ιστορία.',
    real_world_scenario: 'Σενάριο Πραγματικού Κόσμου',
    add_optional_instructions:
      'Προσθέστε προαιρετικές οδηγίες (τόνος, μήκος, κοινό, κ.λπ.)',
    ready_to_enerate_your_real_world_scenario:
      'Έτοιμοι να δημιουργήσετε το σενάριο πραγματικού κόσμου σας',
    click_generate_real_world_scenario_to_create_a_realistic_scenario:
      'Κάντε κλικ στο "Δημιουργία Σεναρίου Πραγματικού Κόσμου" για να δημιουργήσετε ένα ρεαλιστικό σενάριο βασισμένο στο περιεχόμενο του μαθήματός σας.',
    the_ai_will_analyze_your_lesson_topic_and_content:
      'Το AI θα αναλύσει το θέμα και το περιεχόμενο του μαθήματός σας',
    generate_a_practical_real_world_scenario:
      'Δημιουργία πρακτικού σεναρίου πραγματικού κόσμου',
    you_can_then_edit_and_customize_the_result:
      'Στη συνέχεια, μπορείτε να επεξεργαστείτε και να προσαρμόσετε το αποτέλεσμα',
    add_it_as_a_new_page_to_your_lesson:
      'Προσθήκη ως νέα σελίδα στο μάθημά σας',
    regenerate_with_instructions: 'Αναδημιουργία με Οδηγίες',
    add_real_world_scenario: 'Προσθήκη Σεναρίου Πραγματικού Κόσμου',
    generate_real_world_scenario: 'Δημιουργία Σεναρίου Πραγματικού Κόσμου',
    simulation_has_been_stopped: 'Η προσομοίωση έχει σταματήσει!',
    loading_simulation: 'Φόρτωση Προσομοίωσης...',
    you_have_exhausted_all_the_attempts:
      'Έχετε εξαντλήσει όλες τις προσπάθειες',
    study_the_scenario_on_this_page_and_select_the_correct_answer:
      'Μελετήστε το σενάριο σε αυτή τη σελίδα και επιλέξτε τη σωστή απάντηση από τις επιλογές παρακάτω.',
    attempts_limit_reached:
      'Έχετε φτάσει στο όριο προσπαθειών. Μπορείτε να ξαναπαίξετε αλλά η βαθμολογία σας δεν θα αποθηκευτεί.',
    play_again: 'Παίξε ξανά',
    import_music_from_computer: 'Εισαγωγή μουσικής από τον υπολογιστή.',
    more: 'περισσότερα',
    no_badge_yet: 'Δεν υπάρχουν ακόμα σήματα',
    competition_filter: 'Φίλτρο Διαγωνισμού',
    global_leaderboard: 'Παγκόσμια Κατάταξη',
    placeholder_for_the_global_leaderboard:
      'Αυτός είναι ένας χώρος κράτησης για την Παγκόσμια Κατάταξη.',
    badge_editor: 'Επεξεργαστής Σημάτων',
    adjust_the_appearance_of_this_badge_icon:
      'Προσαρμόστε την εμφάνιση αυτού του εικονιδίου σήματος. Οι αλλαγές εφαρμόζονται μόνο σε αυτό το σήμα.',
    badge_style: 'Στυλ Σήματος',
    the_image_must_be_pixels: 'Η εικόνα πρέπει να είναι 200x200 pixels.',
    badge_name: 'Όνομα Σήματος',
    badge_descrription: 'Περιγραφή Σήματος',
    enter_badge_criteria: 'Εισάγετε τα κριτήρια του σήματος',
    discard: 'Απόρριψη',
    badge_enable: 'Σήματα Ενεργοποιημένα',
    award_users_with_badges_to_highlight_the_milestones:
      'Απονείμετε σήματα στους χρήστες για να τονίσετε τα ορόσημα στο μαθησιακό τους ταξίδι.',
    badge_types: 'Τύποι Σημάτων',
    enable_or_disable_specific_badge_types_for_your_users:
      'Ενεργοποιήστε ή απενεργοποιήστε συγκεκριμένους τύπους σημάτων για τους χρήστες σας.',
    levels_enabled: 'Επίπεδα Ενεργοποιημένα',
    level_rules: 'Κανόνες Επιπέδου',
    points: 'Πόντοι',
    add_new_level: 'Προσθήκη Νέου Επιπέδου',
    add_level: 'Προσθήκη Επιπέδου',
    points_enabled: 'Πόντοι Ενεργοποιημένοι',
    learning_activities_and_encourage_healthy_competition:
      'Απονείμετε πόντους για διαφορετικές μαθησιακές δραστηριότητες και ενθαρρύνετε τον υγιή ανταγωνισμό.',
    award_points: 'Απονομή Πόντων',
    the_following_equates_the_value_of_one_item_completion:
      'Το ακόλουθο ισοδυναμεί με την ολοκλήρωση ενός στοιχείου',
    general: 'Γενικά',
    others: 'Άλλα',
    certificate: 'Πιστοποιητικό',
    quiz_passed: 'Το κουίζ περάστηκε',
    tip_approved: 'Συμβουλή Εγκρίθηκε',
    tip_liked: 'Συμβουλή Αρέσει',
    rewards: 'Ανταμοιβές',
    offer_discounts_when_learners_achieve:
      'Προσφέρετε εκπτώσεις όταν οι μαθητές επιτύχουν ένα σύνολο πόντων, σημάτων ή επιπέδων.',
    give_rewards: 'Δώστε Ανταμοιβές',
    discount_course_purchases_by: 'Έκπτωση στα μαθήματα κατά',
    with_points_more_than: 'με πόντους πάνω από',
    with_badges_more_than: 'με σήματα πάνω από',
    with_level_upwards_more_than: 'με επίπεδο άνω του',
    leaderboard: 'Κατάταξη',
    leaderboard_enabled: 'Κατάταξη Ενεργοποιημένη',
    leaderboards_offer_users_an_overview_of_their_learning_progress:
      'Οι κατατάξεις προσφέρουν στους χρήστες μια επισκόπηση της προόδου τους σε πόντους σε σύγκριση με τους άλλους.',
    show_levels: 'Εμφάνιση Επιπέδων',
    show_points: 'Εμφάνιση Πόντων',
    show_badges: 'Εμφάνιση Σημάτων',
    show_courses: 'Εμφάνιση Μαθημάτων',
    show_certificates: 'Εμφάνιση Πιστοποιητικών',
    leaderboard_settings: 'Ρυθμίσεις Κατάταξης',
    set_up_engaging_leaderboard_experiences_to_boost_learner_motivation:
      'Ρυθμίστε ενδιαφέρουσες εμπειρίες κατάταξης για να αυξήσετε το κίνητρο των μαθητών.',
    award_users_with_points_for_different_learning_activities:
      'Απονείμετε πόντους στους χρήστες για διαφορετικές μαθησιακές δραστηριότητες.',
    badge_set: 'Σετ Σημάτων',
    choose_the_type_of_badges_your_users:
      'Επιλέξτε τον τύπο των σημάτων που θα κερδίζουν οι χρήστες σας καθώς μαθαίνουν.',
    levels: 'Επίπεδα',
    Levels_represent_the_stages:
      'Τα επίπεδα αντιπροσωπεύουν τα στάδια στη μαθησιακή πορεία ενός χρήστη.',
    enabled: 'Ενεργοποιημένο',
    disabled: 'Απενεργοποιημένο',
    quick_select: 'Γρήγορη Επιλογή',
    yesterday: 'Χτες',
    last_week: 'Την προηγούμενη εβδομάδα',
    Last_month: 'Τον προηγούμενο μήνα',
    last_quarter: 'Το προηγούμενο τρίμηνο',
    historical_leaderboard: 'Ιστορική Κατάταξη',
    track_your_performance_and_see_how_you_rank_among_your_peers:
      'Παρακολουθήστε τις επιδόσεις σας και δείτε πώς κατατάσσεστε μεταξύ των συνομηλίκων σας',
    time_period: 'Περίοδος',
    page_of: 'Σελίδα 1 από 1',
    edit_competition: 'Επεξεργασία Διαγωνισμού',
    create_competition: 'Δημιουργία Διαγωνισμού',
    arrow_right: 'βέλος-δεξιά',
    update_competition: 'Ενημέρωση Διαγωνισμού',
    competition_title: 'Τίτλος Διαγωνισμού',
    enter_competition_title: 'Εισάγετε τίτλο διαγωνισμού',
    enter_competition_description: 'Εισάγετε περιγραφή διαγωνισμού',
    leaderboard_skill: 'Δεξιότητα',
    select_a_skill: 'Επιλέξτε μια δεξιότητα',
    no_skills_found: 'Δεν βρέθηκαν δεξιότητες',
    competition_period: 'Περίοδος Διαγωνισμού',
    add_badge_rule: 'Προσθήκη Κανόνα Σήματος',
    create_badge: 'Δημιουργία Σήματος',
    add_level_rule: 'Προσθήκη Κανόνα Επιπέδου',
    selected_participants: 'Επιλεγμένοι συμμετέχοντες',
    no_participants: 'Δεν υπάρχουν συμμετέχοντες',
    start_end_date: 'Ημερομηνία Έναρξης-Λήξης',
    created_date: 'Δημιουργήθηκε από',
    new_competition: 'Νέος Διαγωνισμός',
    competitions_list: 'Λίστα Διαγωνισμών',
    search_competitions: 'Αναζήτηση διαγωνισμών...',
    are_you_sure_you_want_to_delete_the_competition:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε τον διαγωνισμό;',
    history: 'Ιστορικό',
    export: 'Εξαγωγή',
    search_by_name: 'Αναζήτηση με όνομα...',
    no_historical_data_available_for_the_selected_period:
      'Δεν υπάρχουν ιστορικά δεδομένα για την επιλεγμένη περίοδο.',
    no_leaderboard_data_available: 'Δεν υπάρχουν δεδομένα κατάταξης.',
    competitions: 'Διαγωνισμοί',
    leaderboards: 'Κατατάξεις',
    welcome_back: 'Καλώς ήρθατε ξανά',
    track_your_performance_and_see:
      'Παρακολουθήστε τις επιδόσεις σας και δείτε πώς κατατάσσεστε μεταξύ των συνομηλίκων σας',
    team_leaderboard: 'Κατάταξη Ομάδας',
    try_again: 'Δοκιμάστε ξανά',
    no_competitions_for_search: 'Δεν υπάρχουν διαθέσιμοι διαγωνισμοί για',
    no_competitions_available: 'Δεν υπάρχουν διαθέσιμοι διαγωνισμοί',
    no_competitions_matching_search:
      'Δεν βρέθηκαν διαγωνισμοί που να ταιριάζουν στην αναζήτησή σας. Δοκιμάστε να προσαρμόσετε τους όρους αναζήτησης ή ελέγξτε αργότερα για νέους διαγωνισμούς.',
    no_competitions_general:
      'Δεν υπάρχουν διαγωνισμοί αυτήν τη στιγμή. Επιστρέψτε αργότερα ή επικοινωνήστε με τον διαχειριστή σας για να δημιουργήσετε νέους διαγωνισμούς.',
    media_management: 'Διαχείριση Μέσων',
    badgess_set: 'Σετ Σημάτων',
    choose_the_default_visual_style_for_badge:
      'Επιλέξτε το προεπιλεγμένο οπτικό στυλ για τα εικονίδια σήματος που χρησιμοποιούνται στην πλατφόρμα.',
    enable_badges: 'Ενεργοποίηση Σημάτων',
    add_badge: 'Προσθήκη Σήματος',
    min: 'Ελάχ',
    max: 'Μέγ',
    your_rank: 'Η Κατάταξή σας',
    your_points: 'Οι Πόντοι σας',
    your_level: 'Το Επίπεδό σας',
    rank: 'Κατάταξη #',
    level: 'Επίπεδο',
    progress: 'Πρόοδος',
    new_folder: 'Νέος Φάκελος',
    file_upload: 'Ανέβασμα Αρχείου',
    writer: 'Συγγραφέας',
    text_documents: 'Έγγραφα Κειμένου',
    spreadsheets: 'Φύλλα Εργασίας',
    impress: 'Impress',
    presentations: 'Παρουσιάσεις',
    capture_desktop_screen: 'Καταγραφή Οθόνης Υπολογιστή',
    capture_desktop_screens: 'Καταγραφή Οθονών Υπολογιστή',
    your_documents: 'Τα Έγγραφά σας',
    manage_your_videos_images_audio_files:
      'Διαχειριστείτε τα βίντεο, εικόνες, αρχεία ήχου και άλλα στοιχεία που χρησιμοποιούνται στη δημιουργία περιεχομένου σας.',
    your_organization_documents: 'Έγγραφα Οργάνωσής σας',
    keep_your_organization_creative_assets_organized:
      'Κρατήστε τα δημιουργικά στοιχεία της οργάνωσής σας οργανωμένα και προσβάσιμα—βελτιστοποιήστε τη συνεργασία και την παραγωγή περιεχομένου.',
    your_public_documents: 'Δημόσια Έγγραφα',
    curated_collection_of_media_assets_available:
      'Μια επιμελημένη συλλογή μέσων διαθέσιμη σε όλους—εξερευνήστε, επαναχρησιμοποιήστε και δημιουργήστε.',
    your_download_center_documents: 'Έγγραφα Κέντρου Λήψεων',
    repository_of_approved_media_assets_for_download:
      'Αποθετήριο εγκεκριμένων μέσων για λήψη και χρήση στα έργα σας.',
    search_files_and_folders: 'Αναζήτηση αρχείων και φακέλων...',
    home: 'Αρχική',
    folders: 'Φάκελοι',
    folder_name: 'Όνομα Φακέλου',
    owner: 'Ιδιοκτήτης',
    last_updated: 'Τελευταία Ενημέρωση',
    action: 'Ενέργεια',
    no_folders_found: 'Δεν βρέθηκαν φάκελοι',
    files: 'Αρχεία',
    enabling_ai: 'Ενεργοποίηση AI...',
    rename: 'Μετονομασία',
    copy: 'Αντιγραφή',
    move: 'Μετακίνηση',
    verson_history: 'Ιστορικό Εκδόσεων',
    manage_permission: 'Διαχείριση Δικαιωμάτων',
    generate_audit_report: 'Δημιουργία Αναφοράς Ελέγχου',
    last_edited: 'Τελευταία Επεξεργασία',
    no_files_found: 'Δεν βρέθηκαν αρχεία',
    are_you_sure_you_want_to_make_this_item_public:
      'Είστε σίγουροι ότι θέλετε να κάνετε αυτό το αντικείμενο δημόσιο; Θα αντιγραφεί στη δημόσια βιβλιοθήκη σας.',
    move_to_organization: 'Μετακίνηση στην Οργάνωση',
    are_you_sure_you_want_to_copy_this_item_to_your_organization_library:
      'Είστε σίγουροι ότι θέλετε να αντιγράψετε αυτό το αντικείμενο στη βιβλιοθήκη της οργάνωσής σας;',
    are_you_sure_you_want_to_make_this_item_private:
      'Είστε σίγουροι ότι θέλετε να κάνετε αυτό το αντικείμενο ιδιωτικό; Θα αντιγραφεί στη δική σας βιβλιοθήκη.',
    date_modified: 'Ημερομηνία Τροποποίησης',
    workflow_management: 'Διαχείριση Ροής Εργασίας',
    configure_editors_approvers_and_viewers_for_this_document:
      'Διαμορφώστε τους επεξεργαστές, εγκριτές και θεατές για αυτό το έγγραφο.',
    error_Loading_editor: 'Σφάλμα Φόρτωσης Επεξεργαστή',
    debug_info: 'Πληροφορίες Αποσφαλμάτωσης',
    loading_editor: 'Φόρτωση Επεξεργαστή...',
    submitted_for_review: 'Υποβλήθηκε για Ανασκόπηση',
    editors: 'Επεξεργαστές',
    no_editors_added_yet:
      'Δεν έχουν προστεθεί ακόμη επεξεργαστές. Κάντε κλικ στο "Προσθήκη επεξεργαστή" για να προσθέσετε έναν.',
    add_editor: 'Προσθήκη Επεξεργαστή',
    approvers: 'Εγκριτές',
    no_approvers_added_yet:
      'Δεν έχουν προστεθεί ακόμη εγκριτές. Κάντε κλικ στο "Προσθήκη εγκριτή" για να προσθέσετε έναν.',
    add_approvers: 'Προσθήκη Εγκριτών',
    viewer: 'Θεατής',
    no_viewers_added_yet:
      'Δεν έχουν προστεθεί ακόμη θεατές. Κάντε κλικ στο "Προσθήκη θεατή" για να προσθέσετε έναν.',
    add_viewer: 'Προσθήκη Θεατή',
    are_you_sure_you_want_to_delete_the_selected_items:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε τα επιλεγμένα αντικείμενα;'
  },
  v3: {
    reportShareSphere: 'SHARESPHERE',
    overview: 'Επισκόπηση Κατηγορίας',
    triviaReport: 'Κατηγορία ShareSphere',
    overviewGraph: 'Γράφημα Επισκόπησης Κατηγορίας',
    category: 'Κατηγορία',
    phCategory: 'Επιλέξτε Κατηγορία',
    podcast: 'Podcast, Μουσική και Ιστορίες',
    pastPodcast: 'Προηγούμενα Podcast',
    upcomingPodcast: 'Επερχόμενα Podcast',
    podcastLanguageTitle: 'Γλώσσα podcast, μουσικής & ιστοριών',
    podcastLanguageCheckbox: 'AI δημιουργεί γλώσσα για το podcast μου',
    howRate: 'Πώς θα αξιολογούσατε αυτό το podcast;',
    podcastSubmit: 'Υποβολή',
    podcastGuest: 'Καλεσμένος Ομιλητής:',
    podcastReview: 'Αξιολογήσεις',
    podcastEpishode: 'Επεισόδια',
    podcastEnd: 'Το podcast έχει τελειώσει',
    date_podcast: 'Ημερομηνία Podcast',
    skill_not_found: 'Λυπούμαστε! Δεν βρέθηκε διαδρομή δεξιοτήτων.',
    coaching: 'Καθοδήγηση',
    webinar: 'Διαδικτυακό Σεμινάριο',
    public_conference: 'Δημόσιο Συνέδριο',
    skill_journey_subtitle:
      'Προσθέστε ρυθμίσεις στη διαδρομή δεξιοτήτων σας και επιλέξτε ποιος μπορεί να δει και να αλληλεπιδράσει με αυτή.',
    enable_white_label: 'Ενεργοποίηση white label',
    create_new_event_org: 'Δημιουργήστε ένα νέο γεγονός για τον οργανισμό σας.',
    create_new_event_marketplace: 'Δημιουργήστε ένα νέο γεγονός για την αγορά.',
    create_new_event_both:
      'Δημιουργήστε νέο γεγονός τόσο για τον οργανισμό σας όσο και για την αγορά.',
    event_outline: 'Παρακαλώ εισάγετε το περίγραμμα του γεγονότος',
    event_obj: 'Παρακαλώ εισάγετε τους στόχους του γεγονότος',
    event_description: 'Παρακαλώ εισάγετε την περιγραφή του γεγονότος',
    create_new_metamaze_org:
      'Δημιουργήστε ένα νέο MetaMaze για τον οργανισμό σας.',
    create_new_metamaze_marketplace:
      'Δημιουργήστε ένα νέο MetaMaze για την αγορά.',
    create_new_metamaze_both:
      'Δημιουργήστε νέο MetaMaze και για τον οργανισμό σας και για την αγορά.',
    add_key_words: 'Προσθέστε λέξεις-κλειδιά',
    press_enter_make_keyword:
      'Πατήστε Enter για να δημιουργήσετε μια λέξη-κλειδί',
    disable_skip_quiz: 'Απενεργοποίηση παράκαμψης κουίζ',
    warning_complete_quiz: 'Παρακαλώ ολοκληρώστε το κουίζ για να προχωρήσετε.',
    signup_email_verification:
      'Στείλαμε έναν σύνδεσμο επαλήθευσης στη διεύθυνση email που δώσατε. Παρακαλώ επισκεφτείτε αυτόν το σύνδεσμο για να επιβεβαιώσετε την εγγραφή σας.',
    verifying_registration: 'Επαλήθευση εγγραφής λογαριασμού...',
    reset_password_linK:
      'Στείλαμε έναν σύνδεσμο στη διεύθυνση email που δώσατε. Παρακαλώ επισκεφτείτε αυτόν το σύνδεσμο για να ορίσετε νέο κωδικό πρόσβασης.',
    reset_email_error:
      'Δεν βρέθηκε χρήστης με αυτό το email, δοκιμάστε ξανά χρησιμοποιώντας το όνομα χρήστη!',
    first_name: 'Όνομα',
    last_name: 'Επίθετο',
    error_firstName: 'Παρακαλώ εισάγετε το όνομά σας',
    error_sharebot_organization: 'Παρακαλώ εισάγετε τον οργανισμό σας',
    error_lastName: 'Παρακαλώ εισάγετε το επίθετό σας',
    private_conference: 'Ιδιωτικό Συνέδριο',
    public_conference: 'Δημόσιο Συνέδριο',
    discussion_room: 'Αίθουσα Συζήτησης',
    training_no_courses: 'Δεν είστε εγγεγραμμένος σε κανένα μάθημα.',
    training_no_events: 'Δεν είστε εγγεγραμμένος σε κανένα γεγονός',
    allow_sharing_trainer_info:
      'Επιτρέψτε την κοινοποίηση της διεύθυνσης email στην αγορά',
    error_username_space: 'Το όνομα χρήστη δεν μπορεί να έχει κενά.',
    error_sharebot_organization_space: 'Ο οργανισμός δεν μπορεί να έχει κενά.',
    edit_permission: 'Δικαίωμα επεξεργασίας',
    valid_price: 'Η τιμή πρέπει να είναι μεγαλύτερη από 0',
    course_price_message: `*το μάθημα θα δημοσιευτεί μόνο στον αριθμό των χρηστών που αγόρασε ο οργανισμός και δεν
θα μπορεί να μεταπωληθεί στην αγορά`,
    valid_edit_price:
      'Η τιμή επεξεργασίας πρέπει να είναι μικρότερη από την τιμή αγοράς.',
    my_calendar: 'Το Ημερολόγιό Μου',
    error_valid_firstName: 'Παρακαλώ εισάγετε ένα έγκυρο όνομα.',
    error_valid_organization: 'Παρακαλώ εισάγετε ένα έγκυρο όνομα οργανισμού.',
    error_valid_lastName: 'Παρακαλώ εισάγετε ένα έγκυρο επίθετο.',
    error_name_spaces: 'Το όνομα δεν μπορεί να έχει κενά',
    items: 'Αντικείμενα',
    publish_to_channel: 'Δημοσίευση στη συλλογή καναλιών μου',
    create_a_channel: 'Δημιουργία Καναλιού',
    create_a_trivia: 'Παιχνίδι Ερωτήσεων',
    create_a_new_channel: 'Δημιουργία Νέου Καναλιού',
    add_videos: 'Προσθήκη Βίντεο',
    save_and_continue: 'Αποθήκευση & Συνέχεια',
    channel: 'Κανάλι',
    channels: 'Κανάλια',
    view_channel: 'Προβολή Καναλιού',
    edit_channel: 'Επεξεργασία Καναλιού',
    delete_channel: 'Διαγραφή Καναλιού',
    my_video_channels: 'Τα Βίντεο Κανάλια Μου',
    training_no_channel: 'Δεν είστε εγγεγραμμένος σε κανάλι.',
    monthly_price_required: 'Απαιτείται μηνιαία τιμή',
    yearly_price_required: 'Απαιτείται ετήσια τιμή',
    one_time_price_required: 'Απαιτείται εφάπαξ τιμή',
    marketplace_quantity: 'USD',
    report_webinar: 'ΔΙΑΔΙΚΤΥΑΚΟ ΣΕΜΙΝΑΡΙΟ',
    report_coaching: 'ΚΑΘΟΔΗΓΗΣΗ',
    report_channel: 'ΚΑΝΑΛΙ',
    report_public_conference: 'ΔΗΜΟΣΙΟ ΣΥΝΕΔΡΙΟ',
    report_maze: 'ΛΑΒΥΡΙΝΘΟΣ',
    channel: 'Κανάλι',
    edit_price: 'Επεξεργασία Τιμής ($)',
    quantity: 'Ποσότητα',
    payment_type: 'Τύπος Πληρωμής',
    total_amount: 'Συνολικό Ποσό ($)',
    net_amount: 'Καθαρό Ποσό ($)',
    edit_option: 'Επιλογή Επεξεργασίας',
    marketplace_price: 'Τιμή ($)',
    market_name: 'Όνομα',
    duration_min: 'Διάρκεια (λεπτά)',
    users_total: 'Χρήστες (Σύνολο)',
    sales_total: 'Σύνολο Πωλήσεων (USD)',
    search_coaching: 'Αναζήτηση Καθοδήγησης',
    search_channel: 'Αναζήτηση Καναλιού',
    search_webinar: 'Αναζήτηση Διαδικτυακού Σεμιναρίου',
    search_maze: 'Αναζήτηση Λαβυρίνθου',
    search_public_conference: 'Αναζήτηση Δημόσιου Συνεδρίου',
    buyer_type: 'Τύπος Αγοραστή',
    quanity: 'Ποσότητα',
    channel_unit_amount: 'Καθαρό Ποσό ($)',
    channel_updated_at: 'Ημερομηνία Ενημέρωσης',
    month_price: 'Τιμή (Μήνας)',
    year_price: 'Τιμή (Έτος)',
    one_time_price: 'Τιμή (Εφάπαξ)',
    sharebot_organization: 'Προσθήκη νέου ονόματος οργανισμού',
    share_sphere: 'ShareSphere',
    ai_course_title: 'Τίτλος μαθήματος',
    ai_input_course_title: 'Παρακαλώ εισάγετε τον τίτλο του μαθήματος!',
    learning_objective_label: 'Στόχος μάθησης',
    learning_objective_message: 'Παρακαλώ εισάγετε τον στόχο μάθησης!',
    standard_question:
      'Υπάρχει κάποιο πρότυπο που πρέπει να ακολουθήσει ο μαθητής;',
    standard_details_label: 'Λεπτομέρειες προτύπου',
    standard_details_message:
      'Παρακαλώ εισάγετε τις λεπτομέρειες του προτύπου!',
    estimated_duration_label: 'Εκτιμώμενη διάρκεια μαθήματος (σε λεπτά)',
    estimated_duration_message: 'Παρακαλώ εισάγετε την εκτιμώμενη διάρκεια!',
    min_duration_message: 'Η ελάχιστη διάρκεια είναι 5 λεπτά.',
    ai_mins: '25 λεπτά',
    industry_specific_question: 'Είναι συγκεκριμένο για κάποιον κλάδο;',
    industry_label: 'Καθορίστε τον κλάδο',
    industry_message: 'Παρακαλώ εισάγετε τον κλάδο!',
    ai_course_creation: 'Δημιουργία μαθήματος με AI',
    course_generated: 'Μάθημα που δημιουργήθηκε από το Sharelook',
    ai: 'AI',
    ai_you: 'Εσείς',
    ai_prompt_ready:
      'Η εντολή σας είναι έτοιμη. Τώρα μπορείτε να δημιουργήσετε το περιεχόμενο του μαθήματος.',
    ai_unable_respond:
      'Λυπούμαστε! Το AI δεν μπορεί να ανταποκριθεί στην εντολή σας. Παρακαλώ δοκιμάστε ξανά.',
    ai_hide_toc: 'Απόκρυψη πίνακα περιεχομένων',
    ai_preview_toc: 'Προεπισκόπηση πίνακα περιεχομένων',
    ai_generate_toc_now: 'Δημιουργήστε τώρα τον πίνακα περιεχομένων',
    ai_creation_course_title: 'Τίτλος μαθήματος:',
    ai_creation_industry_specific: 'Είναι συγκεκριμένο για κάποιον κλάδο:',
    ai_creation_industry: 'Κλάδος:',
    ai_creation_standard_needed:
      'Υπάρχει κάποιο πρότυπο που πρέπει να ακολουθήσει ο μαθητής;',
    ai_creation_standard_details: 'Λεπτομέρειες προτύπου:',
    ai_creation_estimated_duration: 'Εκτιμώμενη διάρκεια μαθήματος (σε λεπτά):',
    minutes: 'λεπτά',
    ai_creation_learning_objective: 'Στόχος μάθησης:',
    setup_again: 'Ρύθμιση ξανά',
    ai_creation_confirm_title:
      'Είστε σίγουροι ότι θέλετε να ρυθμίσετε ξανά τη φόρμα;',
    ai_creation_confirm_content:
      'Η συνομιλία και όλο το παραγόμενο περιεχόμενο θα επαναρυθμιστούν.',
    ai_toc: 'Πίνακας περιεχομένων',
    ai_note_topic:
      'Σημείωση: Μπορείτε να σύρετε και να αποθέσετε για να αναδιοργανώσετε τα θέματα στο μάθημα.',
    ai_add_topic: '+ Προσθήκη θέματος',
    add_topic: 'Προσθήκη θέματος',
    add_lesson: 'Προσθήκη μαθήματος',
    add_new_lesson: 'Προσθήκη νέου μαθήματος',
    ai_add_lesson: '+ Προσθήκη μαθήματος',
    attention: 'Προσοχή',
    before_varifying: 'Πριν την επαλήθευση',
    ai_save_later: 'Αποθήκευση για αργότερα',
    ai_download_word_doc: 'Λήψη σε αρχείο Word',
    ai_download_course_word_doc: 'Λήψη μαθήματος σε αρχείο Word',
    ai_create_course_button: 'Δημιουργία μαθήματος',
    ai_generate_course_content: 'Δημιουργία περιεχομένου μαθήματος',
    ai_out_of: 'από',
    ai_subtopic_failed_content:
      "τα υποθέματα δεν μπόρεσαν να δημιουργήσουν περιεχόμενο. Κάντε κλικ ξανά στο 'Δημιουργία περιεχομένου μαθήματος' για να δημιουργηθεί περιεχόμενο μόνο για αυτά τα υποθέματα.",
    ai_edit_topic: 'Επεξεργασία θέματος',
    ai_edit_lesson_title: 'Επεξεργασία τίτλου μαθήματος',
    ai_save_topic: 'Αποθήκευση θέματος',
    ai_save: 'Αποθήκευση',
    ai_save_lesson_title: 'Αποθήκευση τίτλου μαθήματος',
    ai_add_new_topic: 'Προσθήκη νέου θέματος',
    ai_download_ref: 'Λήψη με αναφορές',
    ai_download_ref_content:
      'Αυτό θα κατεβάσει το μάθημα σε αρχείο Word με τις αναφορές.',
    ai_download_without_ref: 'Λήψη χωρίς αναφορές',
    ai_download_two_word: 'Θα κατέβουν δύο αρχεία Word:',
    ai_download_two_word_content_one:
      '- ένα που περιέχει το κύριο περιεχόμενο χωρίς αναφορές,',
    ai_download_two_word_content_two:
      'και το άλλο που περιέχει μόνο τη λίστα αναφορών χωρίς συσχετισμένο περιεχόμενο.',
    ai_manage_content: 'Διαχείριση περιεχομένου',
    ai_add_content_from_internet: '+ Προσθήκη περιεχομένου από το Διαδίκτυο',
    ai_confirm_start: 'Επιβεβαίωση έναρξης',
    ai_Verify: 'Επαλήθευση',
    ai_undo_warning:
      'Αυτή η διαδικασία μπορεί να διαρκέσει. Παρακαλώ μην κλείσετε αυτό το παράθυρο μέχρι να ολοκληρωθεί η δημιουργία γιατί δεν μπορεί να αναιρεθεί.',
    ai_verified_content:
      'Έχετε επαληθεύσει το περιεχόμενο. Μετά την επιβεβαίωση, δεν θα μπορείτε να επιστρέψετε στη συνομιλία με τον βοηθό AI με το τρέχον περιεχόμενο.',
    ai_want_proceed: 'Είστε σίγουροι ότι θέλετε να συνεχίσετε;',
    upload_simulation: 'Ανέβασμα προσομοίωσης',
    name_simulation: 'Όνομα προσομοίωσης',
    selected_simulation_files: 'Επιλεγμένα αρχεία προσομοίωσης',
    score_between_one_hundred:
      'Η βαθμολογία σας πρέπει να είναι μεταξύ 1 και 100.',
    are_sure_simulation:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το αρχείο προσομοίωσης;',
    required_simulation: 'Η βαθμολογία απαιτείται',
    required_section_file: 'Το αρχείο ενότητας απαιτείται',
    simulation: 'Προσομοίωση',
    simulation_quiz_games: 'Χρειάζεται να προσθέσετε κουίζ στα παιχνίδια',
    simulation_alert_des:
      'Μπορείτε να προσθέσετε παιχνίδια μόνο εάν όλες οι ερωτήσεις έχουν τύπο απάντησης μοναδική ή πολλαπλή επιλογή.',
    alert_info: 'πληροφορίες',
    ai_number_quiz: 'Αριθμός κουίζ',
    ai_point: 'Βαθμός',
    ai_points: 'Βαθμοί',
    val_required: 'Απαιτείται',
    games: 'Παιχνίδια',
    add_simulation: 'Προσθήκη προσομοίωσης',
    text_tiewer: 'Προβολέας κειμένου',
    back_to_account: 'Επιστροφή στον λογαριασμό',
    delete_account: 'Διαγραφή λογαριασμού',
    delete_account_title: 'Διαγραφή λογαριασμού ???',
    delete_account_subtitle: 'Μπορείτε να διαγράψετε τον λογαριασμό σας εδώ.',
    delete_account_cannot_undo:
      'Είστε έτοιμοι να διαγράψετε τον λογαριασμό σας. Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    account_org_profile:
      'Θα χάσετε επίσης όλα τα μαθήματα που έχετε δημιουργήσει, το προφίλ της οργάνωσής σας και όλες τις ρυθμίσεις σας.',
    deleting_account_database:
      'Η διαγραφή του λογαριασμού σας θα διαγράψει όλα τα δεδομένα σας από τη βάση δεδομένων μας.',
    account_confirm_delete:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε τον λογαριασμό σας;',
    action_cannot_be_undone: 'Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    account_delete_message_success: 'Ο λογαριασμός σας διαγράφηκε με επιτυχία.',
    message_edit: 'Επεξεργασία',
    message_delete: 'Διαγραφή',
    message_reply: 'Απάντηση',
    attached_file: 'Συνημμένο αρχείο',
    attach_file: 'Επισύναψη αρχείου',
    attach_des: '25MB, μέγιστο μέγεθος αρχείου',
    view: 'Προβολή',
    go_to_marketplace: 'Μετάβαση στην αγορά',
    learning_center: 'Κέντρο μάθησης',
    knowledge_center: 'Κέντρο γνώσης',
    sharebot: 'ShareBot',
    sharebot_help_message: 'Πώς μπορώ να σας βοηθήσω σήμερα;',
    my_organization: 'Οργάνωσή μου',
    world_knowledge: 'Παγκόσμια γνώση',
    welcome_to_sharelook: 'Καλώς ήρθατε στο Sharelook!',
    sharelook_you_want_go: 'Πού θέλετε να πάτε σήμερα;',
    shareLook_learning_management_system:
      'Πρόσβαση στο σύστημα διαχείρισης μάθησης ShareLook για να δημιουργήσετε ή να αποκτήσετε πρόσβαση σε εκπαιδευτικούς πόρους όπως ζωντανές εκδηλώσεις και μαθήματα στην οργάνωσή σας στο ShareLook.',
    shareLook_powerful_ai_system:
      'Πρόσβαση στο ισχυρό σύστημα AI του ShareLook όπου μπορείτε να ανεβάσετε αρχεία pdf και να λάβετε χρήσιμες πληροφορίες μέσα σε λίγα δευτερόλεπτα. Λάβετε γρήγορες απαντήσεις βασισμένες σε πόρους που έχουν ανέβει στην οργάνωσή σας ή απαντήσεις από το γενικό AI σύστημα μας στην ενότητα παγκόσμιας γνώσης.',
    edit_now: 'Επεξεργασία τώρα',
    sharelook_log_out:
      'Έχετε αποσυνδεθεί από το Sharelook. Παρακαλώ συνδεθείτε ξανά!',
    sorry_error: 'Συγγνώμη! Συναντήσαμε ένα σφάλμα.',
    login: 'Σύνδεση',
    refresh_page: 'Ανανέωση σελίδας',
    just_a_moment: 'Λίγο υπομονή',
    enter_lname_fname:
      'Παρακαλώ εισάγετε το όνομα και επώνυμό σας για να συνεχίσετε.',
    procced_to_sharelook: 'Προχωρήστε στο Sharelook',
    option_one: 'Επιλογή 1',
    option_two: 'Επιλογή 2',
    selected_image: 'Επιλεγμένη εικόνα:',
    add_text: 'Προσθήκη κειμένου',
    linkdin_is_required: 'Το LinkedIn απαιτείται.',
    bio_is_required: 'Η βιογραφία απαιτείται.',
    save_user_information: 'Αποθήκευση πληροφοριών χρήστη',
    select_all: 'Επιλογή όλων',
    enable_ai: 'Ενεργοποίηση AI',
    load_more: 'Φόρτωση περισσότερων',
    channel_id: 'Αναγνωριστικό καναλιού.',
    send: 'Αποστολή',
    v4: 'Πληροφορίες',
    subscription: 'Συνδρομή',
    reset_user_flag: 'ΕΠΑΝΑΦΟΡΑ ΣΗΜΑ ΧΡΗΣΤΗ',
    delete_my_accont: 'Διαγραφή του λογαριασμού μου',
    sharebot_sub_error:
      'Σφάλμα κατά την ανάκτηση των συνδρομών. Παρακαλώ δοκιμάστε ξανά!',
    sharebot_no_sub: 'Δεν έχετε ενεργή συνδρομή αυτή τη στιγμή.',
    sharebot_dont_sub: 'Δεν έχετε προηγούμενη συνδρομή.',
    sharebot_prev_sub: 'Προηγούμενες συνδρομές',
    sharebot_sub: 'Συνδρομή ShareBot',
    sharebot_un_sub: 'Κατάργηση συνδρομής ShareBot',
    sharebot_no_available: 'Δεν υπάρχει διαθέσιμη περιγραφή',
    sharebot_start_date: 'Ημερομηνία έναρξης:',
    sharebot_end_date: 'Ημερομηνία λήξης:',
    sharebot_sure: 'Είστε σίγουροι;',
    sharebot_do_you_want: 'Θέλετε να',
    unsubscribe: 'καταργήσετε τη συνδρομή σας',
    unsubscribe_what: 'καταργήσετε τη συνδρομή σας;',
    subscribe: 'εγγραφείτε',
    subscribe_what: 'εγγραφείτε;',
    subscribe_now: 'Εγγραφείτε τώρα',
    confirm: 'Επιβεβαίωση',
    sharebot_intel_knowledge_center: 'Κέντρο ευφυούς γνώσης ShareBot',
    sharebot_welcome_paragraph:
      'Καλώς ήρθατε στο Κέντρο γνώσης ShareBot, το προηγμένο chatbot AI σχεδιασμένο να μεταμορφώσει τον τρόπο που οι επαγγελματίες αποκτούν πληροφορίες και συνεργάζονται.',
    expired: 'Ληγμένο',
    active: 'Ενεργό',
    Inactive: 'Ανενεργό',
    yearly_subscription: 'Ετήσια συνδρομή',
    monthly_subscription: 'Μηνιαία συνδρομή',
    no_sharebot_org: 'Δεν έχετε οργανισμό ShareBot',
    sharebot_start_free_trial: 'Ξεκινήστε τη δωρεάν δοκιμή',
    sub_month: 'Μηνιαία συνδρομή',
    sub_year: 'Ετήσια συνδρομή',
    question_per_month: 'Αποθήκευση (1 TB) και 1000 ερωτήσεις εφ’ όρου ζωής',
    sharebot_para:
      'Συνεχίζοντας, επιβεβαιώνετε ότι θέλετε να διαγράψετε μόνιμα τον οργανισμό. Αυτή η ενέργεια θα αφαιρέσει όλους τους πολύτιμους πόρους του ShareBot και δεν μπορεί να αναιρεθεί.',
    cancelled_date: 'Ημερομηνία ακύρωσης:',
    live_straming_para:
      'Για να αλλάξετε το μηνιαίο όριο ζωντανής μετάδοσης, επικοινωνήστε με',
    sharelook_agree: 'Συμφωνώ με τους',
    terms_condition: 'Όρους Χρήσης του Sharelook',
    and: 'και',
    privacy_policy: 'Πολιτική Απορρήτου',
    save_for_later: 'Αποθήκευση για αργότερα',
    ai: 'AI',
    no_video_yet: 'Δεν έχει επιλεγεί βίντεο!',
    are_you_sure_delete_video:
      'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το βίντεο;',
    video_des: 'Περιγραφή',
    video_now: 'Τώρα',
    video_playing: 'Αναπαραγωγή:',
    video_no: 'Βίντεο Νο.',
    ai_generated_course: 'Μάθημα που δημιουργήθηκε από AI',
    create_course_on_our_own: 'Δημιουργία μαθήματος με το χέρι',
    ai_Assisted_ourse_reation: 'Δημιουργία μαθήματος με βοήθεια AI',
    pending: 'Εκκρεμεί',
    published: 'Δημοσιευμένο',
    intro_course: 'Προσθήκη στην εισαγωγή του μαθήματος;',
    clone_course: 'Θέλετε να κλωνοποιήσετε αυτό το μάθημα;',
    browser_audio_not_support:
      'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει το στοιχείο ήχου.',
    audio_popup_content:
      'Μπορείτε να προσθέσετε πολλαπλά αρχεία ήχου σύμφωνα με το κείμενό σας — το Lorem Ipsum είναι απλό κείμενο που χρησιμοποιείται από τη δεκαετία του 1500.',
    close: 'Κλείσιμο',
    podcast_rec: 'ΗΧΟΓΡΑΦΗΣΗ',
    create_podcast: 'Δημιουργία podcast',
    add_admin: 'Προσθήκη διαχειριστή',
    delete_all: 'Διαγραφή όλων',
    ai_podcast_audio: 'AI ήχος podcast',
    language: 'Γλώσσα',
    podcast_download_content:
      '*Μπορείτε να κατεβάσετε τον AI μεταφρασμένο ήχο και να τον επεξεργαστείτε με το δικό σας πρόγραμμα επεξεργασίας.',
    upload_audio: 'Μεταφόρτωση ήχου',
    browser_do_not_support_audio:
      'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει το στοιχείο ήχου.',
    upload_cover: 'Μεταφόρτωση εικόνας εξωφύλλου',
    upload_ai_creator: 'Προσθήκη δημιουργού AI',
    required_cover_image: 'Απαιτείται εικόνα εξωφύλλου!',
    room_required_name: 'Απαιτείται όνομα podcast!',
    add_guest_list: 'Προσθέστε προσκεκλημένους!',
    podcast_add_participants: 'Προσθήκη συμμετεχόντων',
    topic_required: 'Απαιτείται τουλάχιστον ένα θέμα',
    podcast_description: 'Περιγραφή',
    podcast_date: 'Ημερομηνία',
    date: 'Ημερομηνία',
    podcast_time: 'Ώρα',
    podcast_to: 'έως',
    podcast_all_day: 'Όλη μέρα',
    podcast_start_date_time: 'Απαιτείται ημερομηνία και ώρα έναρξης!',
    podcast_id: 'ID',
    selected_user: 'Προσκαλεσμένοι χρήστες',
    see_more: 'Δείτε περισσότερα',
    see_less: 'Δείτε λιγότερα',
    no_review_yet: 'Καμία αξιολόγηση ακόμα — γίνε ο πρώτος!',
    request_to_speak: 'Αποδοχή αιτήματος ομιλίας αυτού του χρήστη;',
    kick_user: 'Θέλετε να απομακρύνετε αυτόν τον χρήστη;',
    accept_request: 'Αποδοχή αιτήματος',
    kick: 'Απομάκρυνση',
    started: 'Ξεκίνησε',
    end: 'Τέλος',
    join_now: 'Συμμετοχή τώρα',
    podcast_end: 'Το podcast έχει τελειώσει',
    connecting: 'Σύνδεση...',
    knowledge_center_know_today: 'Τι θέλετε να μάθετε σήμερα;',
    knowledge_center_question: 'Πληκτρολογήστε την ερώτησή σας',
    knowledge_center_error: 'Συγγνώμη! Παρουσιάστηκε σφάλμα.',
    knowledge_center_tooltrip:
      'Αποκτήστε πρόσβαση στους πόρους μάθησης της ομάδας σας και ανεβάστε αρχεία PDF.',
    my_organization: 'Ο οργανισμός μου',
    world_knowledge: 'Παγκόσμια γνώση',
    open_file: 'Άνοιγμα αρχείου',
    reference: 'Αναφορά',
    are_you_cancel: 'Είστε σίγουροι ότι θέλετε να ακυρώσετε;',
    are_you_remove_media:
      'Είστε σίγουροι ότι θέλετε να αφαιρέσετε αυτό το μέσο;',
    terms_agree: 'Συμφωνώ με τους όρους',
    ready: 'Έτοιμο',
    send_email: 'Αποστολή email',
    active_users: 'Ενεργοί χρήστες',
    sign_up_user: 'Εγγεγραμμένοι χρήστες',
    non_sign_up_user: 'Μη εγγεγραμμένοι χρήστες',
    organisation: 'Οργανισμός',
    usage_report: 'Αναφορά χρήσης',
    check_email: 'Ελέγξτε το email σας',
    delete_schedule: 'Διαγραφή προγράμματος',
    are_you_sure_delete_schedule:
      'Θέλετε σίγουρα να διαγράψετε αυτό το πρόγραμμα;',
    add_task: 'Προσθήκη εργασίας',
    coaching_available: 'Διαθέσιμο για coaching',
    message_booking_coaching:
      'Αυτή η ώρα έχει ήδη κρατηθεί για συνεδρία coaching.',
    task_day: 'Ημέρα εργασίας',
    created_task_day: 'Έχει ήδη δημιουργηθεί εργασία για σήμερα.',
    event_day: 'Ημέρα εκδήλωσης',
    has_booked_coaching:
      'Έχει ήδη προγραμματιστεί συνεδρία coaching για αυτήν την ημέρα.',
    active_day: 'Ενεργή ημέρα',
    selectable_time_slots:
      'Οι διαθέσιμες ώρες επιλέγονται κάνοντας κλικ σε μια ενεργή ημέρα.',
    compare_last_month: 'Σύγκριση με τον προηγούμενο μήνα',
    uploading_file: 'Μεταφόρτωση αρχείου',
    attach_file_course: 'Επισύναψη αρχείου στο μάθημα',
    fetch_request: 'Ανάκτηση αιτήματος',
    finilize_upload: 'Ολοκλήρωση μεταφόρτωσης',
    scorm_scanned: 'Παρακαλώ περιμένετε... έλεγχος αρχείου SCORM.',
    scan_status: 'Κατάσταση σάρωσης:',
    scan_completed: 'Η σάρωση ολοκληρώθηκε. Το αρχείο είναι',
    scan_progress: 'Σάρωση σε εξέλιξη...',
    check_scorm: 'Έλεγχος αρχείου SCORM...',
    file_check_success: 'Ο έλεγχος ήταν επιτυχής',
    file_check_progress: 'Έλεγχος αρχείου σε εξέλιξη',
    scorm_not_upload:
      'Το μεταφορτωμένο αρχείο δεν είναι συμβατό με το SCORM 1.2. Παρακαλώ μεταφορτώστε άλλο αρχείο.',
    select_question: 'Ερώτηση πολλαπλής επιλογής (μία σωστή απάντηση)',
    select_answer: 'Παρακαλώ επιλέξτε απάντηση!',
    check_option_one: 'Παρακαλώ εισάγετε την επιλογή!',
    check_option_two: 'Παρακαλώ εισάγετε δύο επιλογές!',
    check_option_three: 'Παρακαλώ εισάγετε τρεις επιλογές!',
    check_option_four: 'Παρακαλώ εισάγετε τέσσερις επιλογές!',
    question_image: 'Εικόνα ερώτησης',
    select_question_image: 'Επιλέξτε εικόνα για την ερώτηση!',
    ans_image: 'Εικόνα απάντησης',
    upload_image_question: 'Μεταφόρτωση εικόνας ερώτησης',
    select_image_answer: 'Επιλέξτε εικόνα για την απάντηση!',
    save_question: 'Αποθήκευση ερώτησης',
    do_you_leave: 'Θέλετε να αποχωρήσετε; Είστε σίγουροι;',
    loose_all_progress: 'Θα χαθεί όλη η πρόοδός σας.',
    welcome: 'Καλώς ήρθατε',
    team_knowledge_quest: 'Αποστολή γνώσης ομάδας',
    your_score: 'Το σκορ σας',
    start_playing: 'Ξεκινήστε το παιχνίδι',
    share_sphere_complete: 'Ολοκληρώθηκε το ShareSphere',
    final_score: 'Τελικό σκορ',
    play_next: 'Παίξτε το επόμενο',
    you_donot_access_event: 'Δεν έχετε πρόσβαση σε αυτή την εκδήλωση',
    ai_content_generated: 'Περιεχόμενο δημιουργημένο από AI για αυτό το θέμα',
    ai_popup_confirm_content: 'Επιβεβαίωση δημιουργίας περιεχομένου',
    limit_transcribe_text:
      'Λεπτά απομένουν για απομαγνητοφώνηση: <0>{{ transcribe_limit }}</0> λεπτά <1/><2/> <3>. Για να αλλάξετε το όριο απομαγνητοφώνησης, παρακαλώ επικοινωνήστε με </3> <4>admin@sharelook.com</4>.',
    you_donot_access_event: 'Δεν έχετε πρόσβαση σε αυτή την εκδήλωση.',
    ai_course_title_training: 'Μαθήματα ηγεσίας',
    ai_course_object: 'Πλοήγηση στην Ηγεσία στην Ψηφιακή Εποχή',
    create_ai_video: 'Δημιουργία AI Βίντεο',
    generate: 'ΔΗΜΙΟΥΡΓΙΑ',
    video_generate_process:
      'Η διαδικασία δημιουργίας βίντεο μπορεί να διαρκέσει λίγο. Θα λάβετε email μόλις ολοκληρωθεί.',
    stripe_account_connect:
      'Ο λογαριασμός σας στο Stripe είναι ανενεργός. Παρακαλώ συνδεθείτε ή ενεργοποιήστε τον για να συνεχίσετε.',
    ai_creator: 'Δημιουργός AI',
    check_video_status: 'Έλεγχος κατάστασης δημιουργίας βίντεο...',
    video_on_queue: 'Η δημιουργία του βίντεο είναι σε αναμονή.',
    video_fail_generation:
      'Λυπούμαστε, η δημιουργία του βίντεο απέτυχε. Παρακαλώ δοκιμάστε ξανά.',
    video_currently_generated: 'Αυτό το βίντεο δημιουργείται αυτή τη στιγμή.',
    checking_status: 'Έλεγχος Κατάστασης',
    check_status: 'Έλεγχος Κατάστασης',
    browser_does_not_support_audio:
      'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει το στοιχείο ήχου',
    existing_edit_scenario:
      'Θέλετε να επεξεργαστείτε το υπάρχον σενάριο ή να δημιουργήσετε νέο; Αν δημιουργήσετε νέο, το παλιό σενάριο θα χαθεί.',
    generate_scenario: 'Δημιουργία Σεναρίου',
    layout: 'Διάταξη',
    confirm_change: 'Επιβεβαίωση Αλλαγής',
    generated_ai_creation_message:
      'Λάβετε υπόψη ότι μόνο τα κείμενα που δημιουργούνται μέσω AI θα διατηρηθούν. Όλα τα άλλα στοιχεία θα αφαιρεθούν από τη σελίδα.',
    generate_story: 'Δημιουργία Ιστορίας',
    save_original_content: 'Αποθήκευση αρχικού περιεχομένου:',
    story_added_specified_position:
      'Η θέση της ιστορίας στο μάθημα. Η ιστορία θα προστεθεί ως μπλοκ στη συγκεκριμένη θέση.',
    position_of_story: 'Θέση Ιστορίας',
    start_the_lesson: 'Αρχή Μαθήματος',
    end_the_lesson: 'Τέλος Μαθήματος',
    add_story_pages: 'Προσθήκη Ιστορίας στις Σελίδες',
    browser_does_not_support:
      'Το πρόγραμμα περιήγησής σας δεν υποστηρίζει το στοιχείο ήχου.',
    no_video_available: 'Δεν υπάρχουν διαθέσιμα βίντεο.',
    no_podcast_available: 'Δεν υπάρχουν διαθέσιμα podcast.',
    no_item_baskets: 'Δεν υπάρχουν αντικείμενα στο καλάθι.',
    ai_course_object: 'Πλοήγηση στην Ηγεσία στην Ψηφιακή Εποχή'
  },
  v2: {
    n_data: 'Δεν υπάρχουν δεδομένα',
    change: 'Αλλαγή',
    remove: 'Αφαίρεση',
    auto_background: 'Αυτόματο φόντο',
    create_new_course_org: 'Δημιουργήστε ένα νέο μάθημα για τον οργανισμό σας.',
    create_new_course_marketplace:
      'Δημιουργήστε ένα νέο μάθημα για το marketplace.',
    create_new_course_both:
      'Δημιουργήστε ένα νέο μάθημα για τον οργανισμό σας και το marketplace.',
    ok: 'Εντάξει',
    page_bg: 'Φόντο σελίδας',
    lesson_cover: 'Εικόνα εξωφύλλου μαθήματος',
    create_skill_journey: 'Δημιουργία διαδρομής δεξιοτήτων',
    Metamaze: 'Metamaze',
    events: 'Εκδηλώσεις',
    scroms: 'SCORMs',
    min_score_pass: 'Ελάχιστη βαθμολογία για επιτυχία',
    no_scorms_available: 'Δεν υπάρχουν διαθέσιμα SCORMs.',
    no_events_available: 'Δεν υπάρχουν διαθέσιμες εκδηλώσεις.',
    no_courses_available: 'Δεν υπάρχουν διαθέσιμα μαθήματα.',
    no_courses_baskets: 'Δεν υπάρχουν μαθήματα στο καλάθι.',
    no_mazes_baskets: 'Δεν υπάρχουν λαβύρινθοι στο καλάθι.',
    no_scroms_baskets: 'Δεν υπάρχουν SCORMs στο καλάθι.',
    no_events_baskets: 'Δεν υπάρχουν εκδηλώσεις στο καλάθι.',
    sorry: 'Συγγνώμη!',
    option_1: 'Επιλογή 1',
    option_2: 'Επιλογή 2',
    enter_number_words: 'Εισαγάγετε τον μέγιστο αριθμό λέξεων.',
    summarize: 'Περίληψη',
    answer: 'Απάντηση',
    hold_tight_one_minute:
      'Περιμένετε! Η προετοιμασία συνεχίζεται. Αυτό μπορεί να διαρκέσει έως ένα λεπτό.',
    enter_question: 'Εισαγάγετε την ερώτησή σας.',
    enter_relevant_documents: 'Εισαγάγετε τον αριθμό σχετικών εγγράφων.',
    please_input_relevant_documents:
      'Παρακαλώ εισαγάγετε τον αριθμό σχετικών εγγράφων!',
    please_wait_loading_results:
      'Παρακαλώ περιμένετε τη φόρτωση των αποτελεσμάτων...',
    proceed_to_add_voice: 'Συνέχεια για προσθήκη φωνής',
    results: 'Αποτελέσματα',
    no_result_found_try_asking_questions:
      'Δεν βρέθηκαν αποτελέσματα. Δοκιμάστε να κάνετε περισσότερες ερωτήσεις.',
    eg: 'π.χ.',
    what_make_sales_manager: 'Τι μπορεί να με κάνει διευθυντή πωλήσεων;',
    please_select_lang: 'Παρακαλώ επιλέξτε γλώσσα!',
    search: 'Αναζήτηση',
    please_copy_desired_content:
      'Αντιγράψτε το επιθυμητό περιεχόμενο από το αριστερό στο δεξί πλαίσιο.',
    rating_req: 'Απαιτείται βαθμολογία.',
    review_req: 'Απαιτείται αξιολόγηση.',
    rating_review_req: 'Πρέπει να δώσετε και βαθμολογία και αξιολόγηση.',
    how_rate_this: 'Πώς θα αξιολογούσατε αυτό;',
    amazing_above_expectations: 'Καταπληκτικό! Πέρα από τις προσδοκίες!',
    certificates: 'Πιστοποιητικά',
    you_no_certificates: 'Δεν έχετε διαθέσιμα πιστοποιητικά αυτή τη στιγμή.',
    please_add_review:
      'Παρακαλώ δώστε αξιολόγηση με τη βαθμολογία σας. Ευχαριστούμε!',
    post: 'Δημοσίευση',
    rate: 'Βαθμολόγηση',
    avg_rating: 'Μέση βαθμολογία',
    no_review_found: 'Δεν βρέθηκε αξιολόγηση',
    are_sure_to_disale_zoom_integration:
      'Είστε σίγουροι ότι θέλετε να απενεργοποιήσετε την ενσωμάτωση Zoom;',
    badges: 'Διακριτικά',
    you_no_badge_available: 'Δεν έχετε διαθέσιμα διακριτικά αυτή τη στιγμή.',
    download_certificate: 'Λήψη πιστοποιητικού',
    loading: 'Φόρτωση...',
    no_file_attached: 'Δεν επισυνάφθηκαν αρχεία',
    you_do_not_have_any_notes: 'Δεν έχετε σημειώσεις.',
    question: 'Ερώτηση',
    score: 'Βαθμολογία',
    alert_score_message: 'Κάποια άτομα υπέβαλαν τις βαθμολογίες τους.',
    alert_question_message: 'Δεν έχουν προστεθεί ερωτήσεις μέχρι στιγμής.',
    button_submit: 'Υποβολή',
    button_allScores: 'Όλες οι βαθμολογίες έχουν υποβληθεί.',
    record_wait: 'Η εγγραφή ξεκινά. Παρακαλώ περιμένετε...',
    buttonSubmit_warning:
      'Παρακαλώ εισάγετε όλες τις βαθμολογίες πριν την υποβολή.',
    upload_ar_assets: 'Μεταφόρτωση πόρων AR',
    edit_ar_assets: 'Επεξεργασία πόρων AR',
    edit_maze_assets: 'Επεξεργασία πόρων MetaMaze',
    upload_assets: 'Μεταφόρτωση πόρων',
    upload_maze_assets: 'Μεταφόρτωση πόρων MetaMaze',
    trigger_title: 'Τίτλος σκανδάλης',
    model_title: 'Τίτλος μοντέλου',
    trigger_description: 'Περιγραφή σκανδάλης',
    model_description: 'Περιγραφή μοντέλου',
    please_type_target_description:
      'Παρακαλώ εισάγετε την περιγραφή του στόχου.',
    please_type_model_description:
      'Παρακαλώ εισάγετε την περιγραφή του μοντέλου.',
    trigger_image: 'Εικόνα σκανδάλης*',
    model_image: 'Εικόνα μοντέλου*',
    upload_trigger_image: 'Μεταφόρτωση εικόνας σκανδάλης',
    upload_model_image: 'Μεταφόρτωση εικόνας μοντέλου',
    drag_n_drop: 'Σύρετε και αποθέστε',
    file_size_should_not_exceed:
      '(Το μέγεθος της εικόνας JPEG δεν πρέπει να υπερβαίνει τα 512KB)',
    zip_size_should_not_exceed:
      '(Το μέγεθος του αρχείου zip δεν πρέπει να υπερβαίνει τα 60MB)',
    ar_content: 'Περιεχόμενο AR*',
    model_content: '3D Μοντέλο*',
    upload_3d_zip: 'Μεταφόρτωση ZIP / βίντεο',
    upload_3d_maze_zip: 'Μεταφόρτωση ZIP',
    audio_content: 'Ηχητικό περιεχόμενο',
    _mp3: '(.mp3)',
    content_attached: 'Συνημμένο zip.',
    video_attached: 'Συνημμένο βίντεο.',
    audio_attached: 'Συνημμένος ήχος.',
    enter_trigger_image_title: 'Εισάγετε τίτλο εικόνας σκανδάλης.',
    enter_model_title: 'Εισάγετε τίτλο μοντέλου MetaMaze.',
    ar_preview_image: 'Προεπισκόπηση εικόνας AR',
    upload_preview_image: 'Μεταφόρτωση εικόνας προεπισκόπησης',
    upload_audio: 'Μεταφόρτωση ήχου',
    creating___: 'Δημιουργία...',
    updating___: 'Ενημέρωση...',
    create: 'Δημιουργία',
    update: 'Ενημέρωση',
    ar_assets: '3D Εικόνα',
    _3d_files_mp4: '(ZIP .obj, .fbx ή βίντεο .mp4)',
    _3d_files_mp4_ar: '(ZIP .obj, .fbx)',
    maze_3d_files_mp4: '(ZIP .obj, .fbx)',
    _jpg_files: 'Μόνο .jpg',
    persons_have_submitted_their_scores: 'Άτομα υπέβαλαν τις βαθμολογίες τους.',
    no_questions_added_till_now: 'Δεν έχουν προστεθεί ερωτήσεις μέχρι στιγμής.',
    submit: 'Υποβολή',
    all_scores_submitted: 'Όλες οι βαθμολογίες έχουν υποβληθεί.',
    recording_is_starting: 'Η εγγραφή ξεκινά. Παρακαλώ περιμένετε...',
    please_input_scores_before_submitting:
      'Παρακαλώ εισάγετε όλες τις βαθμολογίες πριν την υποβολή.',
    end_for_all: 'Τερματισμός για όλους',
    full_screen: 'Πλήρης οθόνη',
    breakout_room: 'Αίθουσα ομάδας',
    send_invitations: 'Αποστολή προσκλήσεων',
    add_participants: 'Προσθήκη συμμετεχόντων',
    create_breakout_room: 'Δημιουργία αίθουσας ομάδας',
    connecting: 'Σύνδεση...',
    currently_broadcaster_unavailable:
      'Αυτή τη στιγμή ο παρουσιαστής δεν είναι διαθέσιμος.',
    how_many_breakout_room_to_create: 'Πόσες αίθουσες ομάδων να δημιουργηθούν;',
    create_upto_three_breakout_rooms: '*Δημιουργήστε έως και 3 αίθουσες ομάδων',
    allow: 'Επιτρέπεται',
    additional: 'Επιπλέον',
    attachment: 'Συνημμένο',
    no_description_available: 'Δεν υπάρχει διαθέσιμη περιγραφή.',
    people: 'Άτομα',
    waiting: 'Αναμονή',
    hand_raising_users: 'Χρήστες που σήκωσαν χέρι',
    invite: 'Πρόσκληση',
    create_room: 'Δημιουργία αίθουσας',
    create_live_event: 'Δημιουργία ζωντανού συμβάντος',
    support_upto_fivethousand_participants:
      'Υποστηρίζει έως και 5000 συμμετέχοντες',
    support_upto_ten_participants:
      'Υποστηρίζει έως και 10 βίντεο συμμετέχοντες',
    support_upto_twohundred_participants:
      'Υποστηρίζει έως και 200 συμμετέχοντες για εκδήλωση',
    supprt_upto_five_participants: 'Υποστηρίζει έως και 5 βίντεο συμμετέχοντες',
    support_upto_twentyfive_participants:
      'Υποστηρίζει έως και 25 βίντεο συμμετέχοντες',
    two_live_video_participants:
      '2 ζωντανοί συμμετέχοντες βίντεο (οικοδεσπότης και επισκέπτης)',
    you_can_have_upto_five_examinees:
      'Μπορείτε να έχετε έως και 5 εξεταζόμενους.',
    you_can_have_upto_twentyfive_participants:
      'Μπορείτε να έχετε έως και 25 συμμετέχοντες.',
    you_can_have_upto_five_participants:
      'Μπορείτε να έχετε έως και 5 συμμετέχοντες.',
    you_can_have_upto_ten_participants:
      'Μπορείτε να έχετε έως και 10 συμμετέχοντες.',
    select_hosts_email: 'Επιλέξτε το email του οικοδεσπότη',
    send_invite_email: 'Αποστολή email πρόσκλησης',
    do_not_send_invite_email: 'Να μην σταλεί email πρόσκλησης',
    error: 'Σφάλμα',
    max_twentyfive_users_allowed: 'Μέγιστο 25 χρήστες επιτρέπονται',
    max_five_users_allowed: 'Μέγιστο 5 χρήστες επιτρέπονται',
    max_ten_users_allowed: 'Μέγιστο 10 χρήστες επιτρέπονται',
    no_user_found: 'Δεν βρέθηκε χρήστης',
    transcribe_to: 'Μεταγραφή σε',
    integrate_zoom_to_start_meeting:
      'Ενσωματώστε το Zoom για να ξεκινήσετε τη συνάντηση.',
    zoom_is_not_integrated: 'Το Zoom δεν είναι ενσωματωμένο.',
    delete_poll: 'Διαγραφή δημοσκόπησης',
    add_poll: 'Προσθήκη δημοσκόπησης',
    live_now: 'ΖΩΝΤΑΝΑ ΤΩΡΑ!',
    average_rating: 'Μέση αξιολόγηση',
    review: 'Αξιολόγηση',
    time_spent: 'Χρόνος που αφιερώθηκε',
    total: 'Σύνολο',
    mins: 'Λεπτά',
    no_data: 'Δεν υπάρχουν διαθέσιμα δεδομένα.',
    total_score: 'Συνολικό σκορ',
    pass_score: 'Βαθμός επιτυχίας',
    point: 'Σημείο',
    wrong: 'Λάθος',
    response: 'Απάντηση',
    submitted: 'Υποβλήθηκε',
    average: 'Μέσος όρος',
    total_play: 'Συνολικά παιχνίδια',
    view_graph: 'Προβολή γραφήματος',
    time_spent_mins: 'Χρόνος που αφιερώθηκε (λεπτά)',
    play: 'Παίξε',
    ideal_path: 'Ιδανική διαδρομή',
    user_incorrect_path: 'Λανθασμένη διαδρομή χρήστη',
    ideal_path_taken: 'Ιδανική διαδρομή που ακολούθησε ο χρήστης',
    scenario: 'Σενάριο',
    option: 'Επιλογή',
    spend: 'Ξοδεύτηκαν',
    average_spending_time: 'Μέσος χρόνος δαπάνης',
    activity_overview: 'Επισκόπηση δραστηριότητας',
    live_event: 'Ζωντανή εκδήλωση',
    live_assessment: 'Ζωντανή αξιολόγηση',
    report_download: 'Λήψη αναφοράς',
    all_workshops: 'Εργαστήρια',
    overview_average_activity: 'Μέση επισκόπηση δραστηριότητας',
    overview_workshop_graph: 'Γράφημα επισκόπησης εργαστηρίου',
    mazes: 'Λαβύρινθοι',
    correct_feedback: 'Ορθή ανατροφοδότηση',
    incorrect_feedback: 'Εσφαλμένη ανατροφοδότηση',
    checkin_checkout: 'Άφιξη - Αναχώρηση',
    minutes: 'Λεπτά',
    incorrect_path: 'Λανθασμένη διαδρομή',
    answer_not_available: 'Η απάντηση δεν είναι διαθέσιμη',
    views: 'Προβολές',
    item: 'Αντικείμενο',
    questions: 'Ερωτήσεις',
    total_points: 'Συνολικοί πόντοι',
    total_attempts: 'Συνολικές προσπάθειες',
    created_date: 'Ημερομηνία δημιουργίας',
    host_name: 'Όνομα οικοδεσπότη',
    host_section: 'Τμήμα οικοδεσπότη',
    choose_products: 'Επιλέξτε προϊόντα',
    add_to_basket: 'Προσθήκη στο καλάθι',
    basket: 'Καλάθι',
    times: 'Φορές',
    scorms: 'SCORMs',
    skill_journey_overview: 'Επισκόπηση διαδρομής δεξιοτήτων',
    how_to_use: 'Πώς να χρησιμοποιήσετε',
    live_broadcast_description:
      'ΕΝΣΩΜΑΤΩΣΑΜΕ ΖΩΝΤΑΝΗ ΜΕΤΑΔΟΣΗ ΣΕ ΕΝΑ ΕΥΧΡΗΣΤΟ ΕΡΓΑΛΕΙΟ ΔΗΜΙΟΥΡΓΙΑΣ ΜΑΘΗΜΑΤΩΝ',
    live_broadcast_subdescription:
      'Με το σύστημα ζωντανής μετάδοσης με δίπλωμα ευρεσιτεχνίας της ShareLook, μπορείτε να δημιουργήσετε εμπλοκή, να αυτοματοποιήσετε τη μάθηση και να μεγιστοποιήσετε την ανταλλαγή γνώσεων.',
    disclaimer: `Βεβαιώνω ότι η διαδρομή δεξιοτήτων μου δεν:
- παραβιάζει τα δικαιώματα τρίτων
- περιέχει παράνομο περιεχόμενο (συκοφαντικό, άσεμνο, βίαιο, ρατσιστικό)
- περιλαμβάνει προσωπικές επιθέσεις
- παραποιεί την ταυτότητα άλλου ατόμου
- καταγράφει προσωπικά δεδομένα χωρίς συγκατάθεση
- περιέχει εμπορικές προσφορές ή ανεπιθύμητα μηνύματα`,
    price: 'Τιμή',
    video_link: 'Σύνδεσμος βίντεο',
    category: 'Κατηγορία',
    objectives: 'Στόχοι',
    marketplace_description: 'Περιγραφή αγοράς',
    live_discussion: 'ΖΩΝΤΑΝΗ ΣΥΖΗΤΗΣΗ',
    poll: 'Δημοσκόπηση',
    hide_grid: 'Απόκρυψη πλέγματος',
    show_grid: 'Εμφάνιση πλέγματος',
    stop_screen_share: 'Διακοπή κοινής χρήσης οθόνης',
    screen_share: 'Κοινή χρήση οθόνης',
    mute: 'Σίγαση',
    unmute: 'Αναίρεση σίγασης',
    raise_hand: 'Σήκωμα χεριού',
    waiting__: 'Αναμονή...',
    audio_active: 'Ενεργός ήχος'
  },
  general: {
    save: 'αποθήκευση',
    autosaved: 'αποθηκεύτηκε αυτόματα',
    back_to: 'πίσω σε',
    by: 'από',
    chat: 'συνομιλία',
    completed: 'ολοκληρώθηκε',
    canceled: 'Ακυρώθηκε',
    component: 'Συνιστώσα',
    confirm: 'Επιβεβαίωση',
    course: 'Διάλεξη',
    skill: 'Ταξίδι Δεξιοτήτων',
    maze: 'ΜεταΛαβύρινθος',
    channel: 'Κανάλι',
    podcast: 'Podcast',

    date: 'Ημερομηνία',
    details: 'Λεπτομέρειες',
    empty: 'Κανένα δεδομένο',
    enrolled: 'Εγγεγραμμένος',
    free: 'Δωρεάν',
    graph: 'Γράφημα',
    loading: 'Φορτώνει...',
    lesson: 'μάθημα',
    lessons: 'μαθήματα',
    live_assessment: 'Ζωντανή αξιολόγηση',
    live_event: 'Ζωντανό δρώμενο',
    no: 'Όχι',
    of: 'Του',
    or: 'Ή',
    organization: 'Οργανισμός',
    page: 'Σελίδα',
    pages: 'Σελίδες',
    personal: 'Προσωπικά',
    poll: 'Ψηφοφορία',
    rating: 'Βαθμολόγηση',
    reset: 'Επαναφορά',
    signin: 'Σύνδεση',
    signup: 'Εγγραφή',
    soon: 'Σύντομα',
    type: 'Τύπος',
    uploading: 'Ανεβαίνει...',
    yes: 'Ναι',
    something_went_wrong: 'Κάτι πήγε στραβά!',
    view_all: 'Προβολή όλων',
    upload_successful: 'Επιτυχές μεταφόρτωση',
    upload_successful_message:
      'Τα αρχεία excel σας έχουν μεταφορτωθεί επιτυχώς και η διαδικασία συνεχίζεται. Αυτό μπορεί να πάρει λίγη ώρα.',
    check_email_upload_successful:
      'Παρακαλούμε <0>ελέγξτε τη διεύθυνση ηλεκτρονικού ταχυδρομείου σας</0> για την <1>αναφορά</1> της ανεβασμένης λίστας χρηστών.',
    is_private: 'Ιδιωτικό'
  },

  account: {
    title: 'Λογαριασμός',
    subtitle:
      'Διαχειριστείτε τις ρυθμίσεις σας και την πληροφορία του λογαριασμού σας.',
    saved: 'Ο λογαριασμός άλλαξε επιτυχώς'
  },

  assessments: {
    title: 'Αξιολογήσεις',
    subtitle: 'Δημιουργήστε μία αξιολόγηση',
    finished: 'Οι αξιολογήσεις έχουν ολοκληρωθεί',
    countdown: 'Οι Ζωντανές Αξιολογήσεις θα μεταδοθούν σε ',
    create: 'Δημιουργήστε Αξιολόγηση',
    list_title: 'Οι Αξιολογήσεις σας',
    delete_warning: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το στοιχείο;',
    details_title: 'Προσθέστε Πληροφορίες Αξιολογήσεων',
    details_subtitle:
      'Ονομάστε την Αξιολόγηση σας και πείτε στο κοινό σας τι θα πρέπει να αναμένει να μάθει από αυτή.',
    disclaimer: `Εγγυώμαι ότι η καταγραμμένη αξιολόγηση δεν θα:
    - καταπατήσει τα δικαιώματα οποιουδήποτε τρίτου μέρους
    - περιέχει οποιαδήποτε παρανομία, συμπεριλαμβανομένου δυσφημιστικού, άσεμνου, πορνογραφικό, βίαιο, καταχρηστικό, προσβλητικό, απειλητικό ή ρατσιστικό περιεχόμενο, ακόμη και σημειωμένο με αστερίσκους 
   - περιέχει οποιεσδήποτε προσωπικές ατάκες σε άλλα άτομα
    - περιέχει οποιαδήποτε μίμηση με άλλους συμμετέχοντες, δημόσια πρόσωπα ή διάσημους
    - περιέχει οποιαδήποτε καταγραμμένη ή προσωπική πληροφορία οποιουδήποτε ιδιώτη χωρίς τη συγκατάθεση του και δεν παραβιάζει κανέναν κανονισμό προστασίας δεδομένων σε οποιοδήποτε μέρος του κόσμου 
    -περιέχει οποιαδήποτε εμπορική προσέλκυση ή οποιαδήποτε μορφή "ανεπιθύμητου" περιεχομένου `,
    assessment_details: 'Λεπτομέρειες Αξιολόγησης',

    assessment_settings: 'Ρυθμίσεις Αξιολόγησης'
  },

  buildersettings: {
    title: 'Δημοσίευση Ρυθμίσεων',
    subtitle:
      'Προσθέστε ρυθμίσεις στο δρώμενο σας, ποιος μπορεί να παρακολουθήσει και να αλληλεπιδράσει σε αυτό'
  },

  buttons: {
    market_place: 'Market Place',
    back_to_normal: 'Back To Normal',
    add: 'Προσθήκη',
    add_page: 'Προσθήκη σελίδας',
    add_lesson: 'Προσθήκη μαθημάτων',
    add_answer: 'Προσθήκη νέας απάντησης',
    add_group: 'Προσθήκη Ομάδας',
    add_organization: 'Προσθήκη Οργανισμού',
    add_question: 'Προσθήκη ερώτησης',
    add_quiz: 'Προσθήκη Κουίζ',
    add_users: 'Προσθήκη Χρηστών',
    back: 'Πίσω',
    back_to_course: 'Πίσω στη Σύνοψη Διάλεξης',
    back_to_lesson: 'Πίσω στη σύνοψη μαθήματος',
    back_to_media: 'Πίσω στη Βιβλιοθήκη Μέσων Κοινωνικής Δικτύωσης',
    back_to_details: 'Πίσω στις λεπτομέρειες',
    cancel: 'Ακύρωση',
    clear: 'Καθαρισμός',
    close: 'Κλείσιμο',
    clone: 'Κλώνος',
    close_lesson: 'Τερματισμός Μαθήματος',
    clone_course: 'Κλώνος Διάλεξη',
    confirm: 'Επιβεβαίωση',
    create: 'Δημιουργία',
    download: 'Κατέβασμα',
    download_mass_user_tamplate: 'Κατεβάστε Υπόδειγμα',
    add_mass_users: 'Προσθήκη Χρηστών Μαζικά',
    upload_excel_list: 'Μεταφόρτωση Λίστας Excel',
    delete: 'Διαγραφή Μέσων Κοινωνικής Δικτύωσης',
    edit: 'Επεξεργασία',
    edit_course: 'Επεξεργασία Διάλεξης',
    enroll: 'Εγγραφή',
    finish: 'Τερματισμός',
    upload_image: 'Μεταφόρτωση εικόνας',
    upload_image_video: 'Μεταφόρτωση εικόνας ή βίντεο',
    select_media_library: 'Επιλέξτε τη βιβλιοθήκη μέσων κοινωνικής δικτύωσης',
    make_public: 'Δημοσιοποιήστε',
    make_private: 'Κάντε Ιδιωτικό',
    make_org: 'Δημιουργήστε Οργανισμό',
    media: 'Βιβλιοθήκη Μέσων Κοινωνικής Δικτύωσης',
    my_theme: 'Το θέμα μου',
    next: 'Επόμενο',
    next_lesson: 'Επόμενο Μάθημα',
    next_step: 'Επόμενο βήμα',
    previous_step: 'Προηγούμενο βήμα',
    publish: 'Δημοσίευση',
    publish_assessment: 'Δημοσιοποιήστε την αξιολόγηση σας',
    publish_course: 'Δημοσιοποιήστε τη διάλεξη σας',
    publish_event: 'Δημοσιοποιήστε το δρώμενο σας',
    reset: 'Επαναφορά',
    reset_elements: 'Επαναφορά στοιχείων',
    save: 'Αποθήκευση',
    creating: 'Δημιουργείται...',
    updating: 'Ενημερώνεται...',
    saved: 'Αποθηκεύτηκε',
    save_for_later: 'Αποθήκευση για αργότερα',
    save_settings: 'Αποθήκευση ρυθμίσεων',
    select_files: 'Επιλογή αρχείων',
    select_theme: 'Επιλογή θέματος',
    start_lesson: 'Έναρξη Μαθήματος',
    update: 'Ενημέρωση',
    upload: 'Μεταφόρτωση',
    upload_audio: 'Μεταφόρτωση Ήχου',
    upload_photo: 'Μεταφόρτωση φωτογραφίας προφίλ',
    upload_video: 'Μεταφόρτωση Βίντεο',
    enrolled: 'Εγγεγραμμένος',
    unenroll: 'Απεγγραφή',
    from_library: 'Media Library',
    remove: 'Αφαίρεση',
    removed: 'Αφαιρέθηκε',
    start_broadcast: 'Έναρξη Μετάδοσης',
    end_broadcast: 'Τερματισμός Μετάδοσης',
    camera: 'Κάμερα',
    screen: 'Οθόνη',
    screen_with_camera: 'Οθόνη με Κάμερα',
    insert: 'Εισαγωγή',
    inserting: 'Εισάγεται'
  },

  card: {
    quick_add: 'Γρήγορη προσθήκη',
    add: 'Προσθήκη',
    clone: 'Κλώνος',
    completed: 'ολοκληρωμένα μαθήματα'
  },

  course: {
    upcoming_course: 'Ανερχόμενη Διάλεξη',
    unPublishEvent: 'Κατάργηση δημοσίευσης Δρώμενου',
    unPublishAssessment: 'Κατάργηση δημοσίευσης Αξιολόγησης',
    pastCourse: 'Εκπαιδευτικό Σεμινάριο',
    upcoming: 'Ανερχόμενο Ζωντανό δρώμενο',
    pastEvent: 'Προηγούμενο Ζωντανό Δρώμενο',
    pastAssessment: 'Προηγούμενη Ζωντανή Αξιολόγηση',
    upcomingAssessment: 'Ανερχόμενη Ζωντανή Αξιολόγηση',
    created: 'Ημερομηνία Δημιουργίας:',
    assignees: 'Εγγεγραμμένοι',
    organisations:
      ' {{ οργανισμοί }} Οργανισμοί, <2> {{ χρήστες }} χρήστες</2>',
    event_date: 'Ημερομηνία Ζωντανού δρώμενος <1> {{ ημερομηνία }} </1>',
    delete_warning: 'Είστε σίγουροι ότι θέλετε να το διαγράψετε;',
    clonning_no_lesson:
      'Παρακαλούμε προσθέστε τουλάχιστον ένα Μάθημα ώστε να δημιουργήσετε ένα κλώνο αυτής της Διάλεξης.',
    clone_warning: 'Είστε σίγουροι ότι θέλετε να κλείσετε αυτό τον κλώνο;',
    clone_success: 'είναι σε διαδικασία τερματισμού',
    disclaimer: `Εγγυώμαι ότι η διάλεξη μου δεν:
- καταπατά τα δικαιώματα οποιουδήποτε τρίτου μέρους
- περιέχει οποιαδήποτε παρανομία, συμπεριλαμβανομένου δυσφημιστικού, άσεμνου, πορνογραφικό, βίαιο, καταχρηστικό, προσβλητικό, απειλητικό ή ρατσιστικό περιεχόμενο, ακόμη και σημειωμένο με αστερίσκους
- περιέχει οποιεσδήποτε προσωπικές ατάκες σε άλλα άτομα
- περιέχει οποιαδήποτε μίμηση με άλλους συμμετέχοντες, δημόσια πρόσωπα ή διάσημους
- περιέχει οποιαδήποτε καταγραμμένη ή προσωπική πληροφορία οποιουδήποτε ιδιώτη χωρίς τη συγκατάθεση του και δεν παραβιάζει κανέναν κανονισμό προστασίας δεδομένων σε οποιοδήποτε μέρος του κόσμου
-περιέχει οποιαδήποτε εμπορική προσέλκυση ή οποιαδήποτε μορφή "ανεπιθύμητου" περιεχομένου`
  },

  coursecreate: {
    dropzone_text: 'Εισαγωγή μέσων κοινωνικής δικτύωσης',
    sidebar_text: 'Επιλέξτε ένα θέμα <1/> για τα <3/> μαθήματα σας',
    delete_warning: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτό το μάθημα;'
  },

  coursepage: {
    quizview_loading: 'Γίνεται έλεγχος απαντήσεων. Παρακαλούμε περιμένετε...',
    quizview_answer: 'Η Απάντηση σας'
  },

  coursequiz: {
    title: 'Κουίζ σε όλα τα Μαθήματα'
  },

  dashboard: {
    tooltip_title: 'Να μην εμφανιστεί αυτό το βίντεο ξανά',
    page_title: 'Τα στατιστικά των Διαλέξεων σας',
    page_subtitle: 'Κατάσταση των διαλέξεων που δημιουργήσατε',
    profile_add_info:
      'Προσθέστε το <1>{{μη ολοκληρωμένο Κείμενο}}</1> για να ολοκληρώσετε το προφίλ σας.',
    profile_build:
      'Χτίστε το προφίλ σας <1>εδώ</1>, ενημερώστε μας για τα ενδιαφέροντα και τις ικανότητες σας.',
    profile_title: 'Δύναμη Προφίλ',
    more_details: 'Περισσότερες Λεπτομέρειες'
  },

  errors: {
    answer: 'Παρακαλούμε εισάγετε απάντηση',
    answer_correct: 'Επιλέξτε τη σωστή απάντηση',
    code: 'Παρακαλούμε εισάγετε τον κωδικό σας',
    criterion: 'Παρακαλούμε εισάγετε κριτήριο',
    duration: 'Η Διάρκεια είναι υποχρεωτική',
    element: 'Παρακαλούμε εισάγετε στοιχείο',
    email: 'Παρακαλούμε εισάγετε διεύθυνση ηλεκτρονικού ταχυδρομείου',
    email_invalid: 'Η διεύθυνση ηλεκτρονικού ταχυδρομείου δεν είναι έγκυρη',
    feedback_correct: 'Παρακαλούμε εισάγετε σωστή ανατροφοδότηση',
    feedback_incorrect: 'Παρακαλούμε εισάγετε ανατροφοδότηση λάθος',
    host: 'Παρακαλούμε εισάγετε τον οικοδεσπότη του δρώμενος',
    host_assessment: 'Παρακαλούμε εισάγετε τον οικοδεσπότη αξιολόγησης',
    image: 'Παρακαλούμε ανεβάστε μία εικόνα',
    location: 'Παρακαλούμε εισάγετε την τοποθεσία σας',
    live_location: 'Παρακαλούμε επιλέξτε μία τοποθεσία μετάδοσης',
    limit: 'Παρακαλούμε εισάγετε τα λεπτά ζωντανής μετάδοσης',
    min_3char: '3 χαρακτήρες ελάχιστο',
    number: 'παρακαλούμε εισάγετε θετικό νούμερο.',
    host_email_require: `Οι διευθύνσεις ηλεκτρονικού ταχυδρομείου του οικοδεσπότη είναι υποχρεωτικές.`,
    attendee_email_require: `Οι διευθύνσεις ηλεκτρονικού ταχυδρομείου των εγγεγραμμένων είναι υποχρεωτικές.`,
    name: 'Παρακαλούμε εισάγετε το όνομα σας',
    not_found_course: 'Η διάλεξη δεν βρέθηκε',
    not_found_event: 'Το δρώμενο δε βρέθηκε',
    not_found_assessment: 'Η αξιολόγηση δε βρέθηκε',
    password: 'Παρακαλούμε εισάγετε τον κωδικό πρόσβασης σας',
    password_digit: 'Τουλάχιστον ένα ψηφίο',
    password_short:
      'Οι κωδικοί πρόσβασης είναι πολύ σύντομοι, 10 χαρακτήρες το λιγότερο',
    password_special: 'Τουλάχιστον ένας ειδικός χαρακτήρας',
    password_uppercase: 'Τουλάχιστον ένας κεφαλαίος χαρακτήρας',
    password_lowercase: 'Τουλάχιστον ένας πεζός χαρακτήρας',
    phone: 'Παρακαλούμε εισάγετε τον αριθμό τηλεφώνου σας',
    phone_invalid: 'Άκυρος αριθμός τηλεφώνου',
    position: 'Παρακαλούμε εισάγετε την τοποθεσία σας',
    question: 'Παρακαλούμε εισάγετε ερώτηση',
    start_date: 'Ημερομηνία & Ώρα Έναρξης απαιτούνται',
    tag: 'Παρακαλούμε επιλέξτε μία ετικέτα',
    topics: 'Παρακαλούμε επιλέξτε τουλάχιστον ένα θέμα.',
    live_topics: 'Παρακαλούμε προσθέστε θέματα',
    title: 'Παρακαλούμε εισάγετε τίτλο',
    title_assessment: 'Παρακαλούμε εισάγετε τίτλο αξιολόγησης',
    title_course: 'Παρακαλούμε εισάγετε τίτλο διάλεξης',
    title_empty: 'Ο τίτλος δεν μπορεί να είναι κενός',
    title_event: 'Παρακαλούμε εισάγετε τίτλο δρώμενου',
    title_lesson: 'Παρακαλούμε εισάγετε τίτλο μαθήματος',
    title_quiz: 'Παρακαλούμε εισάγετε όνομα κουίζ',
    username: 'Παρακαλούμε εισάγετε το όνομα χρήστη σας',
    invalid_verification_code: 'Αυτός ο σύνδεσμος επαλήθευσης έχει λήξει ή δεν είναι πλέον έγκυρος. Αυτό συμβαίνει συνήθως εάν ζητήθηκε ένα νεότερο μήνυμα ηλεκτρονικού ταχυδρομείου επαλήθευσης. Ελέγξτε το πιο πρόσφατο μήνυμα ηλεκτρονικού ταχυδρομείου από το Sharelook για να επαληθεύσετε το email σας.',
    upload_error: 'Σφάλμα – Το αρχείο δεν είναι συμβατό!',
    upload_more_than_10: 'Μπορείτε να ανεβάσετε το πολύ 10 αρχεία τη φορά.',
    topics_max: 'Παρακαλούμε προσθέστε το πολύ 3 θέματα.',
    upload_excel:
      'Παρακαλούμε σιγουρευτείτε ότι έχετε ανεβάσει το σωστό αρχείο.',
    title_excel: 'Σφάλμα μεταφόρτωσης υποδείγματος:',
    file_size_exceed: 'Το μέγεθος αρχείου έχει υπερβεί το όριο',
    subtitle_excel:
      'Παρακαλούμε σιγουρευτείτε ότι το υπόδειγμα και οι στήλες είναι συμπληρωμένες σωστά.',
    select_broadcast_option:
      'Παρακαλούμε επιλέξτε μία επιλογή για να μεταδώσετε το δρώμενο αυτό',
    multi_hosts_number_error:
      'Ο αριθμός των παρουσιαστών δεν μπορεί να υπερβαίνει τον καθορισμένο για το δρώμενο.',
    conference_people_number_error: `Ο αριθμός των παρουσιαστών δεν μπορεί να υπερβαίνει τον καθορισμένο για το δρώμενο.`,
    select_max_host: 'Επιλέξτε τουλάχιστον 1 παρουσιαστή για το δρώμενο.',
    select_max_conference:
      'Επιλέξτε τουλάχιστον 1 εγγεγραμμένο για το δρώμενο.',
    stream_stop_error: 'Η Μετάδοση Τερματίστηκε Απετυχώς!',
    unsecure_context:
      'Σφάλμα: Το πρόγραμμα περιήγησης δεν έχει πρόσβαση στην κάμερα και στο μικρόφωνο λόγω μη ασφαλούς περιεχομένου. Παρακαλούμε εγκαταστήστεSSL και αποκτήστε πρόσβαση μέσω https',
    ws_not_supported:
      'Σφάλμα: Το WebSocket δεν υποστηρίζεται σε αυτό το πρόγραμμα περιήγησης',
    no_org: 'Επιλέξτε τουλάχιστον 1 οργανισμό για να προχωρήσετε.',
    no_org_group: 'Επιλέξτε τουλάχιστον 1 ομάδα οργάνωσης για να προχωρήσετε.',
    waiting_to_join: 'περιμένω να εγγραφείτε'
  },

  events: {
    title: 'Προσθέστε Λεπτομέρειες Ζωντανού Δρώμενος',
    change_host: 'Αλλαγή Οικοδεσπότη',
    finished: 'Το δρώμενο έχει ολοκληρωθεί',
    countdown: 'Το ζωντανό δρώμενο θα μεταδοθεί σε ',
    subtitle:
      'Ονομάστε το Ζωντανό δρώμενο σας και πείτε στο κοινό σας τι θα πρέπει να αναμένει ότι θα μάθει από αυτό.',
    poll_disabled: 'Η ψηφοφορία δεν είναι διαθέσιμη σε αυτό το δρώμενο',
    disclaimer: `Εγγυώμαι ότι το καταγραμμένο δρώμενο δε θα:
    - καταπατά τα δικαιώματα οποιουδήποτε τρίτου μέρους
    - περιέχει οποιαδήποτε παρανομία, συμπεριλαμβανομένου δυσφημιστικού, άσεμνου, πορνογραφικό, βίαιο, καταχρηστικό, προσβλητικό, απειλητικό ή ρατσιστικό περιεχόμενο, ακόμη και σημειωμένο με αστερίσκους
    - περιέχει οποιεσδήποτε προσωπικές ατάκες σε άλλα άτομα
    - περιέχει οποιαδήποτε μίμηση με άλλους συμμετέχοντες, δημόσια πρόσωπα ή διάσημους
    - περιέχει οποιαδήποτε καταγραμμένη ή προσωπική πληροφορία οποιουδήποτε ιδιώτη χωρίς τη συγκατάθεση του και δεν παραβιάζει κανέναν κανονισμό προστασίας δεδομένων σε οποιοδήποτε μέρος του κόσμου 
    -περιέχει οποιαδήποτε εμπορική προσέλκυση ή οποιαδήποτε μορφή "ανεπιθύμητου" περιεχομένου`,
    prompt_message:
      'Εάν εγκαταλείψετε τη σελίδα θα τερματίσετε το δρώμενο. Είστε σίγουροι ότι θέλετε να εγκαταλείψετε τη σελίδα;',
    duration_exceed_message:
      'Ο χρόνος μετάδοσης έχει υπερβεί το όριο, η Εφαρμογή πρόκειται να σταματήσει τη μετάδοση.',
    before_schedule_message:
      'Πρόκειται να ξεκινήσετε τη μετάδοση πριν την προγραμματισμένη ώρα. Παρακαλούμε σημειώστε ότι σταματώντας τη μετάδοση, το δρώμενο θα ολοκληρωθεί.',
    browser_unsupportive_message:
      'Το πρόγραμμα περιήγησης σας δεν υποστηρίζει την κοινοποίηση οθόνης. Μπορείτε να βρείτε υποστηριζόμενα προγράμματα περιήγησης σε αυτό το σύνδεσμο.',
    cancel_switch_host_message:
      'Ο οικοδεσπότης δεν είναι διαθέσιμος. Το δρώμενο θα συνεχιστεί μετά το τέλος.',
    coaching_prompt_message:
      'YΔεν μπορείτε να κλείσετε τη σελίδα μέχρι το δρώμενο να τερματιστεί.',
    event_modal_warn: 'Θέλετε να αποχωρήσετε από το δρώμενο;',
    confirm_message: 'Το δρώμενο σας θα τερματιστεί εάν πατήσετε ΕΝΤΑΞΕΙ.',
    screen_share_denied: 'Αρνηθήκατε την κοινοποίηση οθόνης',
    media_not_found:
      'Η Κάμερα ή το Μικρόφωνο σας δεν βρέθηκαν ή δεν είναι επιτρεπτά από την συσκευή σας.',
    media_not_access:
      'Η Κάμερα ή το Μικρόφωνο σας χρησιμοποιείται από άλλη διαδικασία που δεν επιτρέπει την ανάγνωση συσκευής.',
    constraint_error:
      'Δεν βρέθηκε συσκευή που να ταιριάζει με το βίντεο και τους περιορισμούς ήχου. Μπορείτε να αλλάξετε το βίντεο και τοθς περιορισμούς ήχου.',
    media_access_denied:
      'Δεν επιτρέπεται η πρόσβαση στην κάμερα και το μικρόφωνο.'
  },

  filters: {
    days7: 'Τελευταίες 7 ημέρες',
    days15: 'Τελευταίες 15 ημέρες',
    days30: 'Τελευταίες 30 ημέρες',
    days365: 'Τελευταίες 365 ημέρες',
    date: 'Ημερομηνία δημιουργίας',
    relevance: 'Συνάφεια',
    popularity: 'Δημοσιότητα',
    name: 'Όνομα',
    group: 'Ομάδα',
    Newest_to_Oldest: 'Νεότερο προς Παλαιότερο',
    Oldest_to_Newest: 'Παλαιότερο προς Νεότερο',
    A_Z: 'A έως Ω',
    Z_A: 'Ω έως A'
  },

  helpers: {
    password:
      'Για να επιβεβαιώσετε την ασφάλεια του λογαριασμού σας απαιτείται τουλάχιστον ένας πεζός χαρακτήρας και ένα νούμερο στον κωδικό πρόσβασης σας. Επίσης, χρειάζεται να έχει το λιγότερο 10 χαρακτήρες.',
    phone:
      'Παρακαλούμε συμπεριλάβετε τον κωδικό τηλεφώνου της χώρας σας, για παράδειγμα: +65',
    username:
      'Το όνομα χρήστη σας χρησιμοποιείται ως δημόσια πληροφορία και κοινοποιείται με άλλους χρήστες όταν χρειάζεται. Για αυτό το λόγο, σας προτείνουμε να μη βάζετε προσωπικές πληροφορίες στο όνομα χρήστη σας',
    public_description_normal:
      'Το <0><0/></0> έχει αποθηκευτεί και θεωρείται Ιδιωτικό από προεπιλογή. Αυτό σημαίνει ότι μόνο εσείς μπορείτε να δείτε το περιεχόμενο. Για να δημοσιεύσετε αυτό το περιεχόμενο μπορείτε να επιλέξετε μία από τις παρακάτω επιλογές. Δημοσιεύοντας τη διάλεξη σημαίνει ότι θα είναι διαθέσιμη σε όλους τους χρήστες στην πλατφόρμα. Η επιλογή Συγκεκριμένοι Χρήστες θα σας επιτρέψουν να κοινοποιήσετε τη διάλεξη σας με συγκεκριμένους χρήστες χρησιμοποιώντας τη διεύθυνση ηλεκτρονικού ταχυδρομείου που συνδέεται με το λογαριασμό Sharelook τους.',
    public_description_admin:
      'Το <0><0/></0> έχει αποθηκευτεί και θεωρείται Ιδιωτικό από προεπιλογή. Αυτό σημαίνει ότι μόνο εσείς (και ο δημιουργός του περιεχομένου) μπορείτε να δείτε το περιεχόμενο. Για να δημοσιεύσετε αυτό το περιεχόμενο μπορείτε να επιλέξετε μία από τις παρακάτω επιλογές. Δημοσιεύοντας τη διάλεξη σημαίνει ότι θα είναι διαθέσιμη σε όλους τους χρήστες στην πλατφόρμα – συμπεριλαμβανομένων εκείνων εκτός του οργανισμού. Δημοσιεύοντας τη στον οργανισμό σημαίνει ότι όλοι οι χρήστες μέσα στον οργανισμό θα μπορούν να τη δουν. Επίσης, μπορείτε να τη δημοσιεύσετε σε 1 ή περισσότερες ομάδες, που σημαίνει ότι μόνο οι χρήστες μέσα στις ομάδες θ μπορούν να τη δουν. Τέλος, έχετε τη δυνατότητα να τη δημοσιεύσετε σε συγκεκριμένους χρήστες εντός και εκτός του οργανισμού χρησιμοποιώντας τη διεύθυνση ηλεκτρονικού ταχυδρομείου του λογαριασμού Sharelook τους.'
  },

  labels: {
    add: 'Προσθήκη',
    portrait: 'Crop Portrait',
    landscape: 'Crop Landscape',
    answer_type: 'Τύπος απάντησης',
    answers: 'Απαντήσεις',
    back_to_quiz: 'Πίσω στη λίστα Κουίζ',
    back_to_question: 'Πίσω στη λίστα ερωτήσεων',
    chat: 'Συνομιλία',
    chat_available: 'Η συνομιλία δεν είναι διαθέσιμη σε αυτό το δρώμενο.',
    chat_report: 'Αναφορά Συνομιλίας',
    choice_single: 'Μονή επιλογή',
    choice_multiple: 'Πολλαπλή επιλογή',
    choice_free: '"Ελεύθερη" επιλογή',
    choice_sorting: '"Ταξινόμηση" επιλογής',
    choice_matrix: '"Matrix Sorting" choice',
    clone_lesson_permission: 'Άδεια καταγραφής',
    code: 'Κωδικός',
    correct: 'Σωστό',
    created: 'Ημερομηνία δημιουργίας',
    clone_modal: 'Διάλεξη καταγραμμένη',
    cloning_course: 'Καταγραφή διάλεξης...',
    cloning: 'Καταγραφή...',
    cloning_course_desc:
      'Αυτή η διαδικασία θα πάρει λίγη ώρα. Παρακαλούμε κάντε υπομονή',
    cloning_success: 'Η διάλεξη "<0/>" έχει καταγραφεί επιτυχώς!',
    description: 'Περιγραφή',
    disclaimer: 'Αποποίηση ευθυνών',
    drop_file: 'Αφήστε το φάκελο εδώ...',
    duration: 'Διάρκεια',
    edit: 'Επεξεργασία',
    email: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
    event: 'Δρώμενο',
    event_all: 'Όλα τα Δρώμενα του',
    event_date: 'Live Event Local Date/Time',
    event_this: 'Αυτό το Δρώμενο',
    expire: 'Λήγει σε',
    expiry_date: 'Ημερομηνία λήξης',
    forgot: 'Ξεχάσατε τον κωδικό πρόσβασης;',
    group: 'Ομάδα',
    groups_list: 'Λίστα Ομάδων',
    host: 'Οικοδεσπότης',
    id_annotation: 'Ταυτότητα Σχολίου',
    id_quiz: 'Ταυτότητα Κουίζ',
    incorrect: 'Λάθος',
    interests: 'Ενδιαφέροντα',
    invited: 'Καλεσμένος',
    live_chat: 'Ζωντανή Συζήτηση',
    live_stream_limit: 'Λεπτά Ζωντανής Μετάδοσης',
    contact_text:
      'Για να αλλάξετε το όριο της μηνιαίας ζωντανής μετάδοσης σας, παρακαλούμε επικοινωνήστε μαζί μας.',
    contact_admin:
      '<0>Εάν επιθυμείτε να αλλάξετε το όριο της μηνιαίας ζωντανής μετάδοσης παρακαλούμε επικοινωνήστε εδώ</0><1>admin@sharelook.com</1>',
    limit_stream_text:
      'Εναπομείναντα λεπτά ζωντανής μετάδοσης<0>{{ limit }}</0> λεπτά <1/><2/><3>Για να αλλάξετε το όριο της μηνιαίας ζωντανής μετάδοσης παρακαλούμε επικοινωνήστε</3><4>admin@sharelook.com</4>',
    location: 'Τοποθεσία',
    lessons: 'Μαθήματα',
    location_broadcast: 'Τοποθεσία Οικοδεσπότη',
    location_broadcast_subtitle:
      'Προσθέστε την πιο κοντινή στην περιοχή του οικοδεσπότη της μετάδοσης τοποθεσία για να μειώσετε την καθυστέρηση ήχου και εικόνας',
    media_manager: 'Διαχειριστής μέσων κοινωνικής δικτύωσης',
    minutes: 'Λεπτά',
    name: 'Όνομα',
    online_quiz: 'Ηλεκτρονικό Κουίζ',
    organiser: 'Συγγραφέας',
    organization: 'Οργανισμός',
    overall_emotion: 'Συνολική Εμπειρία:',
    organizations_list: 'Λίστα Οργανισμών',
    password: 'Κωδικός Πρόσβασης',
    participants: 'Συμμετέχοντες',
    picture: 'Εικόνα (16:9)',
    phone: 'Τηλέφωνο',
    photo: 'Φωτογραφία',
    poll: 'Ψηφοφορία',
    position: 'Θέση',
    processing: 'Εκτελείται',
    privacy_settings: 'Ρυθμίσεις απορρήτου',
    question: 'Ερώτηση',
    quiz_create: 'Δημιουργία Νέου Κουίζ',
    quiz_name: 'Όνομα Κουίζ',
    quiz_update: 'Ενημέρωση Κουίζ',
    select_organization: 'Επιλέξτε έναν Οργανισμό',
    settings: 'Ρυθμίσεις',
    show: 'Εμφάνιση',
    show_graph: 'Εμφάνιση αποτελεσμάτων γραφημάτων',
    signin: 'Σύνδεση',
    signup: 'Εγγραφή',
    sort_by: 'Ταξινόμηση κατά',
    start_date: 'Ημερομηνία έναρξης',
    tags: 'Ετικέτες',
    terms: 'Συμφωνώ σε αυτούς<1> τους όρους και προυποθέσεις</1>.',
    title: 'Τίτλος',
    topics: 'Θέματα',
    topic: 'Θέμα',
    total_comments: 'Συνολικά σχόλια',
    username: 'Όνομα Χρήστη',
    users_list: 'Λίστα Χρηστών',
    users_emails:
      'Εισάγετε διευθύνσεις ηλεκτρονικού ταχυδρομείου συγκεκριμένων χρηστών',
    description_specifiction_email:
      'Παρακαλούμε εισάγετε 1 διεύθυνση ηλεκτρονικού ταχυδρομείου σε κάθε γραμμή για να το κοινοποιήσετε με πολλαπλούς συγκεκριμένους χρήστες.',
    message_specific_email:
      'Παρακαλούμε εισάγετε μία διεύθυνση ηλεκτρονικού ταχυδρομείου του συγκεκριμένου χρήστη.',
    viewers: 'Θεατές',
    edit_course: 'Επεξεργασία',
    edit_assessment: 'Επεξεργασία',
    edit_event: 'Επεξεργασία',
    delete_course: 'Διαγραφή',
    delete_event: 'Διαγραφή',
    delete_assessment: 'Διαγραφή',
    view_course: 'Προβολή',
    view_event: 'Προβολή',
    view_assessment: 'Προβολή',
    date_event: 'Ημερομηνία ζωντανού δρώμενος',
    date_assessment: 'Ημερομηνία ζωντανής αξιολόγησης',
    clone_of: 'Αντίγραφο',
    clone_course:
      'Δημιουργήστε ένα αντίγραφο αυτής της διάλεξης που μπορείτε να το επεξεργαστείτε ανεξάρτητα από το πρωτότυπο, συμπεριλαμβανομένων όλων των μαθημάτων και σελίδων.',
    make: 'Δημιουργώ',
    available_to: 'διαθέσιμο σε κάθε χρήστη του ShareLook',
    uploaded_by: 'Μεταφορτώθηκε από: ',
    course: 'Διάλεξη',
    assessment: 'Αξιολόγηση',
    user_not_exist:
      'Ο χρήστης δεν υπάρχει, θα θέλατε να στείλετε μία πρόσκληση;',
    check_user: 'Παρατήρηση',
    user_not_exist_in_org:
      'Ο χρήστης δεν υπάρχει σε αυτό τον οργανισμό, θα θέλατε να στείλετε μία πρόσκληση;',
    title_modal_stream: 'Αλλαγή Ορίου Ζωντανής Μετάδοσης Οργανισμού',
    des_warning_stream: 'Πρόκειται να προχωρήσετε σε αλλαγή',
    monthly_stream: 'μηνιαίο όριο ζωντανής μετάδοσης:',
    min_per_month: 'λεπτά/μήνα',
    broadcast_label: 'Θέλω να κάνω:',
    hosts_emails: `Εισάγετε διευθύνσεις ηλεκτρονικού ταχυδρομείου συγκεκριμένου οικοδεσπότη`,
    attendee_emails: `Εισάγετε διευθύνσεις ηλεκτρονικού ταχυδρομείου συγκεκριμένου εγγεγραμμένου`,
    description_host_specifiction_email:
      'Παρακαλούμε εισάγετε1 διεύθυνση ηλεκτρονικού ταχυδρομείου ανά γραμμή.',
    presenter_label: 'Παρουσιαστής',
    presenter_label_conference: 'Αριθμός Ατόμων',
    event_privacy: 'Τρόπος Διάσκεψης'
  },

  broadcastOptions: {
    stream_from_phone: 'Ζωντανή Μετάδοση με το τηλέφωνο μου',
    other_webrtc: 'Διαδικτυακό σεμινάριο από τον Η/Υ μου',
    multihost: 'Πολλαπλό διαδικτυακό σεμινάριο από τον H/Y μου',
    peer2peer: 'Εκπαιδευτική Συνεδρία',
    conference: 'Ζωντανή Διάσκεψη'
  },

  lessoncreate: {
    title: 'Προσθήκη λεπτομερειών μαθήματος',
    subtitle:
      'Ονομάστε το μάθημα σας και πείτε στο κοινό σας τι θα πρέπει να αναμένουν ότι θα μάθουν από αυτό.',
    input_label_title: 'Τίτλος μαθήματος',
    input_label_topics: 'Θέματα μαθήματος',
    input_label_description: 'Περιγραφή μαθήματος',
    delete_warning: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη σελίδα;'
  },

  lessonoverview: {
    title: 'Προσθήκη μαθήματος',
    subtitle: 'Προσθήκη υπάρχοντος μαθήματος ή δημιουργία ενός νέου',
    new_lesson: 'δημιουργήστε ένα νέο μάθημα',
    new_lesson_sub: 'Δημιουργήστε ένα νέο μάθημα από την αρχή!',
    existing_lesson: 'Επιλέξτε ένα υπάρχον μάθημα',
    existing_lesson_sub:
      'Συνδεθείτε σε ένα υπάρχον μάθημα, αλλαγές που ενδέχεται να έχουν γίνει στο μάθημα θα επηρεάσουν επίσης αυτό το μάθημα σε άλλες διαλέξεις.',
    clone_lesson: 'αντιγράψτε το υπάρχον μάθημα',
    clone_lesson_sub:
      'Δημιουργήστε ένα μοναδικό αντίγραφο του μαθήματος σε αυτή τη διάλεξη, αλλαγές που ενδέχεται να έχουν γίνει στο μάθημα θα επηρεάσουν επίσης αυτό το μάθημα σε άλλες διαλέξεις.',
    clone_lesson_modal_sub:
      'Παρακαλούμε πιέστε το κουμπί Καταγραφή κάτω από το μάθημα που θα θέλατε να προσθέσετε στη διάλεξη σας.'
  },

  management: {
    groups_title: 'Διαχειριστείτε τις Ομάδες',
    delete_warning: 'Είστε βέβαιοι;',
    organizations_title: 'Οι Οργανισμοί μου',
    organizations_subtitle: 'Προσθήκη οργανισμών στη λίστα σας',
    users_title: 'Διαχείριση Χρηστών',
    users_position: 'Ανώτερος Διαχειριστής Λογαριασμού',
    user_not_found: 'Ο Χρήστης Δεν Βρέθηκε',
    select_org:
      'Παρακαλούμε βρείτε και επιλέξτε ένα οργανισμό για να διαχειριστείτε τους χρήστες'
  },

  audio: {
    modal_title: 'Εισαγωγή ήχου',
    list_view: 'Προβολή Λίστας',
    create_audio_modal_title: 'Δημιουργία Ήχου',
    edit_audio_modal_title: 'Επεξεργασία Ήχου',
    public_audio_not_found: 'Ο ήχος δεν βρέθηκε.',
    private_audio_not_found:
      'Δεν έχετε ανεβάσει κάποιο ηχητικό αρχείο μέχρι τώρα',
    are_you_sure_to_delete: 'Είστε βέβαιοι ότι θέλετε να το διαγράψετε;',
    type_something: 'Πληκτρολογήστε κάτι',
    select_voice: 'Επιλέξτε',
    file_name: 'Όνομα φακέλου',
    description: 'Περιγραφή',
    topic: 'Θέμα',
    key_words_tag: 'Ετικέτα Λέξεις Κλειδιά',
    mp3_audio: 'MP3 Ήχος',
    created: 'Δημιουργήθηκε',
    duration: 'Διάρκεια',
    close: 'κλείσιμο'
  },

  image: {
    modal_title: 'Εισαγωγή εικόνας',
    image: 'Εικόνα',
    pixel: 'Πίξελ',
    dimension: 'Διάσταση',
    public_image_not_found: 'Η εικόνα δε βρέθηκε.',
    private_image_not_found: 'Δεν έχετε ανεβάσει εικόνα μέχρι τώρα'
  },

  annotation: {
    modal_title: 'Σχόλιο'
  },

  text: {
    modal_title: 'Επεξεργαστής Κειμένου'
  },

  video: {
    modal_title: 'Εισαγωγή Βίντεο',
    image: 'Βίντεο',
    mp4_video: 'MP4 Βίντεο',
    public_video_not_found: 'Το Βίντεο δε βρέθηκε.',
    private_video_not_found: 'Δεν έχετε ανεβάσει κάποιο βίντεο ακόμη'
  },

  media: {
    title: 'Βιβλιοθήκη Ηλεκτρονικών Μέσων',
    subtitle: 'Βιβλιοθήκη των αρχείων σας',
    modal_title: 'Μεταφόρτωση ηλεκτρονικών μέσων',
    delete_warning: 'Επιβεβαίωση διαγραφής',
    delete_message:
      'Τα διαγραμμένα ηλεκτρονικά μέσα θα συνεχίζουν να εμφανίζονται στις σελίδες που χρησιμοποιούνταν',
    dropzone_text: 'ή Σύρετε ή Αφήστε',
    delete_success: 'Το ηλεκτρονικό μέσο διαγράφηκε με επιτυχία',
    upload_file: 'Μεταφόρτωση αρχείου',
    drag_drop: 'ή Σύρετε και Αφήστε',
    import_file: 'Εισαγωγή αρχείου(ων) από τον υπολογιστή σας',
    no_media: 'Δεν έχετε ανεβάσει κάποιο ηλεκτρονικό μέσο προς το παρόν',
    media_type: 'Τύπος ηλεκτρονικού μέσου',
    video: 'Βίντεο',
    image: 'Εικόνα',
    audio: 'Ήχος',
    gif: 'GIF',
    transcribed_text: 'Transcribed Text',
    media_not_found: 'Το ηλεκτρονικό μέσο δε βρέθηκε.',
    of: 'του',
    disclaimer: `Εγγυώμαι ότι το ηλεκτρονικό μέσο μου δεν:
    - καταπατά τα δικαιώματα οποιουδήποτε τρίτου μέρους
  - περιέχει οποιαδήποτε παρανομία, συμπεριλαμβανομένου δυσφημιστικού, άσεμνου, πορνογραφικό, βίαιο, καταχρηστικό, προσβλητικό, απειλητικό ή ρατσιστικό περιεχόμενο, ακόμη και σημειωμένο με αστερίσκους
  - περιέχει οποιεσδήποτε προσωπικές ατάκες σε άλλα άτομα
  - περιέχει οποιαδήποτε μίμηση με άλλους συμμετέχοντες, δημόσια πρόσωπα ή διάσημους
  - περιέχει οποιαδήποτε καταγραμμένη ή προσωπική πληροφορία οποιουδήποτε ιδιώτη χωρίς τη συγκατάθεση του και δεν παραβιάζει κανέναν κανονισμό προστασίας δεδομένων σε οποιοδήποτε μέρος του κόσμου
  -περιέχει οποιαδήποτε εμπορική προσέλκυση ή οποιαδήποτε μορφή "ανεπιθύμητου" περιεχομένου`,
    my_media: 'τα Μέσα Κοινωνικής Δικτύωσης μου',
    public_library: 'Δημόσια Βιβλιοθήκη',
    organization_library: 'Βιβλιοθήκη Οργανισμού',
    upload_from_computer: 'Ανεβάστε από τον Υπολογιστή',
    create: 'Δημιουργία',
    all: 'Όλα',
    male: 'Άνδρας',
    female: 'Γυναίκα',
    processing_audio: 'Επεξεργασία Ήχου',
    create_annotation: 'Δημιουργία Σχολίου',
    popup_over_lesson_text:
      'Το σχόλιο θα εμφανιστεί στη σελίδα του μαθήματος μετά το κλικ',
    edit_detail: 'Επεξεργασία Λεπτομερειών',
    delete: 'Διαγραφή',
    go_create_audio: 'Δημιουργία Ήχου',
    show_more_details: 'εμφάνιση περισσότερων λεπτομερειών',
    show_less_details: 'εμφάνιση λιγότερων λεπτομερειών',
    drop_files: 'Σύρετε φακέλους εδώ για να ανεβάσετε',
    or: 'Ή',
    import_files: 'Εισαγωγή αρχείων από τον υπολογιστή'
  },

  navigation: {
    account: 'Λογαριασμός',
    assessments: 'Αξιολογήσεις',
    dashboard: 'Πίνακας',
    groups: 'Διαχείριση Ομάδας',
    logout: 'Αποσύνδεση',
    organisations: 'Οργανισμοί',
    organizations_users: 'Οργανισμοί & Χρήστες',
    reports: 'Αναφορές',
    schedule: 'Πρόγραμμα',
    training: 'Εκπαίδευση',
    users: 'Χρήστες',
    nowLive: 'αναμετάδοση',
    workshop: 'Το Εργαστήριο Μου'
  },

  onboarding: {
    step1_title: 'Βήμα 1 : Πείτε μας λίγα για τον εαυτό σας.',
    step1_subtitle:
      'Ποιο είναι το όνομα σας; Από πού κατάγεστε; Τι δουλειά κάνετε;',
    step2_title:
      'Βήμα 2 : Επιλέξτε Μερικές Ικανότητες Που Θα Μπορούσατε Να Βελτιώσετε',
    step2_subtitle:
      'Επόμενο, πείτε μας τι θα θέλατε να κατανοήσετε καλύτερα. Ίσως κάτι που έχετε καιρό να ασχοληθείτε; Ένας νέος τομέας σπουδών; Με τι ασχολείται ο αγαπημένος σας;'
  },

  pagebuilder: {
    title: 'Δημιουργία Μαθήματος',
    subtitle:
      'Ήρθε η ώρα να δημιουργήσετε το περιεχόμενο για το κοινό σας για να μάθει από εσάς, μπορείτε να προσθέσετε εικόνες, βίντεο και γραφήματα',
    select_layout: 'Επιλέξτε μία Διάταξη Σελίδας',
    template1: 'Κενό',
    template2: 'Τίτλος & Υπότιτλος',
    template3: 'Τίτλος & Κείμενο',
    template4: 'Τίτλος, Ηλεκτρονικά Μέσα & Κείμενο',
    template5: 'Τίτλος & Ηλεκτρονικά Μέσα',
    template6: 'Τίτλος & Κουίζ'
  },

  pageconstructor: {
    title: 'Δημιουργία και Καταγραφή Μαθήματος',
    subtitle:
      'Ήρθε η ώρα να δημιουργήσετε το περιεχόμενο για το κοινό σας για να μάθει από εσάς, μπορείτε να προσθέσετε εικόνες, βίντεο και γραφήματα'
  },

  passwordreset: {
    success_coded:
      'Σας έχουμε στείλει ένα κωδικό επιβεβαίωσης στην διεύθυνση ηλεκτρονικού ταχυδρομείου που μας δώσατε, παρακαλούμε αντιγράψτε αυτό τον κωδικό στο πεδίο κάτω από τον ορισμό νέου κωδικού πρόσβασης.',
    success_changed:
      'Έχετε ορίσει νέο κωδικό πρόσβασης επιτυχώς. Μπορείτε να συνδεθείτε τώρα.'
  },

  placeholders: {
    search: 'Αναζήτηση',
    answer: 'Απάντηση',
    chat: 'Πείτε κάτι...',
    code: 'Κωδικός',
    criterion: 'Κριτήριο',
    date_event: 'Επιλέξτε ημερομηνία & ώρα',
    date_start: 'Ημερομηνία έναρξης',
    date_expire: 'Ημερομηνίας λήξης',
    description: 'Περιγραφή',
    elements: 'Ταξινόμηση στοιχείων',
    email: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
    feedback_correct: 'Ανατροφοδότηση Σωστή',
    feedback_incorrect: 'Ανατροφοδότηση Λάθος',
    host: 'Οικοδεσπότης',
    keywords: 'Αναζήτηση λέξη(εις) κλειδί(α)',
    lesson_description: 'Περιγραφή μαθήματος',
    location: 'Τοποθεσία',
    minutes: 'Λεπτά',
    name: 'Όνομα',
    organiser: 'Συγγραφέας',
    organization: 'Οργανισμός',
    password: 'Κωδικός Πρόσβασης',
    phone: 'Τηλέφωνο',
    photo: 'Φωτογραφία',
    picture: 'Εικόνα',
    point: 'Σημείο',
    position: 'Θέση',
    question: 'Ερώτηση',
    quiz: 'Όνομα Κουίζ',
    search_course: 'Αναζήτηση μέσω Διάλεξης',
    search_media: 'Αναζήτηση ηλεκτρονικού μέσου',
    search_name: 'Αναζήτηση μέσω Ονόματος',
    search_title: 'Αναζήτηση μέσω Τίτλου',
    search_training: 'Αναζήτηση Εκπαίδευσης',
    settings: 'Ρυθμίσεις',
    tags: 'Ετικέτες',
    title: 'Τίτλος',
    topics: 'Θέματα',
    username: 'Όνομα Χρήστη',
    keyword: 'Λέξεις Κλειδιά',
    max_500_characters: 'Το πολύ 500 Χαρακτήρες ',
    no_description: 'αυτός ο φάκελος δεν έχει περιγραφή',
    no_keyword: 'αυτός ο φάκελος δεν έχει λέξεις κλειδιά',
    no_topics: 'αυτός ο φάκελος δεν έχει καθορισμένο θέμα',
    feedback: 'Μήνυμα',
    contact: 'Πως μπορώ να βοηθήσω;'
  },

  publishsettings: {
    title: 'Δημοσίευση Ρυθμίσεων',
    event_subtitle:
      'Προσθήκη ρυθμίσεων στο δρώμενο σας, ποιος μπορεί να παρακολουθήσει και να αλληλεπιδράσει στο δρώμενο σας.',
    assessment_subtitile:
      'Ονομάστε την Αξιολόγηση σας και πείτε στο κοινό σας τι θα πρέπει να αναμένει ότι θα μάθει από αυτή.',
    course_subtitle:
      'Προσθήκη ρυθμίσεων στη διάλεξη σας, ποιος μπορεί να παρακολουθήσει και να αλληλεπιδράσει σε αυτή τη διάλεξη',
    disclaimer: `1.	Εγγραφή

  Κάνοντας εγγραφή ως χρήστης/ δημιουργώντας ένα λογαριασμό συμφωνείτε με τη [Συμφωνία Χρήστη] και γνωστοποιείτε την ανάγνωση της [Πολιτική Απορρήτου] μας

  2.	Δημιουργία διάλεξης

  Χρησιμοποιώντας τα εργαλεία σας και δημιουργώντας το περιεχόμενο της διάλεξης, συμφωνείτε με τη [Συμφωνία Χρήστη] και γνωστοποιείτε την ανάγνωση της [Πολιτική Απορρήτου] μας

  3.	Δημιουργία δρώμενου

  Χρησιμοποιώντας τα εργαλεία μας και δημιουργώντας ένα δρώμενο, συμφωνείτε με τη [Συμφωνία Χρήστη] μας και γνωστοποιείτε την ανάγνωση της [Πολιτική Απορρήτου] μας


  4.	Δημιουργία αξιολόγησης

  Χρησιμοποιώντας τα εργαλεία μας και δημιουργώντας ένα δρώμενο, συμφωνείτε με τη [Συμφωνία Χρήστη] μας και γνωστοποιείτε την ανάγνωση της [Πολιτική Απορρήτου] μας`,
    dates_validation_error: 'Πρέπει να συμπληρωθούν και οι δύο ημερομηνίες.',
    course_dates_validation_error: 'Εισαγάγετε την ημερομηνία έναρξης και λήξης αυτού του μαθήματος.',
    emails_validation_error:
      'Η λίστα διευθύνσεων ηλεκτρονικού ταχυδρομείου δεν είναι έγκυρες.',
    specific_email_validation_error:
      'Μόνο μία διεύθυνση ηλεκτρονικού ταχυδρομείου είναι επιτρεπτή.',
    i_agree_to_these: 'Συμφωνώ με αυτά ',
    terms_and_conditions: 'όροι και προϋποθέσεις.',
    PublicDescription: `Δωρεάν ανεξάρτητοι χρήστες: (ιδιωτικές και δημόσιες επιλογές) Η [Διάλεξη | Δρώμενο | Αξιολόγηση] έχει αποθηκευτεί και θεωρείται Ιδιωτική από προεπιλογή. Αυτό σημαίνει ότι μόνο εσείς μπορείτε να δείτε αυτό το περιεχόμενο. Για να δημοσιεύσετε αυτό το περιεχόμενο, μπορείτε να επιλέξετε να το κάνετε δημόσιο παρακάτω. Αυτό σημαίνει ότι η διάλεξη θα είναι διαθέσιμη σε όλους τους χρήστες της πλατφόρμας.`,
    OrganisationsDescription:
      'Χρήστες οργανισμού: (Αντί για "" Τέλος "" χρησιμοποιήστε "" Δημοσίευση "" και μεταφέρετέ τους στη σελίδα δημοσίευσης όπως άλλους χρήστες, αλλά χωρίς καμία από τις επιλογές δημοσίευσης.) Η [Διάλεξη | Δρώμενο | Αξιολόγηση] έχει αποθηκευτεί και είναι ιδιωτική. Αυτό σημαίνει ότι μόνο εσείς και οι Διαχειριστές στον οργανισμό μπορείτε να το δείτε. Ως χρήστης, δεν μπορείτε να δημοσιεύσετε το περιεχόμενό σας μόνοι σας στον οργανισμό, καθώς αυτό απαιτεί δικαιώματα διαχειριστή. Παρακαλούμε επικοινωνήστε με έναν από τους διαχειριστές και ζητήστε του να δημοσιεύσει το περιεχόμενό σας δημόσια, σε ολόκληρο τον οργανισμό, σε συγκεκριμένες ομάδες εντός του οργανισμού σας ή σε συγκεκριμένους χρήστες.',
    OrganisationGroupsDescription:
      'Διαχειριστές οργανισμού: (Για περιεχόμενο που δημιουργείται εντός του οργανισμού: Ιδιωτικός, δημόσιος, οργανισμός, ομάδες, συγκεκριμένοι χρήστες): Αυτή η [Διάλεξη | Δρώμενο | Αξιολόγηση] έχει αποθηκευτεί και θεωρείται απόρρητη από προεπιλογή. Αυτό σημαίνει ότι μόνο εσείς (και ο δημιουργός περιεχομένου) μπορείτε να δείτε αυτό το περιεχόμενο. Για να δημοσιεύσετε αυτό το περιεχόμενο, μπορείτε να ορίσετε μία από τις παρακάτω επιλογές. Η δημοσίευση της διάλεξης σας σημαίνει ότι θα είναι διαθέσιμη σε όλους τους χρήστες της πλατφόρμας - συμπεριλαμβανομένων εκείνων που δεν ανήκουν στον οργανισμό σας. Η δημοσίευσή στον οργανισμό σημαίνει ότι όλοι οι χρήστες του οργανισμού θα μπορούν να τη δουν. Μπορείτε επίσης να τη δημοσιεύσετε σε 1 ή περισσότερες ομάδες, κάτι που σημαίνει ότι μόνο οι χρήστες σε αυτές τις ομάδες θα μπορούν να τη δουν. Τέλος, έχετε την επιλογή να τη δημοσιεύσετε σε συγκεκριμένους χρήστες εντός και εκτός του οργανισμού σας χρησιμοποιώντας τη διεύθυνση ηλεκτρονικού ταχυδρομείου του λογαριασμού Sharelook.',
    SpecificUsersDescription:
      'Ανεξάρτητοι χρήστες επί πληρωμή: (ιδιωτικοί, δημόσιοι και συγκεκριμένοι χρήστες) Η [Διάλεξη | Δρώμενο | Αξιολόγηση] έχει αποθηκευτεί και θεωρείται απόρρητη από προεπιλογή. Αυτό σημαίνει ότι μόνο εσείς μπορείτε να δείτε αυτό το περιεχόμενο. Για να δημοσιεύσετε αυτό το περιεχόμενο, μπορείτε να επιλέξετε μία από τις παρακάτω επιλογές. Η δημοσίευση της διάλεξης σας σημαίνει ότι θα είναι διαθέσιμη σε όλους τους χρήστες της πλατφόρμας. Η επιλογή συγκεκριμένων χρηστών θα σας επιτρέψει να μοιραστείτε τη διάλεξη  με συγκεκριμένους χρήστες χρησιμοποιώντας τη διεύθυνση ηλεκτρονικού ταχυδρομείου που σχετίζεται με τον λογαριασμό τους στο Sharelook.'
  },

  quiz: {
    quiz_empty: 'Δεν έχετε δημιουργήσει ακόμη ένα κουίζ',
    questions_empty: 'Δεν έχετε δημιουργήσει ακόμη ερώτηση'
  },

  regions: {
    asia_pacific_australia: 'Αυστραλία',
    asia_pacific_india: 'Ινδία',
    asia_pacific_japan: 'Ιαπωνία',
    asia_pacific_s_korea: 'Νότια Κορέα',
    asia_pacific_singapore: 'Σιγκαπούρη',
    asia_pacific_taiwan: 'Ταιβάν',
    eu_belgium: 'Βέλγιο',
    eu_germany: 'Γερμανία',
    eu_ireland: 'Ιρλανδία',
    south_america_brazil: 'Βραζιλία',
    us_central_iowa: 'Iowa',
    us_east_s_carolina: 'Νότια Καρολίνα',
    us_east_virginia: 'Βιρτζίνια',
    us_west_california: 'Καλιφόρνια',
    us_west_oregon: 'Όρεγκον'
  },

  reports: {
    title: 'Αναφορές',
    workshop_report: 'Αναφορά Εργαστηρίου',
    user_report: 'Αναφορά Χρήστη',
    organization_workshop: 'Οργάνωση εργαστηρίου',
    course: 'Διάλεξη',
    live_event: 'Ζωντανό δρώμενο',
    workShop_graph: 'Γράφημα Εργαστηρίου',
    organization_account: 'Λογαριασμός Οργανισμού',
    all: 'Όλα',
    name: 'Όνομα',
    id_number: 'Αριθμός Α.Δ.Τ.',
    email: 'Διεύθυνση ηλεκτρονικού ταχυδρομείου',
    search_user_report: 'Αναζήτηση Αναφοράς Χρήστη',
    participant: 'Συμμετέχων',
    participants: 'Συμμετέχοντες',
    host: 'Οικοδεσπότης',
    username: 'Όνομα Χρήστη',
    event: 'Δρώμενο',
    quiz: 'Κουίζ',
    assessment: 'Αξιολόγηση',
    time: 'Ώρα',
    no_recent_activity: 'Καμία Πρόσφατη Δραστηριότητα',
    workshops: 'Εργαστήρια',
    courses: 'Διαλέξεις',
    live_events: 'Ζωντανά Δρώμενα',
    live_assessments: 'Ζωντανές Αξιολογήσεις',
    quizzes: 'Κουίζ',
    overview: 'Σύνοψη',
    by: 'Από',
    views: 'Προβολές',
    status: 'Κατάσταση',
    poll: 'Ψηφοφορία',
    comment: 'Σχόλιο',
    comments: 'Σχόλια',
    no_comments: 'Κανένα Σχόλιο',
    no_polls: 'Καμία Ψηφοφορία',
    live_date: 'Ημερομηνία Ζωντανής Μετάδοσης',
    score: 'Βαθμολογία',
    question: 'Ερώτηση',
    submit: 'Υποβολή',
    recent_activity: 'Πρόσφατη δραστηριότητα',
    ago: 'Πριν',
    no_data_found: 'Δεν βρέθηκαν δεδομένα',
    start_end_live: 'Έναρξη/Τερματισμός Ζωντανής Μετάδοσης',
    join_leave_date: 'Συμμετοχή/Αποχώρηση',
    watched_time: 'Ώρα Προβολής',
    complete: 'Ολοκλήρωση',
    in_complete: 'Σε Ολοκλήρωση',
    today: 'Σήμερα',
    seven_days: '7 Ημέρες',
    last_month: 'Τρέχον Μήνας',
    one_year: '1 Χρόνος',
    all_time: 'Πάντα',
    report: 'Αναφορά',
    from_date: 'Από Ημερομηνία',
    to_date: 'Έως Ημερομηνία',
    all_workshop: 'Όλα τα Εργαστήρια',
    all_participants: 'Όλοι οι Συμμετέχοντες',
    live_assessment: 'Ζωντανή Αξιολόγηση',
    users: 'Χρήστες',
    download: 'Κατεβάστε',
    recent: 'Πρόσφατα',
    WorkShop: 'Εργαστήριο',
    Activity: 'Δραστηριότητα',
    created_date: 'Ημερομηνία δημιουργίας',
    lessons: 'Μαθήματα',
    lesson: 'Μάθημα',
    completed: 'Ολοκληρωμένο',
    report_download: 'Κατέβασμα Αναφοράς',
    this_month: 'Αυτό το μήνα',
    search_course: 'Αναζήτηση Διάλεξης',
    participants_graph: 'Γράφημα Συμμετεχόντων',
    viewed: 'Προβλήθηκε',
    enrolled: 'Εγγεγραμμένος',
    description: 'Περιγραφή',
    topic: 'Θέμα',
    analytic: 'Αναλυτικό',
    quiz_list: 'Λίστα Κουίζ',
    select_one: 'Επιλέξτε Ένα',
    group_status: 'Κατάσταση Ομάδας',
    duration_min: 'Διάρκεια(λεπτά)',
    submit_poll: 'Υποβολή Ψηφοφορίας',
    download_events: 'Κατεβάστε τα Δρώμενα',
    search_event: 'Αναζήτηση δρώμενου',
    duration: 'Διάρκεια',
    total_participants: 'Συνολικοί Συμμετέχοντες',
    message: 'Μήνυμα',
    avg_message: 'Μέσο Μήνυμα'
  },

  signup: {
    success_step1:
      'Σας έχουμε στείλει ένα κωδικό επιβεβαίωσης στην διεύθυνση ηλεκτρονικού ταχυδρομείου που μας δώσατε, παρακαλούμε αντιγράψτε αυτό τον κωδικό στο πεδίο κάτω από τον ορισμό νέου κωδικού πρόσβασης.',
    success_step2: 'Ευχαριστούμε. Έχετε εγγραφεί επιτυχώς.',
    privacy: `Συμφωνώ με τους <1> όρους & προϋποθέσεις του Sharelook</1> και <3> πολιτική απορρήτου</3>`
  },

  stream: {
    emotion_impressive: 'Εντυπωσιακό',
    emotion_unimpressive: 'Αδιάφορο',
    message_not_started: 'Έρχεται σύντομα',
    message_running: 'Ζωντανά',
    message_processing:
      'Αυτή τη στιγμή εκτελούμε τη διαδικασία της ζωντανής καταγραφής. Παρακαλούμε ελέγξτε αργότερα για να προβάλετε το βίντεο και να συνεχίσετε να προσθέσετε βαθμολογία και ανατροφοδότηση'
  },

  tabs: {
    audience: 'Κοινό',
    course: 'Σύνοψη Διάλεξης',
    details: 'Λεπτομέρειες Ζωντανού Δρώμενου',
    description: 'Περιγραφή',
    host: 'Οικοδεσπότης',
    lesson: 'Σύνοψη Μαθήματος',
    lessons: 'Μαθήματα',
    overview: 'Σύνοψη',
    page: 'Δημιουργός Σελίδας',
    publish: 'Δημοσίευση',
    settings: 'Δημοσίευση Ρυθμίσεων',
    total_views: 'Συνολικές Προβολές',
    live_participates: 'Ζωντανά Συμμετέχοντες',
    live_chats: 'Ζωντανές Συνομιλίες',
    live_quiz: 'Ζωντανές Ψηφοφορίες',
    trainer_rating: 'Βαθμολογία Εκπαιδευτή',
    trainer_times: 'Ώρες Εκπαίδευσης',
    courses_quizzes: 'Κουίζ Διαλέξεις',
    user_list: 'Λίστα Χρηστών',
    discussion: 'Συζήτηση',
    notes: 'Οι Σημειώσεις μου'
  },

  topics: {
    SALES_TRAINING: 'Εκπαίδευση Πωλήσεων',
    NEGOTIATION_TRAINING: 'Εκπαίδευση Διαπραγμάτευσης',
    CROSS_CULTURAL_AWARENESS: 'Διαπολιτισμική ευαισθητοποίηση',
    NETWORKING_SKILLS: 'Ικανότητες ιντερνετικής δικτύωσης',
    SOFTWARE_ARCHITECTURE: 'Ανάπτυξη Λογισμικού',
    PROJECT_MANAGEMENT: 'Διαχείριση Έργων',
    DIGITAL_TRANSFORMATION: 'Ψηφιακή Αναδιαμόρφωση',
    IT_CONSULTING: 'Συμβουλευτική Πληροφορικής',
    MANAGEMENT_CONSULTING: 'Management Consulting',
    HR_CONSULTING: 'Συμβουλευτική Ανθρωπίνου Δυναμικού',
    INTERNET_OF_THINGS: 'To Διαδίκτυο των Πραγμάτων(IoT)',
    CYBERSECURITY: 'Κυβερνασφάλεια',
    PRIVACY_AND_GDRP: 'Απόρρητο και GDPR'
  },

  training: {
    title: 'Εκπαίδευση',
    title_assessment: 'Αξιολογήσεις',
    subtitle: 'Διαλέξεις και Ζωντανά Δρώμενα',
    enrolled_title: 'Εγγεγραμμένες Διαλέξεις και Ζωντανά Δρώμενα',
    enrolled_subtitle: 'Διαλέξεις και Ζωντανά Δρώμενα στα οποία εγγραφήκατε',
    enrolled_message:
      'Δεν είστε προς το παρόν εγγεγραμμένοι σε κάποια διάλεξη και δρώμενο.',
    past_live_event_title: 'Προηγούμενα Ζωντανά Δρώμενα',
    past_live_event_subTitle: 'Ολοκληρωμένα Ζωντανά Δρώμενα',
    past_live_event: 'Δεν υπάρχουν προς το παρόν προηγούμενα ζωντανά δρώμενα.',
    recomended_title: 'Προτεινόμενες Διαλέξεις και Ζωντανά Δρώμενα',
    now_live_event_title: 'Ζωντανά Τώρα',
    now_live_event_subTitle: 'Events that are live or will be very soon',
    now_live_event: 'Δεν υπάρχει προς το παρόν ζωντανό δρώμενο.',
    webinar_event_title: 'Κανάλι Διαδικτυακών Σεμιναρίων',
    webinar_event_subTitle: 'Ολοκληρωμένα Διαδικτυακά Σεμινάρια',
    webinar_event: 'Δεν υπάρχουν προς το παρόν διαδικτυακά σεμινάρια.',
    p2p_event_title: 'Εκπαίδευση',
    p2p_event_subTitle: 'Ολοκληρωμένες Εκπαιδεύσεις',
    p2p_event: 'Δεν υπάρχει προς το παρόν εκπαίδευση.',

    now_live_assessment_title: 'Ζωντανά Τώρα',
    now_live_assessment_subTitle:
      'AΑξιολογήσεις που είναι ζωντανές ή θα είναι πολύ σύντομα',
    now_live_assessment_message: 'Δεν υπάρχει τώρα ζωντανή αξιολόγηση.',

    upcoming_assessment_title: 'Ανερχόμενες Ζωντανές Αξιολογήσεις',
    upcoming_assessment_subtitle: 'Ανερχόμενες Ζωντανές Αξιολογήσεις',
    upcoming_assessment_message:
      'Δεν υπάρχει προς το παρόν επερχόμενη ζωντανή αξιολόγηση.',

    past_live_assessment_title: 'Προηγούμενες Ζωντανές Αξιολογήσεις',
    past_live_assessment_subTitle: 'Ολοκληρωμένες Ζωντανές Αξιολογήσεις',
    past_live_assessment_message:
      'Δεν υπάρχουν προς το παρόν προηγούμενες ζωντανές αξιολογήσεις.',

    /**
     * <0/> get index 0 of data from Trans component
     * exp -->
     * <Trans i18nKey='training:recomended_subtitle' >
     *    <Navlink>{...something}</Navlink> --> is index 0 of Trans component
     *    <h1>{...something}</h1> --> is index 1 of Trans component
     * </Trans>
     */
    recomended_subtitle:
      'Έχουμε προτείνει δρώμενα και ζωντανά δρώμενα βάσει <0><0/></0>',
    /**
     * and we also can get data from index to replace in recommended_subtitle by like above string.
     * for exp -->
     * at the end of the recomended_subtitle above will get data from index of component to display
     * <0><0/></0> mean get data index 0 of Trans component above = <Navlink> and <0/> get data index 0 from <Navlink> = {...something}
     */
    search: 'Αναζήτηση Εκπαίδευσης',
    search_assessment: 'Αναζήτηση Αξιολόγησης',
    recomended_message:
      'Δεν υπάρχουν προς το παρόν προτεινόμενες διαλέξεις και δρώμενα.'
  },

  warnings: {
    delete: 'Είστε σίγουροι;'
  },

  workshop: {
    title: 'Το Εργαστήριο μου',
    subtitle: 'Δημιουργία δρώμενου ή φιλοξενία ενός ζωντανού δρώμενος',
    new_course: 'Δημιουργία νέας διάλεξης',
    new_event: 'Δημιουργία νέου ζωντανού δρώμενος',
    new_assessment: 'Δημιουργία νέας ζωντανής αξιολόγησης',
    courses_title: 'Created Courses & Live Events',
    courses_subtitle:
      'Επεξεργασία & Δημοσίευση των διαλέξεων που έχετε δημιουργήσει και σχεδιάστε ζωντανά δρώμενα',
    tags_course: 'Διάλεξη',
    tags_live: 'Ζωντανό Δρώμενο',
    tags_assessment: 'Ζωντανή Αξιολόγηση'
  },

  help_center: {
    sidebar: {
      title: 'Πως μπορούμε να βοηθήσουμε;',
      back_to: 'Πίνακας'
    },
    menu: {
      help_center: 'Κέντρο Βοήθειας',
      whats_new: 'Τι νέο υπάρχει',
      feedback: 'Ανατροφοδότηση',
      feedback_title: 'Αποστολή ανατροφοδότησης στο sharelook',
      terms_and_conditions: 'Όροι & Προϋποθέσεις',
      privacy_policy: 'Πολιτική Απορρήτου',
      contact_us: 'Επικοινωνήστε μαζί μας'
    },
    get_started: {
      title: 'Ξεκινήστε με το share look',
      description: {
        main:
          'ΈΧΟΥΜΕ ΟΛΟΚΛΗΡΩΣΕΙ ΕΝΑ LIVE VIDEO ΓΙΑ ΜΙΑ ΕΥΚΟΛΗ-ΓΙΑ-ΧΡΗΣΗ ΔΗΜΙΟΥΡΓΙΑ ΔΙΑΛΕΞΗΣ',
        tagline:
          'Με το πατενταρισμένο σύστημα ζωντανής μετάδοσης του ShareLook, μπορείτε να δημιουργήσετε αφοσίωση, αυτόματη εκμάθηση και να μεγιστοποιήσετε την κοινή χρήση γνώσεων.'
      }
    },
    whats_new: {
      title: 'Ξεκινήστε με το share look',
      description: {
        main:
          'Γνωρίζατε ότι η δημιουργία εκμάθησης στυλ αφήγησης μπορεί να δημιουργηθεί σε σύντομο χρόνο και όχι τόσο ακριβά; Θα πρέπει να συνδυάσετε το πρόγραμμα δημιουργίας μαθημάτων ShareLook και αντίστοιχα ταλέντα. Μπορείτε να μας ρωτήσετε "ΠΩΣ"',
        tagline: ''
      }
    },
    create_workshop: 'Πώς να δημιουργήσετε ένα Εργαστήριο',
    create_course: 'Πώς να δημιουργήσετε μία Διάλεξη',
    create_user: 'Πώς να δημιουργήσετε ένα Χρήστη',
    create_group: 'Πώς να δημιουργήσετε μία Ομάδα',
    create_webinar: 'Πως να δημιουργήσετε ένα διαδικτυακό σεμινάριο',
    create_live_event: 'Πως να δημιουργήσετε ένα Ζωντανό Δρώμενο',
    create_live_assessment: 'Πως να δημιουργήσετε Ζωντανή Αξιολόγηση',
    create_live_on_mobile: 'Δημιουργία Ζωντανά στο Κινητό',
    personalize_profile: 'Κάντε πιο προσωπικό ένα προφίλ',
    manage_group: 'Διαχείριση ομάδας',
    report: 'Αναφορά',
    add_annotations: 'Πως Να προσθέσετε Σχόλια/Αναδυόμενα',
    add_audio: 'Πώς να Προσθέσετε Ήχο',
    add_header_and_footer: 'Adding Header & Footer',
    add_image: 'Πώς να Προσθέσετε Εικόνα',
    add_quiz_content: 'Πώς να προσθέσετε Περιεχόμενο Κουίζ',
    add_text_content: 'Πως να Προσθέσετε Περιεχόμενο Κειμένου',
    add_user: 'Πως να Προσθέσετε Χρήστη',
    add_video: 'Πως να Προσθέσετε Βίντεο',
    clone_course: 'Πως να Αντιγράψετε τη Διάλεξη',
    find_live_broadcast: 'Πώς να Βρείτε τη Ζωντανή Αξιολόγηση',
    contact_us: {
      title: 'Επικοινωνήστε μαζί μας',
      subject_placeholder: 'Εισάγετε ένα θέμα*',
      content_placeholder: 'Εισάγετε ένα μήνυμα*',
      subject_required: '*Απαιτείται θέμα',
      content_required: '*Απαιτείται μήνυμα',
      submit: 'Αποστολή',
      cancel: 'Ακύρωση',
      sent: 'Απεστάλη'
    },
    feedback: {
      title: 'Αποστολή ανατροφοδότησης στο sharelook',
      attach_title: 'Επισύναψη αρχείου',
      choose: 'Επιλέξτε αρχείο',
      detail: 'Το αρχείο θα κοινοποιηθεί με την ομάδα υποστήριξης',
      content_placeholder: 'Εισαγωγή μηνύματος*',
      content_required: '*Απαιτείται μήνυμα',
      submit: 'Αποστολή',
      cancel: 'Ακύρωση',
      sent: 'Απεστάλη'
    }
  },
  discussion: {
    join_discussion: 'Συμμετέχετε στη συζήτηση'
  },
  notes: {
    title: 'Οι Σημειώσεις μου',
    add_note: 'Προσθήκη νέας σημείωσης'
  }
}
